/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-modele.js (chargé par snippets/cp-decor-data.liquid)
   MODÈLE UNIQUE plan_v1 + CONTRÔLES + EMPREINTE + VUE RÉELLE
   1. buildPlan : l'état du configurateur -> un plan en millimètres
      (pièces = contours de points, origine = coin arrière gauche,
      x vers la droite, y vers l'avant). Chaque nombre dit d'où il vient.
      forme en L : géométrie tracée par points avec le VRAI angle (85–95°)
        et la vraie jonction (retour filant / plan filant / onglet 45°) ;
      droit, U, G : pièces relevées dans le dessin du moteur (rectangles).
   2. Contrôles (propriétés, pas des pixels) ; un contrôle bloquant en échec
      refuse l'ajout au panier avec le motif.
   3. Commande : _cfg_model (JSON canonique), _cfg_hash (SHA-256 du JSON),
      « Réf. plan » (12 premiers caractères, visible par le client).
   4. Vue réelle (forme en L) : le plan dessiné point par point, décor à
      l'échelle, fil le long de la plus longue arête de chaque pièce.
   Le moteur (configurator-main.js) n'est pas modifié.
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  /* ── Données de gamme et d'atelier. Sources :
     longueur_max_mm 4180 = tarif v1.22, « Dimension maximale L 418 » (sûr) ;
     angles 85 à 95° = décision Creapanel, (sûr) ──*/
  var GAMME = {
    longueur_max_mm: { valeur: 4180 },
    angle_min_deg:   { valeur: 85 },
    angle_max_deg:   { valeur: 95 }
  };
  var EPS = 1e-6;
  /* nom de chaque angle d'un U ou d'un G (commande, contrôles) */
  var NOMS_ANGLES = { gauche: 'coin gauche', droite: 'coin droit', haut_gauche: 'coin haut gauche', haut_droit: 'coin haut droit', retour: 'coin du retour' };
  /* A2 du lot « messages 1 » (COMMERCIAL, AUDIT Tour 597) : contrôles internes, que le client ne peut pas corriger ; en échec,
     ce message seul (garde du panier), le motif gardé dans « detail » pour l'outil */
  var MSG_INTERNE = 'Ce plan ne peut pas être commandé en ligne pour l\'instant. Écrivez-nous.';
  var INTERNES = /^(variante_finition|jonction_portee|mur_retour|chants_sur_aretes|prix_usinages|usinages_pieces|jambages_modele|pieces_sans_chevauchement|surface_dessin|contour_.+|prix_coherent|pieces_composition)$/;
  window.CP_MSG_INTERNE = MSG_INTERNE;
  function ouListe(l) { return l.length > 1 ? l.slice(0, -1).join(', ') + ' ou ' + l[l.length - 1] : String(l[0]); }   /* « 19 ou 38 », comme cp-gamme */

  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  function decor() { return (typeof window.CP_decorFull === 'function') ? window.CP_decorFull() : null; }
  /* référence interne de la VARIANTE choisie (un décor peut en avoir plusieurs : profondeurs, épaisseurs ; CP_DECORS les
     regroupe par nom, d.ref est celle de la 1re) ; null si inconnue */
  function refVariante(d, v) {
    var e = d && window.CP_DECORS && window.CP_DECORS[d.name], r = e && e.refs && v && v.id != null ? e.refs[v.id] : null;
    return r || null;
  }
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }
  function r2(v) { return Math.round(v * 100) / 100; }
  function len(a, b) { return Math.hypot(b[0] - a[0], b[1] - a[1]); }
  function area(p) { return Math.abs(p.reduce(function (s, a, i) { var b = p[(i + 1) % p.length]; return s + a[0] * b[1] - b[0] * a[1]; }, 0)) / 2; }
  function segInter(a, b, c, d) {
    var r = (b[0] - a[0]) * (d[1] - c[1]) - (b[1] - a[1]) * (d[0] - c[0]); if (!r) return false;
    var t = ((c[0] - a[0]) * (d[1] - c[1]) - (c[1] - a[1]) * (d[0] - c[0])) / r;
    var u = ((c[0] - a[0]) * (b[1] - a[1]) - (c[1] - a[1]) * (b[0] - a[0])) / r;
    return t > 1e-9 && t < 1 - 1e-9 && u > 1e-9 && u < 1 - 1e-9;
  }
  function simple(p) {
    var n = p.length;
    for (var i = 0; i < n; i++) for (var j = i + 2; j < n; j++) {
      if (i === 0 && j === n - 1) continue;
      if (segInter(p[i], p[(i + 1) % n], p[j], p[(j + 1) % n])) return false;
    }
    return true;
  }
  function onBoundary(p, q) {
    return p.some(function (a, i) { var b = p[(i + 1) % p.length]; return Math.abs(len(a, q) + len(q, b) - len(a, b)) < EPS; });
  }
  /* plus longue arête : longueur et direction (degrés), pour la plaque et le fil */
  function longest(p) {
    var best = { l: 0, deg: 0 };
    p.forEach(function (a, i) {
      var b = p[(i + 1) % p.length], l = len(a, b);
      if (l > best.l + EPS) best = { l: l, deg: Math.atan2(b[1] - a[1], b[0] - a[0]) * 180 / Math.PI };
    });
    best.deg = ((best.deg % 180) + 180) % 180;             /* un fil n'a pas de sens : 0–180° */
    return best;
  }

  /* ── 1a. Forme en L, tracée par points (méthode du prototype, 84 cas testés) ──
     jn : 'retour' (le retour va au mur = moteur 'flush'),
          'barre'  (le plan principal va au mur = moteur 'overlap'),
          'onglet' (coupe de l'angle extérieur à l'angle intérieur). */
  function geomAngle(s) {
    var d = (s.ang - 90) * Math.PI / 180;
    var dir = [Math.sin(d), Math.cos(d)], nrm = [-Math.cos(d), Math.sin(d)];
    var C = [s.L1, 0];
    var onOuter = function (t) { return [C[0] + t * dir[0], C[1] + t * dir[1]]; };
    var onInner = function (t) { return [C[0] + t * dir[0] + s.P2 * nrm[0], C[1] + t * dir[1] + s.P2 * nrm[1]]; };
    var outerAtY = function (y) { return onOuter(y / dir[1]); };
    var innerAtY = function (y) { return onInner((y - s.P2 * nrm[1]) / dir[1]); };
    var Lw = s.P1 + s.L2, O2 = onOuter(Lw), I2 = onInner(Lw);
    var barre, retour, seam, I1, O1, I0;
    if (s.jn === 'barre') {
      O1 = outerAtY(s.P1); I1 = innerAtY(s.P1);
      barre = [[0, 0], C, O1, [0, s.P1]]; retour = [O1, O2, I2, I1]; seam = [I1, O1];
    } else if (s.jn === 'onglet') {
      I1 = innerAtY(s.P1);
      barre = [[0, 0], C, I1, [0, s.P1]]; retour = [C, O2, I2, I1]; seam = [C, I1];
    } else {
      I0 = innerAtY(0); I1 = innerAtY(s.P1);
      barre = [[0, 0], I0, I1, [0, s.P1]]; retour = [C, O2, I2, I0]; seam = [I0, I1];
    }
    var pieces = [{ id: 'plan', role: 'plan principal', pts: barre, axis: [1, 0] }, { id: 'retour', role: 'retour', pts: retour, axis: dir }];
    var corner = C, dirV = dir;
    if (s.dir === 'left') {                                /* miroir : on retourne les POINTS, pas l'image */
      var m = function (p) { return [s.L1 - p[0], p[1]]; };
      pieces = pieces.map(function (p) { return { id: p.id, role: p.role, pts: p.pts.map(m).reverse(), axis: [-p.axis[0], p.axis[1]] }; });
      seam = seam.map(m); corner = m(C); dirV = [-dir[0], dir[1]];
    }
    /*  chaque pièce porte son axe (le long de son mur) : fil du décor et longueur suivent cet axe*/
    return { pieces: pieces, seam: seam, corner: corner, dirV: dirV };
  }
  window.CP_geomAngle = geomAngle;

  /* étendue d'une pièce le long de son axe*/
  function axisLength(pts, ax) {
    var l = Math.hypot(ax[0], ax[1]) || 1, pr = pts.map(function (q) { return (q[0] * ax[0] + q[1] * ax[1]) / l; });
    return Math.max.apply(null, pr) - Math.min.apply(null, pr);
  }

  /* ── 1a bis. Plan droit, par points (même repère : origine au coin arrière gauche) ── */
  function geomLinear(s) {
    return { pieces: [{ id: 'plan', role: 'plan principal', pts: [[0, 0], [s.L, 0], [s.L, s.P], [0, s.P]], axis: [1, 0] }] };   /* axe : le front */
  }
  window.CP_geomLinear = geomLinear;

  /* ── 1a ter. Forme en U, par points (6b) ; même repère. Jonctions, comme en L :
     jl / jr = 'retour' (la jambe va jusqu'au mur du fond = moteur 'flush'),
               'barre' (le fond passe au-dessus de la jambe = moteur 'overlap').
     Un angle par coin : aL, aR de 85 à 95°, angle
     entre le mur du fond et le mur de la jambe ; chaque jambe tourne autour de son coin de murs.
     Cotes de jambe (L2 = Pc + Lg, L3 = Pc + Ld) mesurées le long de leur mur (Q7).
     Points de chaque pièce dans l'ordre des coins du rectangle du moteur (HG, HD, BD, BG). ──*/
  function uSide(C, sx, a, s, P, Lw) {                    /* sx = +1 : coin droit ; -1 : coin gauche (miroir) */
    var d = (a - 90) * Math.PI / 180, dir = [sx * Math.sin(d), Math.cos(d)], nrm = [-sx * Math.cos(d), Math.sin(d)];
    var on = function (t, v) { return [C[0] + t * dir[0] + v * nrm[0], C[1] + t * dir[1] + v * nrm[1]]; };
    var tAt = function (y, v) { return (y - C[1] - v * nrm[1]) / dir[1]; };
    return { C: C, dir: dir, O1: on(tAt(s.Pc, 0), 0), O2: on(Lw, 0), I0: on(tAt(0, P), P), I1: on(tAt(s.Pc, P), P), I2: on(Lw, P) };
  }
  /* jl / jr = 'onglet' : la jambe et le fond vont tous deux jusqu'au coin
     extérieur des murs, coupés du coin extérieur C au coin intérieur I1*/
  function geomU(s) {
    var W = s.Pl + s.Lc + s.Pr, aL = s.aL || 90, aR = s.aR || 90;
    var L = uSide([0, 0], -1, aL, s, s.Pl, s.Pc + s.Lg), R = uSide([W, 0], 1, aR, s, s.Pr, s.Pc + s.Ld);
    var gB = s.jl === 'barre', dB = s.jr === 'barre', gO = s.jl === 'onglet', dO = s.jr === 'onglet';
    return {
      pieces: [{ id: 'gauche', role: 'jambe gauche', pts: gB ? [L.O1, L.I1, L.I2, L.O2] : [L.C, gO ? L.I1 : L.I0, L.I2, L.O2], axis: L.dir },
               { id: 'fond', role: 'fond du U', pts: [gB || gO ? L.C : L.I0, dB || dO ? R.C : R.I0, dB ? R.O1 : R.I1, gB ? L.O1 : L.I1], axis: [1, 0] },
               { id: 'droite', role: 'jambe droite', pts: dB ? [R.I1, R.O1, R.O2, R.I2] : [dO ? R.I1 : R.I0, R.C, R.O2, R.I2], axis: R.dir }],
      seams: [gB ? [L.O1, L.I1] : (gO ? [L.C, L.I1] : [L.I0, L.I1]), dB ? [R.I1, R.O1] : (dO ? [R.I1, R.C] : [R.I0, R.I1])],
      corners: { g: L.I1, d: R.I1 },                      /* angles intérieurs (étiquettes d'angle) */
      sides: { g: L, d: R },                              /* points de chaque côté (habillage du dessin) */
      walls: { g: { C: L.C, end: L.O2, dir: L.dir }, d: { C: R.C, end: R.O2, dir: R.dir } },
      rot: { g: aL - 90, d: -(aR - 90) }                  /* rotation de chaque jambe autour de son coin (degrés, repère SVG) */
    };
  }
  window.CP_geomU = geomU;

  /* ── 1a quater. Forme en G, par points (6c, à 90°) ; même repère. Relevé de renderG
     (configurator-render-g.liquid, §§ 7, 10 et 11) :
     G à droite : montant gauche (Pgleft, pleine hauteur), haut (Gtop), montant droit
       (Pgright, sous le haut), retour (Greturn × Pgreturn) accroché en bas du montant droit,
       vers l'intérieur ;
     G à gauche : montant droit (Pgright) dessiné à gauche, en pleine hauteur, et portant le
       retour ; montant gauche (Pgleft) à droite, sous le haut.
     Jonctions top / mid / ret : 'retour' (moteur flush) ou 'barre' (overlap). Le moteur superpose
     ses blocs (le dernier dessiné gagne) ; ici chaque coin appartient à UNE pièce, sans chevauchement :
     top 'barre' -> le haut va jusqu'au bord ; mid 'barre' -> le montant sans retour de coin monte
     jusqu'en haut ; ret 'barre' -> le retour passe sous le montant jusqu'à son bord extérieur. ──*/
  /*  top / mid / ret = 'onglet' (coupe à 45°) : les deux pièces vont jusqu'au coin extérieur
     des murs et sont coupées du coin extérieur au coin intérieur. Chaque pièce : [HG, HD, BD, BG].
     G à gauche : le montant « right » du moteur (Pgright, Gright, porteur du retour) est dessiné
     À GAUCHE et le montant « left » à droite. Les pièces portent le nom de leur position réelle : « gauche » = montant de gauche à l'écran et à l'atelier.
     Un angle par coin : aTop (haut gauche), aMid (haut droit), aRet
     (retour), de 85 à 95°. Les montants tournent autour de leur coin de murs, comme les jambes du U
     (uSide, avec le plan du haut pour fond). Le retour tourne autour du coin extérieur du bas de son
     montant : son bord avant fait l'angle aRet avec le mur du montant, et l'angle intérieur
     (montant / retour) vaut aRet. Cotes le long des murs (Q7) : montant = Pgtop + Gleft ou Gright
     depuis le coin des murs ; retour = largeur du montant + Greturn depuis le coin extérieur. À 90°,
     les points sont exactement ceux d'avant.*/
  function lineX(P, u, Q, v) {                            /* intersection des droites P + a·u et Q + b·v */
    var den = u[0] * v[1] - u[1] * v[0], a = ((Q[0] - P[0]) * v[1] - (Q[1] - P[1]) * v[0]) / den;
    return [P[0] + a * u[0], P[1] + a * u[1]];
  }
  function geomG(s) {
    var t = s.top, m = s.mid, r = s.ret, R = s.dir !== 'left', pt = s.Pgtop, pg = s.Pgreturn;
    var aT = s.aTop || 90, aM = s.aMid || 90, aR = s.aRet || 90, z0 = function (v) { return [v[0] + 0, v[1] + 0]; };
    /* une extrémité de pièce selon la jonction : 'retour' / 'barre' / 'onglet' → [sommet 1, sommet 2] */
    var end = function (j, onRetour, onBarre, onOnglet) { return j === 'onglet' ? onOnglet : (j === 'barre' ? onBarre : onRetour); };
    /* montants de gauche et de droite À L'ÉCRAN : largeur, longueur le long du mur */
    var wl = R ? s.Pgleft : s.Pgright, wr = R ? s.Pgright : s.Pgleft, ll = pt + (R ? s.Gleft : s.Gright), lr = pt + (R ? s.Gright : s.Gleft);
    var W = wl + s.Gtop, Ls = uSide([0, 0], -1, aT, { Pc: pt }, wl, ll), Rs = uSide([W, 0], 1, aM, { Pc: pt }, wr, lr);
    var M = R ? Rs : Ls, wm = R ? wr : wl;                /* montant qui porte le retour */
    var up = [-M.dir[0], -M.dir[1]], nM = [(M.I2[0] - M.O2[0]) / wm, (M.I2[1] - M.O2[1]) / wm], dd = (aR - 90) * Math.PI / 180;
    var ca = -Math.sin(dd), sa = Math.cos(dd);           /* cos(aR), sin(aR), exacts à 90° */
    var dRet = [ca * up[0] + sa * nM[0], ca * up[1] + sa * nM[1]], p1 = [-dRet[1], dRet[0]];
    var nRet = (p1[0] * up[0] + p1[1] * up[1] > 0) ? p1 : [dRet[1], -dRet[0]];
    var O = M.O2, Lret = wm + s.Greturn, Qi = [O[0] + pg * nRet[0], O[1] + pg * nRet[1]];
    var Eout = [O[0] + Lret * dRet[0], O[1] + Lret * dRet[1]], Ein = [Eout[0] + pg * nRet[0], Eout[1] + pg * nRet[1]];
    var I = lineX(M.I1, M.dir, Qi, dRet), Ob = lineX(M.I1, M.dir, O, dRet), Ot = lineX(M.C, M.dir, Qi, dRet);
    var gTop = end(t, [Ls.C, Ls.I0], [Ls.O1, Ls.I1], [Ls.C, Ls.I1]);                        /* haut du montant de gauche : HG, HD */
    var hL = end(t, [Ls.I0, Ls.I1], [Ls.C, Ls.O1], [Ls.C, Ls.I1]);                          /* bout gauche du haut : HG, BG */
    var hR = end(m, [Rs.C, Rs.O1], [Rs.I0, Rs.I1], [Rs.C, Rs.I1]);                          /* bout droit du haut : HD, BD */
    var dTop = end(m, [Rs.I1, Rs.O1], [Rs.I0, Rs.C], [Rs.I1, Rs.C]);                        /* haut du montant de droite : HG, HD */
    var haut = { id: 'haut', role: 'plan principal', pts: [hL[0], hR[0], hR[1], hL[1]], axis: [1, 0] }, pieces, seams;
    if (R) {
      var dBot = end(r, [O, Ob], [Ot, I], [O, I]);                                           /* bas du montant droit : BD, BG */
      var rR = end(r, [I, Ob], [Ot, O], [I, O]);                                             /* bout du retour côté montant : HD, BD */
      pieces = [
        { id: 'gauche', role: 'montant gauche', pts: [gTop[0], gTop[1], Ls.I2, Ls.O2], axis: z0(Ls.dir) },
        haut,
        { id: 'droite', role: 'montant droit', pts: [dTop[0], dTop[1], dBot[0], dBot[1]], axis: z0(Rs.dir) },
        { id: 'retour', role: 'retour', pts: [Ein, rR[0], rR[1], Eout], axis: z0([-dRet[0], -dRet[1]]) }
      ];
      seams = [end(t, [Ls.I0, Ls.I1], [Ls.O1, Ls.I1], [Ls.C, Ls.I1]), end(m, [Rs.I1, Rs.O1], [Rs.I0, Rs.I1], [Rs.I1, Rs.C]), end(r, [I, Ob], [I, Ot], [I, O])];
    } else {
      var gB = end(r, [Ob, O], [I, Ot], [I, O]);                                             /* bas du montant de gauche : BD, BG */
      var rL = end(r, [I, Ob], [Ot, O], [I, O]);                                             /* bout du retour côté montant : HG, BG */
      pieces = [
        { id: 'droite', role: 'montant droit', pts: [dTop[0], dTop[1], Rs.O2, Rs.I2], axis: z0(Rs.dir) },
        haut,
        { id: 'gauche', role: 'montant gauche', pts: [gTop[0], gTop[1], gB[0], gB[1]], axis: z0(Ls.dir) },
        { id: 'retour', role: 'retour', pts: [rL[0], Ein, Eout, rL[1]], axis: z0(dRet) }
      ];
      seams = [end(t, [Ls.I0, Ls.I1], [Ls.O1, Ls.I1], [Ls.C, Ls.I1]), end(m, [Rs.I1, Rs.O1], [Rs.I0, Rs.I1], [Rs.I1, Rs.C]), end(r, [I, Ob], [Ot, I], [I, O])];
    }
    /* passage : distance du bout du retour au bord intérieur du montant d'en face ; <= 0, le G est fermé*/
    var F = R ? Ls : Rs, nF = [(F.I2[0] - F.O2[0]) / (R ? wl : wr), (F.I2[1] - F.O2[1]) / (R ? wl : wr)];
    var opening = Math.min.apply(null, [Ein, Eout].map(function (q) { return (q[0] - F.I1[0]) * nF[0] + (q[1] - F.I1[1]) * nF[1]; }));
    /* repère du moteur à 90° (rectangles) -> quadrilatère réel, zone par zone (habillage du dessin, cp-trace) */
    var xR = W - wr, yEnd = pt + s.Gright, yRet = yEnd - pg, xRet = R ? xR - s.Greturn : wl + s.Greturn;   /* le retour est en bas du montant « right » du moteur */
    /* rot : rotation (degrés, repère SVG) de la pièce de la zone, pour ce que le moteur dessine d'un bloc
       (chant d'un coin usiné) : montants autour de leur coin de murs, retour selon son bord avant */
    var rL = aT - 90, rR = -(aM - 90), d90 = R ? [-1, 0] : [1, 0];
    var rT = (Math.atan2(dRet[1], dRet[0]) - Math.atan2(d90[1], d90[0])) * 180 / Math.PI;
    rT = ((rT + 540) % 360) - 180;
    var Z = function (r, q, rot) { return { r: r, q: q, rot: rot }; };
    var zones = R ? [
      Z([wl, 0, xR, pt], [Ls.I0, Rs.I0, Rs.I1, Ls.I1], 0), Z([0, 0, wl, pt], [Ls.C, Ls.I0, Ls.I1, Ls.O1], rL),
      Z([0, pt, wl, ll], [Ls.O1, Ls.I1, Ls.I2, Ls.O2], rL), Z([xR, 0, W, pt], [Rs.I0, Rs.C, Rs.O1, Rs.I1], rR),
      Z([xR, pt, W, yRet], [Rs.I1, Rs.O1, Ot, I], rR), Z([xR, yRet, W, yEnd], [I, Ot, O, Ob], rR),
      Z([xRet, yRet, xR, yEnd], [Ein, I, Ob, Eout], rT)
    ] : [
      Z([wl, 0, xR, pt], [Ls.I0, Rs.I0, Rs.I1, Ls.I1], 0), Z([0, 0, wl, pt], [Ls.C, Ls.I0, Ls.I1, Ls.O1], rL),
      Z([0, pt, wl, yRet], [Ls.O1, Ls.I1, I, Ot], rL), Z([0, yRet, wl, yEnd], [Ot, I, Ob, O], rL),
      Z([wl, yRet, xRet, yEnd], [I, Ein, Eout, Ob], rT), Z([xR, 0, W, pt], [Rs.I0, Rs.C, Rs.O1, Rs.I1], rR),
      Z([xR, pt, W, lr], [Rs.I1, Rs.O1, Rs.O2, Rs.I2], rR)
    ];
    return { pieces: pieces, seams: seams, opening: opening,
      between: R ? [['gauche', 'haut'], ['haut', 'droite'], ['droite', 'retour']] : [['gauche', 'haut'], ['haut', 'droite'], ['gauche', 'retour']],
      sides: { g: Ls, d: Rs }, ret: { O: O, I: I, Ob: Ob, Ot: Ot, Ein: Ein, Eout: Eout, dir: dRet, nrm: nRet }, zones: zones,
      /* contour réel du G entier (réunion des pièces) et profondeur de pièce à chaque sommet (0 : angle rentrant) */
      outline: R ? [Ls.C, Rs.C, O, Eout, Ein, I, Rs.I1, Ls.I1, Ls.I2, Ls.O2] : [Ls.C, Rs.C, Rs.O2, Rs.I2, Rs.I1, Ls.I1, I, Ein, Eout, O],
      outlineDepth: R ? [Math.min(wl, pt), Math.min(wr, pt), Math.min(wr, pg), pg, pg, 0, 0, 0, wl, wl] : [Math.min(wl, pt), Math.min(wr, pt), wr, wr, 0, 0, 0, pg, pg, Math.min(wl, pg)],
      /* angles intérieurs (étiquettes d'angle) : sommet et les deux bords qui forment l'angle */
      inner: { top: { p: Ls.I1, a: [1, 0], b: Ls.dir }, mid: { p: Rs.I1, a: [-1, 0], b: Rs.dir }, ret: { p: I, a: dRet, b: up } },
      /*  bout de pièce où le moteur, qui dessine un onglet en « retour filant », pose un chant*/
      caps: { top: [Ls.C, Ls.I0], mid: [Rs.C, Rs.O1], ret: [O, Ob] } };
  }
  window.CP_geomG = geomG;

  /* ── 1a quinquies. A-345 : pièce d'angle du tarif (PDF 34 et 44, A-235), à un coin de murs C (90°). La pièce A suit le mur
     u (profondeur PA, selon v), la pièce B le mur v (profondeur PB, selon u). La pièce d'angle a 5 côtés : K le long de
     chaque mur, un bout de A et un bout de B (les jonctions), et l'avant en biais d'un bout à l'autre, devant l'angle
     intérieur. A et B s'arrêtent à K du coin. Une seule description : le modèle de commande, la 3D, le dessin, les
     longueurs facturées et la Composition (cp-pierre-angle) la lisent. ── */
  function demiPlan(P, C, d, K) {                         /* partie de P où (p − C)·d ≥ K (Sutherland–Hodgman, un seul bord) */
    var f = function (p) { return (p[0] - C[0]) * d[0] + (p[1] - C[1]) * d[1] - K; }, out = [];
    P.forEach(function (a, i) {
      var b = P[(i + 1) % P.length], fa = f(a), fb = f(b), ia = fa >= -1e-6, ib = fb >= -1e-6;
      if (ia) out.push(a);
      if (ia !== ib) { var t = fa / (fa - fb); out.push([a[0] + t * (b[0] - a[0]), a[1] + t * (b[1] - a[1])]); }
    });
    return out.filter(function (q, i) { var r = out[(i + 1) % out.length]; return Math.hypot(q[0] - r[0], q[1] - r[1]) > 1e-6; });
  }
  /* coins à pièce d'angle dans la géométrie brute g de la forme (geomAngle, geomU, geomG) */
  function coinsPA(S, g, coins) {
    var l = S.layout, out = [];
    coins.forEach(function (c) {
      if (l === 'angle' && c === 'L') out.push({ c: c, C: g.corner, u: S.angleDir === 'left' ? [1, 0] : [-1, 0], v: g.dirV, A: 'plan', B: 'retour', PA: num(S.P1), PB: num(S.P2) });
      if (l === 'u-shape' && (c === 'g' || c === 'd')) {
        var w = g.walls[c];
        out.push({ c: c, C: w.C, u: c === 'g' ? [1, 0] : [-1, 0], v: w.dir, A: 'fond', B: c === 'g' ? 'gauche' : 'droite', PA: num(S.Pc), PB: num(c === 'g' ? S.Pl : S.Pr) });
      }
      if (l === 'g-shape') {
        var R = S.gDir !== 'left', wl = num(R ? S.Pgleft : S.Pgright), wr = num(R ? S.Pgright : S.Pgleft), M = R ? g.sides.d : g.sides.g;
        if (c === 'top') out.push({ c: c, C: g.sides.g.C, u: [1, 0], v: g.sides.g.dir, A: 'haut', B: 'gauche', PA: num(S.Pgtop), PB: wl });
        if (c === 'mid') out.push({ c: c, C: g.sides.d.C, u: [-1, 0], v: g.sides.d.dir, A: 'haut', B: 'droite', PA: num(S.Pgtop), PB: wr });
        if (c === 'ret') out.push({ c: c, C: g.ret.O, u: [-M.dir[0], -M.dir[1]], v: g.ret.dir, A: R ? 'droite' : 'gauche', B: 'retour', PA: R ? wr : wl, PB: num(S.Pgreturn) });
      }
    });
    return out;
  }
  /* pa : { K, coins } (cp-pierre-angle, CP_paGeometrie). Pièces dans l'ordre de pose : la pièce d'angle entre ses deux plans.
     extra : surface de la pièce hors du dessin du moteur (le triangle devant l'angle intérieur) */
  function piecesPA(S, g, pieces, pa) {
    var K = pa.K, ps = pieces.map(function (p) { return { id: p.id, role: p.role, pts: p.pts, axis: p.axis }; }), seams = [], extra = 0;
    var ix = function (id) { for (var i = 0; i < ps.length; i++) if (ps[i].id === id) return i; return -1; };
    coinsPA(S, g, pa.coins).forEach(function (k) {
      var iA = ix(k.A), iB = ix(k.B); if (iA < 0 || iB < 0) return;
      var at = function (a, b) { return [k.C[0] + a * k.u[0] + b * k.v[0], k.C[1] + a * k.u[1] + b * k.v[1]]; }, id = 'angle_' + k.c;
      ps[iA] = Object.assign({}, ps[iA], { pts: demiPlan(ps[iA].pts, k.C, k.u, K) });
      ps[iB] = Object.assign({}, ps[iB], { pts: demiPlan(ps[iB].pts, k.C, k.v, K) });
      /* fil du décor parallèle au plan (L1), comme le plan (STYLE, Tour 34) */
      ps.splice(Math.max(iA, iB), 0, { id: id, role: 'pièce d\'angle', pts: [at(0, 0), at(K, 0), at(K, k.PA), at(k.PB, K), at(0, K)], axis: [1, 0], coin: k.c });
      seams.push({ c: k.c, entre: [k.A, id], segment: [at(K, 0), at(K, k.PA)] }, { c: k.c, entre: [id, k.B], segment: [at(0, K), at(k.PB, K)] });
      extra += Math.max(0, K - k.PA) * Math.max(0, K - k.PB) / 2;
    });
    return { pieces: ps, seams: seams, extra: extra };
  }
  window.CP_piecesPA = piecesPA;
  /* pièces de commande de la forme (repère du dessin du moteur, origine = coin haut gauche de ses blocs), pièces d'angle
     comprises : ce que le dessin de cp-pierre-angle peint (A-345) */
  window.CP_piecesCommande = function (A) {
    A = A || getApp(); if (!A || !A.S) return null;
    var S = A.S, g = null;
    if (S.layout === 'angle') g = geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: num(S.innerAngle || 90), jn: junctionOf(S), dir: S.angleDir === 'left' ? 'left' : 'right' });
    else if (S.layout === 'u-shape') {
      var aU = cornerAnglesOf(S), jU = jnUside(S);
      g = geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr), jl: jU.g, jr: jU.d, aL: aU.g, aR: aU.d });
    } else if (S.layout === 'g-shape') g = geomG(gParams(S));
    if (!g) return null;
    var pa = typeof window.CP_paGeometrie === 'function' ? window.CP_paGeometrie(A) : null;
    return pa ? piecesPA(S, g, g.pieces, pa) : { pieces: g.pieces, seams: [], extra: 0 };
  };

  /* ── 1b. Autres formes : pièces relevées dans le dessin du moteur (cp-texture.js) ── */
  function piecesFromEngine(A) {
    var raw = (A._cpPieces || []).slice();
    if (!raw.length) return [];
    var x0 = Math.min.apply(null, raw.map(function (p) { return p.x; }));
    var y0 = Math.min.apply(null, raw.map(function (p) { return p.y; }));
    return raw.map(function (p, i) {
      var x = r2(p.x - x0), y = r2(p.y - y0), w = r2(p.w), h = r2(p.h);
      return { id: 'p' + (i + 1), role: (i === 0 ? 'plan principal' : 'pièce ' + (i + 1)), pts: [[x, y], [x + w, y], [x + w, y + h], [x, y + h]] };
    });
  }

  function junctionOf(S) {
    if (S.cpJ45) return 'onglet';
    return S.junctionType === 'overlap' ? 'barre' : 'retour';
  }

  function cotes(S) {
    var pick = function (keys) { var o = {}; keys.forEach(function (k) { if (S[k] !== undefined) o[k] = num(S[k]); }); return o; };
    if (S.layout === 'linear') return pick(['L', 'P']);
    if (S.layout === 'angle') return pick(['L1', 'P1', 'L2', 'P2']);
    if (S.layout === 'u-shape') return pick(['Lc', 'Pc', 'Lg', 'Ld', 'Pl', 'Pr']);
    if (S.layout === 'g-shape') return pick(['Gtop', 'Gleft', 'Gright', 'Greturn', 'Pgtop', 'Pgleft', 'Pgright', 'Pgreturn']);
    return {};
  }

  /* Cases de chants du dessin courant (posées par addEdgeCheckbox du moteur dans #dims) :
     all = clés présentes, checked = clés cochées ; sans doublon, triées */
  function drawnEdges(A) {
    var host = A.dims || document.getElementById('dims'), all = [], checked = [];
    if (host) Array.prototype.forEach.call(host.querySelectorAll('.edge-checkbox-visual[data-edge]'), function (c) {
      var k = c.dataset.edge;
      if (all.indexOf(k) < 0) all.push(k);
      if (c.classList.contains('checked') && checked.indexOf(k) < 0) checked.push(k);
    });
    return { all: all.sort(), checked: checked.sort() };
  }

  /*  variante = finition choisie, par égalité exacte du nom (sans casse ni espaces en trop)*/
  function normName(s) { return String(s == null ? '' : s).normalize('NFC').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function finitionName(A) { var m = A.variantsMeta && A.variantsMeta[A.S.variant]; return m && m.name ? String(m.name) : ''; }
  function variantIs(v, name) {
    var n = normName(name);
    return !!v && !!n && [v.title, v.option1, v.option2, v.option3].concat(v.options || []).some(function (o) { return normName(o) === n; });
  }
  function exactVariant(A) {
    var name = finitionName(A), all = A.shopifyVariants || [];
    if (!name) return null;
    var dec = byThk(A, all.filter(function (v) { return variantIs(v, name); }));
    return all.filter(function (v) { return normName(v.title) === normName(name); })[0] || (hauteurVar(A) ? byHauteur(A, dec) : byDepth(A, dec)) || null;   /* lot R : la hauteur, pas la profondeur */
  }
  /* Familles HPL et pierre : l'épaisseur aussi peut être portée par les
     variantes (option « Épaisseur », valeurs « 12 mm », « 20 mm »…). Le prix fournisseur dépend du groupe du décor, de
     l'épaisseur et de la profondeur, sans écart fixe : il est dans la variante. L'épaisseur choisie (S.thk) désigne
     alors la variante, donc son prix au cm et la ligne du panier ; le supplément d'épaisseur du moteur (blocs
     « thickness », en €/ml, communs au site : 40 mm = +10 pour le stratifié) ne s'applique pas à ces produits.*/
  function thkValue(val) {
    var m = String(val == null ? '' : val).replace(',', '.').match(/^\s*(\d+(?:\.\d+)?)\s*mm\s*$/i);
    return m ? parseFloat(m[1]) : null;
  }
  function thkKey(list) {
    return ['option1', 'option2', 'option3'].filter(function (k) {
      return list.every(function (v) { return thkValue(v[k]) != null; }) && list.some(function (v) { return v[k] !== list[0][k]; });
    })[0] || null;
  }
  function thkByVariant(A) { var all = (A && A.shopifyVariants) || []; return all.length > 1 && !!thkKey(all); }
  function byThk(A, list) {
    var all = A.shopifyVariants || [], k = all.length > 1 ? thkKey(all) : null; if (!k || !list.length) return list;
    var t = num(A.S && A.S.thk), m = list.filter(function (v) { return thkValue(v[k]) === t; });
    return m.length ? m : list;                                    /* épaisseur absente du décor : cp-gamme bloque l'ajout */
  }
  window.CP_thkByVariant = function () { return thkByVariant(getApp()); };
  /* Étagère (26 / 34 cm), Dekton (60/65, 65,1/70 cm) : un même décor a plusieurs variantes, une par profondeur
     (option « Profondeur », valeurs en cm, seules ou en plage « a/b cm »). La profondeur saisie (S.P, mm) désigne la
     variante, donc son prix au cm et la ligne du panier. Le moteur prenait la première (toujours la plus petite).
     Option repérée par ses valeurs (le moteur n'a pas options_with_values sur ce site). */
  function depthRange(val) {
    var m = String(val == null ? '' : val).replace(/,/g, '.').match(/^\s*(\d+(?:\.\d+)?)\s*(?:\/\s*(\d+(?:\.\d+)?))?\s*cm\s*$/i);
    if (!m) return null;
    var a = parseFloat(m[1]) * 10, b = m[2] ? parseFloat(m[2]) * 10 : a;
    return [Math.min(a, b), Math.max(a, b)];
  }
  function depthKey(list) {
    return ['option1', 'option2', 'option3'].filter(function (k) {
      return list.every(function (v) { return depthRange(v[k]); }) && list.some(function (v) { return v[k] !== list[0][k]; });
    })[0] || null;
  }
  /* profondeur du plan : en L, en U et en G, celle des branches (la plus grande) ; S.P garde celle du plan droit, et
     une profondeur de 700 laissée là facturait encore la variante 65,1/70 d'un L ramené à 650 */
  function profPlan(S) {
    if (!S) return 0;
    if (S.layout === 'angle') return Math.max(num(S.P1), num(S.P2)) || num(S.P);
    if (S.layout === 'u-shape') return Math.max(num(S.Pl), num(S.Pc), num(S.Pr)) || num(S.P);
    if (S.layout === 'g-shape') return Math.max(num(S.Pgtop), num(S.Pgleft), num(S.Pgright), num(S.Pgreturn)) || num(S.P);
    return num(S.P);
  }
  function byDepth(A, list) {
    if (list.length < 2) return list[0] || null;
    var k = depthKey(list); if (!k) return list[0];
    var P = profPlan(A.S), best = list[0], bd = Infinity;
    list.forEach(function (v) {
      var r = depthRange(v[k]), d = P < r[0] ? r[0] - P : (P > r[1] ? P - r[1] : 0);
      if (d < bd - 0.01) { bd = d; best = v; }
    });
    return best;
  }
  window.CP_variantByDepth = function () { var A = getApp(); return A ? exactVariant(A) : null; };
  /* lien ?variant= (fiche Google, carte par variante) : le moteur ne reprend que le décor ; l'épaisseur et la profondeur
     de la variante du lien sont reprises ici, une fois, au démarrage. Sans cela, la page s'ouvrait sur la première
     épaisseur et la première profondeur, à un autre prix que celui annoncé pour ce lien. La profondeur n'est changée que
     si elle sort de la plage de la variante (ramenée à la borne la plus proche), en plan droit ; ensuite, le client choisit. */
  function urlVariant(A) {
    var id = null; try { id = new URLSearchParams(window.location.search).get('variant'); } catch (e) { id = null; }
    var all = A.shopifyVariants || [], v = id ? all.filter(function (x) { return String(x.id) === String(id); })[0] : null;
    if (!v || all.length < 2) return false;
    var ch = false, tk = thkKey(all), dk = hauteurVar(A) ? null : depthKey(all);   /* lot R : « 5 cm » n'est pas une profondeur */
    if (tk) { var t = thkValue(v[tk]); if (t && num(A.S.thk) !== t) { A.S.thk = t; ch = true; } }
    if (hauteurVar(A)) { var hv = hautDe(v); if (hv && num(A.S.P) !== hv) { A.S.P = hv; ch = true; } }   /* lot R : la hauteur de la variante du lien */
    if (dk && (A.S.layout || 'linear') === 'linear') {
      var r = depthRange(v[dk]), P = num(A.S.P);
      if (r) { var c = Math.min(r[1], Math.max(r[0], P)); if (c !== P) { A.S.P = c; ch = true; } }
    }
    return ch;
  }
  var uvTries = 0, uvTimer = setInterval(function () {
    var A = getApp();
    if (A && A.S && A.svg && A.S.variant && (A.shopifyVariants || []).length) {
      clearInterval(uvTimer);
      if (urlVariant(A)) { if (typeof A.renderThicknessUI === 'function') A.renderThicknessUI(); A.render(); }
    } else if (++uvTries > 200) clearInterval(uvTimer);
  }, 100);
  /* Produit dont la profondeur est portée par les variantes : ses plages (mm), sinon null */
  function depthRanges(A) {
    var all = A.shopifyVariants || [], k = all.length > 1 && !hauteurVar(A) ? depthKey(all) : null; if (!k) return null;   /* lot R : pas de plages de profondeur */
    var seen = {}, out = [];
    all.forEach(function (v) { var r = depthRange(v[k]); if (r && !seen[r.join('-')]) { seen[r.join('-')] = 1; out.push(r); } });
    return out.sort(function (a, b) { return a[0] - b[0]; });
  }
  /* profondeur ramenée dans une plage vendue (étagère : 26 ou 34 cm ; Dekton : 600 à 700 mm) ; message si changée */
  function snapDepth(A) {
    if (typeof window.CP_ilotOk === 'function' && window.CP_ilotOk(A)) return null;   /* pierre au m² (cp-pierre-angle) : îlot, plan fini sur 4 côtés */
    var R = depthRanges(A), S = A.S; if (!R || S.layout !== 'linear') return null;
    var P = num(S.P), best = null, bd = Infinity;
    R.forEach(function (r) { var t = P < r[0] ? r[0] : (P > r[1] ? r[1] : P), d = Math.abs(t - P); if (d < bd) { bd = d; best = t; } });
    if (best == null || best === P) return null;
    S.P = best;
    return 'Profondeur ramenée à ' + String(best / 10).replace('.', ',') + ' cm : ' + R.map(function (r) { return r[0] === r[1] ? String(r[0] / 10).replace('.', ',') + ' cm' : String(r[0] / 10).replace('.', ',') + ' à ' + String(r[1] / 10).replace('.', ',') + ' cm'; }).join(' ou ') + ' pour ce produit.';
  }

  function parseEuroCents(txt) {
    var t = String(txt || '').replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var n = parseFloat(t); return isFinite(n) ? Math.round(n * 100) : null;
  }

  /* ── 1c. LE modèle ── */
  /* angles par coin (U, G) tenus par cp-trace.js dans S.cpAng[forme] ; 90° par défaut */
  function cornerAnglesOf(S) {
    var c = (S.cpAng && S.cpAng[S.layout]) || {}, f = function (x) { x = num(x); return (x >= 85 && x <= 95) ? x : 90; };
    if (S.layout === 'g-shape') return { top: f(c.top), mid: f(c.mid), ret: f(c.ret) };     /* haut gauche, haut droit, retour */
    return S.layout === 'u-shape' ? { g: f(c.g), d: f(c.d) } : null;
  }
  /* paramètres de CP_geomG tirés de l'état (cotes, jonctions, sens, angles par coin) */
  function gParams(S) {
    var j = jnGside(S), a = cornerAnglesOf(Object.assign({}, S, { layout: 'g-shape' }));
    return { Gtop: num(S.Gtop), Gleft: num(S.Gleft), Gright: num(S.Gright), Greturn: num(S.Greturn),
      Pgtop: num(S.Pgtop), Pgleft: num(S.Pgleft), Pgright: num(S.Pgright), Pgreturn: num(S.Pgreturn),
      top: j.top, mid: j.mid, ret: j.ret, dir: S.gDir === 'left' ? 'left' : 'right', aTop: a.top, aMid: a.mid, aRet: a.ret };
  }
  window.CP_gParams = function (S) { return gParams(S || (getApp() || {}).S || {}); };
  window.CP_cornerAngles = function (S) { return cornerAnglesOf(S || (getApp() || {}).S || {}); };
  var jnU = function (x) { return x === 'overlap' ? 'barre' : 'retour'; };
  /* jonction de chaque coin du U : coupe à 45° sinon celle du moteur*/
  function jnUside(S) { var o = S.cpJ45U || {}; return { g: o.g ? 'onglet' : jnU(S.junctionLeftU), d: o.d ? 'onglet' : jnU(S.junctionRightU) }; }
  window.CP_jnU = function (S) { return jnUside(S || (getApp() || {}).S || {}); };
  /* idem pour les 3 coins du G (S.cpJ45G : top, mid, ret) */
  function jnGside(S) {
    var o = S.cpJ45G || {};
    return { top: o.top ? 'onglet' : jnU(S.junctionTopG), mid: o.mid ? 'onglet' : jnU(S.junctionMidG), ret: o.ret ? 'onglet' : jnU(S.junctionReturnG) };
  }
  window.CP_jnG = function (S) { return jnGside(S || (getApp() || {}).S || {}); };
  /* recale un tracé à l'origine « coin arrière gauche de l'encombrement » (x, y >= 0) */
  function shiftPieces(geoPieces, extra) {
    var all = [].concat.apply([], geoPieces.map(function (p) { return p.pts; }));
    var ox = Math.min(0, Math.min.apply(null, all.map(function (q) { return q[0]; })));
    var oy = Math.min(0, Math.min.apply(null, all.map(function (q) { return q[1]; })));
    var sh = function (q) { return [q[0] - ox, q[1] - oy]; };
    return { sh: sh, pieces: geoPieces.map(function (p) { return { id: p.id, role: p.role, pts: p.pts.map(sh) }; }) };
  }

  /* règle retenue par le moteur (App._eff.matchedCollectionId) dans CONFIGURATOR_CONFIG.collectionRules ; null sans règle */
  function regleRetenue(A) {
    var id = A && A._eff ? Number(A._eff.matchedCollectionId) : 0; if (!id) return null;
    return ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0] || null;
  }
  /* ── : pour les produits dont la règle du configurateur vend à la surface (case « Vendre par surface » de la
     règle retenue), la quantité facturée est la
     surface en dm² (prix des variantes au dm²), arrondie au dm² le plus proche, comme la longueur l'est au cm ;
     aucun supplément de profondeur. La surface est celle des pièces du modèle (mêmes géométries que buildPlan,
     angles et jonctions compris) ; elle ne passe pas par buildPlan, qui lit lui-même la quantité facturée. ──*/
  function sellsBySurface(A) { var rg = regleRetenue(A); return !!rg && rg.parSurface === true; }
  function piecesOf(A) {
    var S = A.S;
    var bp = typeof window.CP_boisPieces === 'function' ? window.CP_boisPieces() : null;   /* R133 : boiserie, les panneaux (cp-etagere) ; null ailleurs */
    if (bp) return bp;
    if (S.layout === 'angle') return geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: num(S.innerAngle || 90), jn: junctionOf(S), dir: S.angleDir === 'left' ? 'left' : 'right' }).pieces;
    if (S.layout === 'u-shape') {
      var angU = cornerAnglesOf(S), jU = jnUside(S);
      return geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr), jl: jU.g, jr: jU.d, aL: angU.g, aR: angU.d }).pieces;
    }
    if (S.layout === 'g-shape') return geomG(gParams(S)).pieces;
    if (S.layout === 'linear') return geomLinear({ L: num(S.L), P: num(S.P) }).pieces;
    return piecesFromEngine(A);
  }
  function surfaceMm2(A) { return piecesOf(A).reduce(function (s, p) { return s + area(p.pts); }, 0); }
  /*  surface minimale facturée par panneau (par pièce) : « Surface minimale facturée par pièce (m²) » de la règle
     retenue (ex. 0,4 m² pour le mélaminé : un panneau de 25 × 3,7 cm partait à 1,40 € pour un coût d'au moins 24 € HT ;
     0,25 m² pour une crédence en pierre). 0 : aucune.*/
  function minM2(A) { var rg = regleRetenue(A); return rg && num(rg.factureMinM2) > 0 ? num(rg.factureMinM2) : 0; }
  function billedMm2(A) { var mn = minM2(A) * 1e6; return piecesOf(A).reduce(function (s, p) { return s + Math.max(area(p.pts), mn); }, 0); }
  function minApplied(A) { var mn = minM2(A) * 1e6; return mn > 0 && piecesOf(A).some(function (p) { return area(p.pts) < mn; }); }
  function minText(A) { return 'minimum facturé : ' + String(minM2(A)).replace('.', ',') + ' m²' + (piecesOf(A).length > 1 ? ' par panneau' : ''); }
  function m2Reel(A) { return (surfaceMm2(A) / 1e6).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²'; }   /* taille réelle, avant minimum */
  /* Étagère : facturation minimale de 0,6 ml, pour les collections de
     CP_MIN_ML (cp-decor-data : { id de collection : mm }). Une étagère de 40 cm est facturée 60 cm.*/
  function minMl(A) {
    var il = typeof window.CP_ilotMinMl === 'function' ? num(window.CP_ilotMinMl(A)) : 0; if (il) return il;   /* îlot en pierre : 0,3 m */
    var id = A && A._eff ? Number(A._eff.matchedCollectionId) : 0, t = window.CP_MIN_ML || {};
    /* « Longueur minimale facturée (mm) » de la règle (bloc « Règle par collection »), si elle est posée */
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    var qe = parEp(A); if (qe && num(qe.facture_min_mm) > 0) return num(qe.facture_min_mm);   /* R180 : minimum facturé de l'épaisseur */
    if (rg && num(rg.factureMinMm) > 0) return num(rg.factureMinMm);
    return id && t[id] ? Number(t[id]) : depthMinMl(A);
  }
  /* ── : profondeurs du plan stratifié.
     1. Le supplément de profondeur dépend de l'ÉPAISSEUR (€/ml, 20 / 40 / 60 mm) : 800 et sur mesure 631–799 = P80
        (+120 / +120 / +150) ; 1 200 et sur mesure 801–1 199 = P120 (+140 / +150 / +200). Les autres (600 : 0, 630 : +5,
        sur mesure 300–599 : +49) restent ceux de product.json. Le moteur n'a qu'un extra_price par profondeur : la table
        ci-dessous le remplace, épaisseur par épaisseur, le temps du calcul.
     2. Recherche limitée aux profondeurs de la RÈGLE du produit : le moteur prenait la 1re profondeur trouvée, toutes
        collections confondues (crédence « sur mesure 50–800 : +79 €/ml » facturée +179 à 700 mm, +49 à 300 mm,
        d'après les plages du plan).
     3. Facturation minimale : 0,3 ml si toutes les profondeurs sont standard, 0,5 ml sinon.*/
  var DEPTH_THK = {
    depth_800: { 20: 120, 40: 120, 60: 150 }, depth_custom_631_799: { 20: 120, 40: 120, 60: 150 },
    depth_1200: { 20: 140, 40: 150, 60: 200 }, depth_custom_801_1199: { 20: 140, 40: 150, 60: 200 }
  };
  var DEPTH_KEYS = { linear: ['P'], angle: ['P1', 'P2'], 'u-shape': ['Pl', 'Pc', 'Pr'], 'g-shape': ['Pgleft', 'Pgtop', 'Pgright', 'Pgreturn'] };
  function depthAllowed(A) {
    var r = A && A._eff && A._eff.depthRule;
    return (r && r.enabled && Array.isArray(r.allowed) && r.allowed.length) ? r.allowed.map(String) : null;
  }
  function depthRate(o, thk) { var m = o && DEPTH_THK[o.id], v = m && m[thk]; return v != null ? v : Number(o && o.extraPrice || 0); }
  function depthTable(A, thk) {
    var al = depthAllowed(A); if (!al) return null;
    var C = window.CONFIGURATOR_CONFIG || {}, t = thk != null ? num(thk) : num(A.S && A.S.thk);
    var pick = function (arr) {
      return (arr || []).filter(function (o) { return al.indexOf(String(o.id)) >= 0; }).map(function (o) {
        var c = {}; for (var k in o) c[k] = o[k]; c.extraPrice = depthRate(o, t); return c;
      });
    };
    return { std: pick(C.depthStandards), cst: pick(C.depthCustomRanges) };
  }
  /* facturation minimale par règle (repérée par une de ses profondeurs) : plan 0,3 ml, crédence aucune. Le minimum de 0,5 ml
     hors standard (A-158) est retiré par le lot de prix du stratifié (AUDIT Tour 622, q2) : la coupe se paie par la ligne de
     réduction de profondeur */
  var DEPTH_MIN = [{ id: 'depth_800', std: 300, hors: 300 }, { id: 'depth_800_credence_imb', std: 0, hors: 0 }];
  /*  mention sous la plage sur mesure*/
  var DEPTH_MENTION = {
    depth_custom_300_599: 'découpe en profondeur',
    custom_credence_50_599: 'découpe comprise',
    custom_credence_601_799: 'découpée dans une crédence de 800 mm',
    custom_credence_801_1199: 'découpée dans une crédence de 1 200 mm'
  };
  function depthMinRule(A) {
    var al = depthAllowed(A); if (!al) return null;
    return DEPTH_MIN.filter(function (r) { return al.indexOf(r.id) >= 0; })[0] || null;
  }
  /* lot de prix du stratifié (tableau 2.3 ; AUDIT Tours 557, 622) : réduction de profondeur de la règle (« Réduction
     profondeur » du tarif, par pièce) et profondeurs vendues sans elle → { eur, sans : [mm] }, sinon null */
  function reducRegle(A) {
    var rg = regleRetenue(A); if (!rg || !(num(rg.reducProfEur) > 0)) return null;
    return { eur: num(rg.reducProfEur), sans: String(rg.reducProfSans || '').split(/[,;\s]+/).map(num).filter(function (v) { return v > 0; }) };
  }
  /* plafond « jamais plus cher » (A-193, AUDIT Tour 622) : la profondeur vendue de référence d'une pièce de profondeur P, la
     plus petite des profondeurs standard de la règle au moins égale à P et au palier de la règle (« depth_800 » : 800) ;
     plan : 300-799 → 800, 801-1 199 → 1 200 ; null au-delà */
  function capProf(A, P) {
    var r = depthMinRule(A), m = r && /_(\d+)(?:_|$)/.exec(r.id), pal = m ? num(m[1]) : 800, tb = depthTable(A); if (!tb) return null;
    var std = tb.std.map(function (o) { return num(o.depth_mm); }).filter(function (v) { return v >= Math.max(P, pal); }).sort(function (a, b) { return a - b; });
    return std.length ? std[0] : null;
  }
  /* pièce de chaque profondeur du moteur (nom de la ligne de mise à la profondeur) */
  function pieceDeCle(S, k) {
    if (S.layout === 'angle') return { P1: 'plan principal', P2: 'retour' }[k];   /* R148-b4 : comme le dessin et les cases */
    if (S.layout === 'u-shape') return { Pl: 'jambe gauche', Pc: 'fond', Pr: 'jambe droite' }[k];
    if (S.layout === 'g-shape') { var R = S.gDir !== 'left'; return { Pgtop: 'plan du haut', Pgreturn: 'retour', Pgleft: R ? 'montant gauche' : 'montant droit', Pgright: R ? 'montant droit' : 'montant gauche' }[k]; }
    return 'plan';
  }
  /* Plafond du plan : une profondeur hors standard ne coûte jamais plus que la profondeur standard du dessus, de même
     épaisseur et de même longueur.
     - 631–799 et 801–1 199 : prix au mètre du 800 et du 1 200, donc leur facturation minimale (0,3 ml) ;
     - 300–599 : 0,5 ml au moins, sauf si un 800 coûte moins (pièce courte) : prix du 800 (capP80) ;
     - découpé dans un 800 (chant arrière) : minimum du 800. */
  function standardDessus(v) { return (v > 630 && v < 800) || (v > 800 && v < 1200); }
  function depthMinMl(A) {
    var rule = depthMinRule(A); if (!rule) return 0;
    var p80 = rule.id === 'depth_800';
    if (p80 && (backP80(A) || capP80(A))) return rule.std;
    var std = depthTable(A).std.map(function (o) { return num(o.depth_mm); }), keys = DEPTH_KEYS[A.S.layout] || [];
    var hors = function (v) { return v > 0 && std.indexOf(v) < 0 && !(p80 && standardDessus(v)); };
    return keys.some(function (k) { return hors(num(A.S[k])); }) ? rule.hors : rule.std;
  }
  /* tarif de profondeur (€/ml, à l'épaisseur choisie) et prix d'un plan droit de profondeur P, en centimes : base +
     profondeur + épaisseur sur la longueur facturée (mêmes arrondis que le moteur) ; le reste ne dépend pas de P */
  function depthRateAt(A, P) {
    var tb = depthTable(A); if (!tb) return 0;
    var o = tb.std.filter(function (x) { return num(x.depth_mm) === P; })[0] ||
      tb.cst.filter(function (x) { return P >= num(x.min_mm) && P <= num(x.max_mm || 99999); })[0];
    return o ? num(o.extraPrice) : 0;
  }
  function prixLin(A, P) {
    var r = depthMinRule(A), std = depthTable(A).std.map(function (o) { return num(o.depth_mm); });
    var mn = (std.indexOf(P) >= 0 || standardDessus(P)) ? r.std : r.hors, L = num(A.S.L), mm = Math.max(L, mn);
    var cm = Math.max(Math.round(L / 10), Math.ceil(mn / 10)), u = num(A.getUnitPriceCents && A.getUnitPriceCents()), e = thkExtra(A.S.thk);
    return cm * u + Math.round(depthRateAt(A, P) * mm / 10) + Math.round(e * mm / 10);
  }
  /* plan droit de 300 à 599 mm, sans chant arrière, plus cher qu'un 800 (pièce courte, minimum de 0,5 ml) : prix du 800 */
  function capP80(A) {
    if (!A || !A.S || A.S.layout !== 'linear' || sellsBySurface(A)) return false;
    var r = depthMinRule(A); if (!r || r.id !== 'depth_800') return false;
    var P = num(A.S.P), L = num(A.S.L);
    if (!(P >= 300 && P < 600) || !(L > 0 && L < r.hors) || backP80(A)) return false;
    return prixLin(A, P) > prixLin(A, 800);
  }
  /* Chant arrière d'un plan stratifié droit de moins de 800 mm : le tarif ne finit qu'un côté des plans de 600 et 630 ;
     un arrière fini impose un plan de 800 réduit. Le plan coûte alors EXACTEMENT un 800 de même épaisseur et de même
     longueur : supplément de profondeur du 800, sans le supplément de chant de l'arrière, même facturation minimale
     (600 et 630 sont standard, comme 800). Le sur-mesure 631–799 a déjà le prix du 800. Plan droit seulement. */
  var b80Force = null;                                 /* prix « avec » / « sans » l'arrière, calculés avant le clic */
  function backP80Ok(A) {
    if (!A || !A.S || A.S.layout !== 'linear' || sellsBySurface(A)) return false;
    var r = depthMinRule(A); if (!r || r.id !== 'depth_800') return false;
    return num(A.S.P) > 0 && num(A.S.P) < 800;
  }
  function backP80(A) {
    if (!backP80Ok(A)) return false;
    if (b80Force !== null) return b80Force;
    var el = A.dims && A.dims.querySelector ? A.dims.querySelector('.edge-checkbox-visual[data-edge="back"]') : null;
    return el ? el.classList.contains('checked') : !!(A.S.edgeBanding && A.S.edgeBanding.back);
  }
  /* Même règle en L, en U et en G, pièce par pièce : chaque pièce de moins de 800 mm dont l'arrière est chanté coûte un
     800 de même épaisseur et de même longueur (supplément de profondeur du 800 sur sa longueur réelle, sans le
     supplément de chant de cet arrière). Chant libre -> pièce (relevé sur toutes les jonctions ; les bouts ne comptent
     pas) ; pièce -> profondeur du moteur (G à gauche : le montant de gauche porte Pgright). */
  var ARR_KEYS = {
    angle: { back: 'plan', angleReturn: 'retour' },
    'u-shape': { backMidU: 'fond', backflol_right: 'fond', backolfl_left: 'fond', sideLeftU: 'gauche', sideLeftUBot: 'gauche', sideRightU: 'droite', sideRightUBot: 'droite' },
    'g-right': { backRightG_FF: 'haut', backMidG_FO: 'haut', backMidG_OF: 'haut', backLeftG_OO: 'haut', sidesLeftG_F: 'gauche', leftSideBottomG_O: 'gauche',
      rightSideBottomG_FF: 'droite', rightSideMidG_FO: 'droite', sidesRightG_OF: 'droite', rightSideTopG_OO: 'droite', frontReturnBottomG_F: 'retour', frontReturnRightComboG_O: 'retour' },
    'g-left': { backRightGL_FF: 'haut', backMidGL_FO: 'haut', backMidGL_OF: 'haut', backLeftGL_OO: 'haut', sidesRightRightGL_FF: 'gauche', rightSideBottomGL_OF: 'gauche',
      rightSideMidGL_OO: 'gauche', rightSideTopGL_FO: 'gauche', leftSideBottomGL_F: 'droite', sidesLeftRightGL_O: 'droite', frontReturnBottomGL_F: 'retour', frontRightBottomGL_FO: 'retour', frontRightComboGL_OO: 'retour' }
  };   /* A-419 (AUDIT 00:1x) : rightSideTopGL_FO, miroir de rightSideTopG_OO (bord arrière du montant, Montant filant / Montant filant / Retour filant) */
  function arrTable(S) { return S.layout === 'g-shape' ? ARR_KEYS[S.gDir === 'left' ? 'g-left' : 'g-right'] : ARR_KEYS[S.layout] || null; }
  function arrDepthKey(S, piece) {
    if (S.layout === 'angle') return { plan: 'P1', retour: 'P2' }[piece];
    if (S.layout === 'u-shape') return { gauche: 'Pl', fond: 'Pc', droite: 'Pr' }[piece];
    var R = S.gDir !== 'left';
    return { haut: 'Pgtop', retour: 'Pgreturn', gauche: R ? 'Pgleft' : 'Pgright', droite: R ? 'Pgright' : 'Pgleft' }[piece];
  }
  function pieceNom(S, piece) {                        /* « Le retour », « La jambe gauche »… */
    if (S.layout === 'u-shape' && (piece === 'gauche' || piece === 'droite')) return 'La jambe ' + piece;
    if (S.layout === 'g-shape' && (piece === 'gauche' || piece === 'droite')) return 'Le montant ' + (piece === 'gauche' ? 'gauche' : 'droit');
    /* R148-b4 (AUDIT Tour 1126) : sur un L, « le plan principal », comme le dessin et les cases (« Chant arrière du plan principal
       (découpé dans un plan de 800 mm) », « Profondeur du plan principal … ») */
    return { plan: S.layout === 'angle' ? 'Le plan principal' : 'Le plan', retour: 'Le retour', fond: 'Le fond', haut: 'Le plan du haut' }[piece] || 'Le plan';
  }
  function pieceDe(S, piece) { return pieceNom(S, piece).replace(/^Le /, 'du ').replace(/^La /, 'de la '); }
  var arrForce = null;                                 /* { cle, on } : prix avec / sans ce chant, calculés avant le clic */
  function arrOk(A) {
    if (!A || !A.S || !arrTable(A.S) || sellsBySurface(A)) return false;
    var r = depthMinRule(A); return !!r && r.id === 'depth_800';
  }
  /* case d'arrière que le moteur facture en supplément (updateTdOptionsList) : case active, ou case imposée par un coin
     usiné (désactivée, raison « edge ») ; pas une case verrouillée au produit, ni imposée par « tous les chants » ou par
     la profondeur (ces chants-là sont compris) */
  function arrFacture(A, el, k) {
    if (!el) return false;
    if (!el.classList.contains('disabled')) return true;
    if (el.dataset.forceReason !== 'edge') return false;
    var E = A._eff || {}, lay = A.S.layout || 'linear';
    var pre = lay === 'linear' ? 'linear_' : lay === 'angle' ? 'angle_' : lay === 'u-shape' ? 'u_' : (/GL(?:_|$)/.test(k) ? 'gl_' : 'g_');
    if ((E.bandingLocked || {})[pre + k] === true || E.forceAllBanding === true) return false;
    var ff = num(E.forceBandingFromDepth), dk = arrDepthKey(A.S, arrTable(A.S)[k]);
    return !(ff > 0 && num(A.S[dk]) >= ff);
  }
  function arrPieces(A) {                              /* pièces de moins de 800 mm à l'arrière chanté : [{ cle, piece, dk }] */
    if (!arrOk(A) || !A.dims || !A.dims.querySelector) return [];
    var S = A.S, T = arrTable(S), out = [], seen = {};
    Object.keys(T).forEach(function (k) {
      var el = A.dims.querySelector('.edge-checkbox-visual[data-edge="' + k + '"]');
      if (!arrFacture(A, el, k)) return;
      var on = (arrForce && arrForce.cle === k) ? arrForce.on : el.classList.contains('checked');
      var dk = arrDepthKey(S, T[k]), P = num(S[dk]);
      if (!on || !(P > 0 && P < 800) || seen[dk]) return;
      seen[dk] = true; out.push({ cle: k, piece: T[k], dk: dk });
    });
    return out;
  }
  /* A-323 (lot « messages 1 », L78) : la règle s'applique sous le palier de la règle (« depth_800 » : 800 mm), pour toutes les
     formes ; le seuil est lu dans l'identifiant de la règle, dit en cm */
  function backAide(A) {
    var r = depthMinRule(A), m = r && /_(\d+)$/.exec(r.id), cm = String((m ? Number(m[1]) : 800) / 10).replace('.', ',') + NB + 'cm';
    return 'Le chant arrière n\'est utile que si l\'arrière du plan reste visible : îlot, péninsule, plan décollé du mur. ' +
      'Contre un mur, la crédence ou un joint couvre ce bord. Sur un plan de moins de ' + cm + ' de profondeur, le chant arrière impose ' +
      'une fabrication dans un plan de ' + cm + ' : le prix au mètre devient celui de la profondeur ' + cm + '.';
  }
  /* plan de 300 à 599 mm plafonné : la ligne de profondeur (calculée au palier 800) dit la profondeur choisie */
  function capOptions(A) {
    if (!capP80(A)) return;
    var td = document.getElementById('td-options'); if (!td) return;
    Array.prototype.forEach.call(td.querySelectorAll('li'), function (li) {
      var t = li.textContent.replace(/[\s  ]+/g, ' ').trim();
      if (/^Profondeur 800 mm :/.test(t)) li.textContent = t.replace(/^Profondeur 800 mm/, 'Profondeur ' + fmtMm(num(A.S.P)) + ' mm (au prix d\'un plan de 800 mm, moins cher ici)');
    });
  }
  /* A-368 (AUDIT Tours 824 et 826, COMMERCIAL Tour 144) : la ligne du plan de 800 (« Chant arrière (découpé dans un plan de
     800 mm) : ml × 120 €/ml ») portait aussi le supplément de la profondeur choisie, alors que la case dit l'écart. Elle se
     partage, même somme :
     - profondeur sans supplément (600) : la ligne seule, au tarif du 800, comme la case ;
     - supplément sous celui du 800 (630) : « Profondeur 630 mm : ml × 5 €/ml », puis le chant au tarif de la case (120 − 5) ;
     - déjà au tarif du 800 (631 à 799) : la ligne de profondeur, puis « … : compris, sans supplément » (jamais « +0,00 € »).
     En L, U et G, pièce par pièce, avec les noms de N22 (« Profondeur du plan … », « Chant arrière du plan (…) »). */
  function arrDeux(A, li, t, P, nomProf) {
    var m = t.match(/^(.+?) : ([\d,]+) ml × ([\d .,]+) €\/ml = \+([\d .,]+) €$/), x = depthRateAt(A, P);
    if (!m || !(x > 0) || !(P > 0 && P < 800)) { if (li.textContent !== t) li.textContent = t; return; }
    var ml = parseFr(m[2]), tot = Math.round(parseFr(m[4]) * 100), cp = Math.min(tot, Math.round(x * ml * 100)), y = depthRateAt(A, 800) - x;
    li.textContent = nomProf + ' ' + fmtMm(P) + ' mm : ' + mlTxt(ml) + NB + 'ml × ' + rate(x) + NB + '€/ml = +' + eur(cp / 100) + NB + '€';
    var n = document.createElement('li');
    n.textContent = y > 0 && tot > cp ? m[1] + ' : ' + mlTxt(ml) + NB + 'ml × ' + rate(y) + NB + '€/ml = +' + eur((tot - cp) / 100) + NB + '€'
      : m[1] + ' : compris, sans supplément';
    li.parentNode.insertBefore(n, li.nextSibling);
  }
  /* après le calcul du moteur : ligne de profondeur renommée, supplément de chant de l'arrière retiré, aide affichée */
  function backP80Options(A) {
    backEcoutes(); setTimeout(function () { try { backTag(A); } catch (e) { console.warn('[cp-plan]', e); } }, 0);   /* après le rendu */
    var on = backP80(A), nArr = on ? 1 : arrPieces(A).length, aide = document.getElementById('cp-back-aide');
    if (!nArr) { if (aide && aide.parentNode) aide.parentNode.removeChild(aide); return; }
    var td = document.getElementById('td-options');
    if (td) {
      var pieces = on ? [] : arrPieces(A);
      Array.prototype.forEach.call(td.querySelectorAll('li'), function (li) {
        var t = li.textContent.replace(/[\s  ]+/g, ' ').trim(), m, pe;
        if (on && /^Profondeur 800 mm :/.test(t)) arrDeux(A, li, t.replace(/^Profondeur 800 mm/, 'Chant arrière (découpé dans un plan de 800 mm)'), num(A.S.P), 'Profondeur');
        else if (!on && (m = t.match(/^Chant arrière (.+?) \(découpé dans un plan de 800 mm\) : [\d,]+ ml ×/)) &&
          (pe = pieces.filter(function (a) { return pieceDe(A.S, a.piece) === m[1]; })[0])) arrDeux(A, li, t, num(A.S[pe.dk]), 'Profondeur ' + m[1]);   /* A-368, L, U, G */
        else if ((m = lireSupp(t)) && m.lab === 'Chants supp.' && !li.hasAttribute('data-cp-bouts')) {   /* N3 : les deux formes de la ligne ; R191 : pas celle des bouts d'office */
          var u = m.u, n = m.q - nArr;                                       /* un supplément de chant par arrière */
          (A._cpChantsRetires = A._cpChantsRetires || []).push.apply(A._cpChantsRetires, on ? ['back'] : pieces.map(function (a) { return a.cle; }).slice(0, nArr));   /* R148-b2 */
          A.S.optionsTotalCents = num(A.S.optionsTotalCents) - nArr * u;
          if (n > 0) li.textContent = ligneSupp('Chants supp.', n, u);
          else li.parentNode.removeChild(li);
        }
      });
      var sum = td.querySelector('.td-options-dropdown > summary'), tot = num(A.S.optionsTotalCents);
      if (sum) sum.textContent = 'Suppléments : ' + (tot < 0 ? '−' : '+') + eur(Math.abs(tot) / 100) + '€';   /* signe du total (L73) : jamais « +- » */
    }
    var host = document.getElementById('cp-stage-extras') || (document.getElementById('stage') && document.getElementById('stage').parentNode);
    if (!host) return;
    if (!aide) { aide = document.createElement('p'); aide.id = 'cp-back-aide'; aide.setAttribute('role', 'note'); aide.style.cssText = 'margin:0;font-size:13px;line-height:1.45;color:#374151'; host.appendChild(aide); }
    var ta = backAide(A);
    if (aide.textContent !== ta) aide.textContent = ta;
    if (host.hidden) host.hidden = false;
  }
  /* Prix du chant arrière annoncé AVANT le clic : nom accessible et bulle de survol de la pastille. Au clic, bulle
     ancrée sur le bord, toujours dans l'écran (au-dessus de la barre de prix du bas), avec [Garder] et [Annuler]
     (Annuler décoche). La pastille est recréée à chaque rendu : on la retrouve par sa clé. */
  var backBulle = null, backBulleCle = null, backTip = null, backEcoute = false, BACK_SEL = '.edge-checkbox-visual[data-cp-b80]';
  /* pastilles d'arrière concernées : l'arrière du plan droit, ou ceux des pièces du L, du U et du G */
  function backCles(A) {
    if (backP80Ok(A)) return ['back'];
    return arrOk(A) ? Object.keys(arrTable(A.S)).filter(function (k) { var P = num(A.S[arrDepthKey(A.S, arrTable(A.S)[k])]); return P > 0 && P < 800; }) : [];
  }
  function backPastille(A, cle) {
    return A && A.dims && A.dims.querySelector ? A.dims.querySelector('.edge-checkbox-visual[data-edge="' + (cle || 'back') + '"]') : null;
  }
  function backCoche(A, cle) {                     /* l'arrière de cette pastille est-il facturé au palier 800 ? */
    return A.S.layout === 'linear' ? backP80(A) : arrPieces(A).some(function (a) { return a.cle === cle; });
  }
  function backPrix(A, cle) {                      /* écart du clic : €/ml et montant pour ce plan (minimum compris) */
    if (A.S.layout === 'linear') {                 /* plan droit : total avec (prix du 800) moins total sans (plafonné) */
      var P0 = num(A.S.P), avec = prixLin(A, 800), sans = Math.min(prixLin(A, P0), avec), r0 = depthMinRule(A);
      var ml0 = depthRateAt(A, 800) - depthRateAt(A, P0), ici0 = (avec - sans) / 100;
      /* la facturation minimale change avec l'arrière (300–599 court) : le montant seul, sans tarif au mètre */
      var parMl = Math.abs(ml0 * Math.max(num(A.S.L), r0 ? r0.std : 0) / 1000 - ici0) < 0.01;
      return { ml: ml0, ici: ici0, P: P0, piece: null, sansMl: !parMl };
    }
    var on, off, T = arrTable(A.S);
    try { arrForce = { cle: cle, on: true }; on = A.calculateDepthSupplements(); arrForce = { cle: cle, on: false }; off = A.calculateDepthSupplements(); }
    finally { arrForce = null; }
    var P = num(A.S[arrDepthKey(A.S, T[cle])]);
    return { ml: depthRateAt(A, 800) - depthRateAt(A, P), ici: Math.round(num(on && on.total) - num(off && off.total)) / 100, P: P, piece: T[cle] };
  }
  function eurCourt(n) { return (Math.round(n * 100) % 100 ? eur(n) : rate(Math.round(n))) + NB + '€'; }
  /* R148-b3 (COMMERCIAL, docs\commercial-r148b3-textes.md) : « Chant du bord arrière : brut. Cocher pour le finir, +120 €/ml (+288 €
     ici). » ; cochée : « … : fini, … » */
  function backTexte(A, p, on) {
    /* A-416 : sur un L, « plan principal », comme les autres noms de la page */
    var nom = 'Chant du bord arrière' + (p.piece ? ' ' + pieceDe(A.S, p.piece) : ''), etat = on ? 'fini' : 'brut. Cocher pour le finir';
    if (!(p.ici > 0)) return nom + ' : ' + etat + ', sans supplément ici (déjà au prix d\'un plan de 800 mm).';
    return nom + ' : ' + etat + ', +' + (p.sansMl ? eurCourt(p.ici) + ' ici' : rate(p.ml) + NB + '€/ml (+' + eurCourt(p.ici) + ' ici)') + '.';
  }
  function backTag(A) {
    backCles(A).forEach(function (cle) {
      var el = backPastille(A, cle); if (!el || el.classList.contains('disabled')) return;
      var t = backTexte(A, backPrix(A, cle), el.classList.contains('checked'));
      el.setAttribute('aria-label', t); el.setAttribute('data-cp-b80', t); if (el.title !== t) el.title = t;   /* R148-b3 (AUDIT 23:09) : le même texte en title */
    });
    if (backBulle) { if (backCoche(A, backBulleCle)) backSuit(); else backFerme(false); }
  }
  /* R148-b4 (UX 01:03 ; AUDIT Tour 1136) : le texte d'une case d'arrière au palier 800, pour cp-a11y, dès le 1er affichage
     (avant, son nom générique restait le temps du setTimeout de backTag) ; null : pas une case du palier 800 */
  window.CP_texteB80 = function (A, cle, on, dis) {
    A = A || getApp(); if (!A || !A.S || dis || backCles(A).indexOf(cle) < 0) return null;
    return backTexte(A, backPrix(A, cle), !!on);
  };
  function backCss() {
    if (document.getElementById('cp-back-css')) return;
    var st = document.createElement('style'); st.id = 'cp-back-css';
    st.textContent = '#cp-back-tip{position:fixed;z-index:10060;box-sizing:border-box;max-width:min(300px,calc(100vw - 32px));padding:6px 9px;border-radius:6px;background:#111827;color:#fff;font-size:13px;line-height:1.35;pointer-events:none}' +
      '#cp-back-tip[hidden]{display:none}' +
      '#cp-back-bulle{position:fixed;z-index:10060;box-sizing:border-box;width:min(340px,calc(100vw - 32px));padding:14px 14px 12px;border:1px solid #d1d5db;border-radius:10px;background:#fff;color:#1f2937;font-size:14px;line-height:1.45;box-shadow:0 10px 30px rgba(0,0,0,.18)}' +
      '#cp-back-bulle p{margin:0 0 12px}#cp-back-bulle .cp-bb-actions{display:flex;gap:8px;justify-content:flex-end}' +
      '#cp-back-bulle button{min-height:44px;min-width:96px;padding:0 16px;border:1px solid #0d3527;border-radius:6px;background:#fff;color:#0d3527;font:inherit;font-weight:600;cursor:pointer}' +
      '#cp-back-bulle button:focus-visible{outline:3px solid #1F51FF;outline-offset:2px}' +
      '#cp-back-bulle .cp-bb-fl{position:absolute;width:12px;height:12px;box-sizing:border-box;background:#fff;border:solid #d1d5db;transform:rotate(45deg)}';
    document.head.appendChild(st);
  }
  /* place une bulle sous le bord (au-dessus s'il manque la place), dans l'écran, jamais sous la barre de prix */
  function backPlace(box, el, gap) {
    var r = el.getBoundingClientRect(), vw = document.documentElement.clientWidth, bas = window.innerHeight, m = 16;
    var bar = document.getElementById('cp-pricebar'), br = bar ? bar.getBoundingClientRect() : null;
    if (br && br.height > 0 && br.top < bas) bas = br.top;
    var w = box.offsetWidth, h = box.offsetHeight, cx = r.left + r.width / 2;
    var left = Math.max(m, Math.min(vw - m - w, cx - w / 2)), top = r.bottom + gap, dessous = true;
    if (top + h > bas - 8) { top = r.top - gap - h; dessous = false; }
    var t2 = Math.max(8, Math.min(bas - 8 - h, top));
    box.style.left = left + 'px'; box.style.top = t2 + 'px';
    return { dessous: dessous, colle: t2 === top && r.bottom > 0 && r.top < bas, fx: Math.max(14, Math.min(w - 14, cx - left)) };
  }
  function backSuit() {
    if (backTip && !backTip.hidden) backTip.hidden = true;
    if (!backBulle) return;
    var el = backPastille(getApp(), backBulleCle); if (!el) return;
    var r = backPlace(backBulle, el, 12), fl = backBulle.querySelector('.cp-bb-fl'); if (!fl) return;
    fl.style.display = r.colle ? '' : 'none'; fl.style.left = (r.fx - 6) + 'px';
    fl.style.top = r.dessous ? '-7px' : 'auto'; fl.style.bottom = r.dessous ? 'auto' : '-7px';
    fl.style.borderWidth = r.dessous ? '1px 0 0 1px' : '0 1px 1px 0';
  }
  function backTipMontre(el) {
    var t = el.getAttribute('data-cp-b80'); if (!t || backBulle) return;
    backCss();
    if (!backTip) { backTip = document.createElement('div'); backTip.id = 'cp-back-tip'; backTip.setAttribute('aria-hidden', 'true'); document.body.appendChild(backTip); }
    backTip.textContent = t; backTip.hidden = false; backPlace(backTip, el, 10);
  }
  function backTipCache() { if (backTip) backTip.hidden = true; }
  function backFerme(rendFocus) {
    if (!backBulle) return;
    var b = backBulle, cle = backBulleCle; backBulle = null; backBulleCle = null; if (b.parentNode) b.parentNode.removeChild(b);
    if (rendFocus) { var c = backPastille(getApp(), cle); if (c) c.focus({ preventScroll: true }); }
  }
  function backOuvre(A, cle) {
    var el = backPastille(A, cle); if (!el) return;
    var p = backPrix(A, cle); if (!(p.ici > 0)) return;
    backCss(); backFerme(false); backTipCache();
    var b = document.createElement('div'); b.id = 'cp-back-bulle'; b.setAttribute('role', 'dialog'); b.setAttribute('aria-label', 'Chant arrière');
    b.innerHTML = '<span class="cp-bb-fl" aria-hidden="true"></span><p></p><div class="cp-bb-actions">' +
      '<button type="button" data-cp-bb="garder">Garder</button><button type="button" data-cp-bb="annuler">Annuler</button></div>';
    b.querySelector('p').textContent = (p.piece ? pieceNom(A.S, p.piece) : 'Le plan') + ' de ' + fmtMm(p.P) + ' mm a un arrière brut. Pour un arrière chanté, nous découpons un plan de 800 mm : +' +
      eurCourt(p.ici) + '. Utile seulement si l\'arrière reste visible (îlot, plan sans mur).';
    b.addEventListener('click', function (e) {
      var k = e.target && e.target.closest && e.target.closest('[data-cp-bb]'); if (!k) return;
      if (k.getAttribute('data-cp-bb') !== 'annuler') { backFerme(true); return; }
      var c = backPastille(getApp(), cle); backFerme(false);
      if (c && c.classList.contains('checked')) c.click();                    /* le moteur décoche et recalcule */
      setTimeout(function () { var c2 = backPastille(getApp(), cle); if (c2) c2.focus({ preventScroll: true }); }, 0);
    });
    document.body.appendChild(b); backBulle = b; backBulleCle = cle; backSuit();
    var g = b.querySelector('[data-cp-bb="garder"]'); if (g) g.focus({ preventScroll: true });
  }
  function backEcoutes() {
    if (backEcoute) return; backEcoute = true;
    var of = function (e) { return e.target && e.target.closest ? e.target.closest(BACK_SEL) : null; };
    var survol = window.matchMedia ? window.matchMedia('(hover: hover)') : { matches: true };
    /* R148-b3 (AUDIT 23:09) : à la souris, le title de la case dit le texte ; plus de 2e infobulle (#cp-back-tip garde le clavier) */
    document.addEventListener('mouseover', function (e) { var el = of(e); if (el && survol.matches && !el.title) backTipMontre(el); }, true);
    document.addEventListener('mouseout', function (e) { var el = of(e); if (el && !(e.relatedTarget && el.contains(e.relatedTarget))) backTipCache(); }, true);
    document.addEventListener('focusin', function (e) {
      var el = of(e), vis = true; try { vis = !el || el.matches(':focus-visible'); } catch (x) {}
      if (el && vis) backTipMontre(el); else backTipCache();
    });
    document.addEventListener('focusout', function (e) { if (of(e)) backTipCache(); });
    document.addEventListener('click', function (e) {
      var el = of(e);
      if (!el) { if (backBulle && !backBulle.contains(e.target)) backFerme(false); return; }
      backTipCache();
      var avant = el.classList.contains('checked'), cle = el.getAttribute('data-edge');   /* avant le moteur (phase de capture) */
      setTimeout(function () { var A = getApp(); if (avant) backFerme(false); else if (A && backCoche(A, cle)) backOuvre(A, cle); }, 0);
    }, true);
    document.addEventListener('keydown', function (e) { if (backBulle && e.key === 'Escape') { e.stopPropagation(); backFerme(true); } }, true);
    window.addEventListener('scroll', backSuit, { passive: true, capture: true });
    window.addEventListener('resize', backSuit);
  }
  window.CP_surface = function () { var A = getApp(); return A ? { vente_surface: sellsBySurface(A), surface_mm2: Math.round(surfaceMm2(A)) } : null; };

  function buildPlan(A) {
    var S = A.S, d = decor(), v = (A.getSelectedShopifyVariant && A.getSelectedShopifyVariant()) || {};
    var ang = num(S.innerAngle || 90), geo = null, geoU = null, pieces, seamOut = null, seamsU = null, seamsG = null, angU = null, angG = null;
    var raw = null, shf = null;                          /* géométrie brute (repère du dessin, sans décalage) et son recalage */
    if (S.layout === 'angle') {
      geo = geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: ang, jn: junctionOf(S), dir: S.angleDir === 'left' ? 'left' : 'right' });
      /* origine = coin arrière gauche de l'encombrement (en orientation gauche hors équerre,
         le retour peut déborder à gauche du plan : on recale tout en x, y >= 0) */
      var shA = shiftPieces(geo.pieces);
      pieces = shA.pieces; raw = geo.pieces; shf = shA.sh;
      seamOut = geo.seam.map(shA.sh);
    } else if (S.layout === 'u-shape') {
      /* U (6b) : même géométrie que le dessin, angles par coin compris */
      angU = cornerAnglesOf(S);
      var jU = jnUside(S);
      geoU = geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr),
        jl: jU.g, jr: jU.d, aL: angU.g, aR: angU.d });
      var shU = shiftPieces(geoU.pieces);
      pieces = shU.pieces; raw = geoU.pieces; shf = shU.sh;
      seamsU = geoU.seams.map(function (sg) { return sg.map(shU.sh); });
    } else if (S.layout === 'g-shape') {
      /* G : les blocs du moteur se chevauchent en jonction superposée ; le
         modèle prend la géométrie par points du dessin, chaque coin à une seule pièce*/
      var gp = gParams(S), geoG = geomG(gp);            /* angles par coin compris */
      angG = { haut_gauche: gp.aTop, haut_droit: gp.aMid, retour: gp.aRet };
      var shG = shiftPieces(geoG.pieces);
      pieces = shG.pieces; raw = geoG.pieces; shf = shG.sh;
      seamsG = geoG.seams.map(function (sg) { return sg.map(shG.sh); });
    } else if (S.layout === 'linear') {
      /* étagère V2 (cp-etagere) : une pièce par étagère, centrées, repère vu de dessus */
      var gl = typeof window.CP_etagPieces === 'function' ? { pieces: window.CP_etagPieces(S) } : geomLinear({ L: num(S.L), P: num(S.P) }), shL = shiftPieces(gl.pieces);
      pieces = shL.pieces; raw = gl.pieces; shf = shL.sh;
    } else {
      pieces = piecesFromEngine(A);
    }
    /* A-345 : pièces d'angle du tarif (cp-pierre-angle, CP_paGeometrie). Le modèle de commande porte la pièce à 5 côtés et ses
       deux jonctions ; les contrôles qui comparent au dessin du moteur gardent la géométrie sans elle (raw, pieces) */
    var paC = raw && typeof window.CP_paGeometrie === 'function' ? window.CP_paGeometrie(A) : null, gF = geo || geoU || geoG;
    var gPA = paC && gF ? piecesPA(S, gF, raw, paC) : null;
    var rawCmd = gPA ? gPA.pieces : raw, piecesCmd = gPA ? gPA.pieces.map(function (p) { return { id: p.id, role: p.role, pts: p.pts.map(shf) }; }) : pieces;
    /* chants rattachés aux arêtes : origine du dessin = coin haut gauche des blocs du moteur*/
    var bs = (A._cpPieces || []).filter(function (b) { return isFinite(b.x) && isFinite(b.y); });
    var O0 = bs.length ? [Math.min.apply(null, bs.map(function (b) { return num(b.x); })), Math.min.apply(null, bs.map(function (b) { return num(b.y); }))] : null;
    var chantsAretes = (raw && O0) ? mapChants(A, raw, shf, O0) : null;
    if (gPA && chantsAretes) chantsAretes.list = chantsPA(chantsAretes.list, coinsPA(S, gF, paC.coins), shf, paC.K);
    var usinagesSommets = (rawCmd && O0) ? mapCorners(A, rawCmd, shf, O0) : {};
    /*  un coin usiné au bout d'une jonction (onglet) : le segment part du contour réel,
       celui de la découpe du décor, et non du sommet vif supprimé*/
    var trimRaw = function (sg) {
      if (!O0 || !A.svg || !A.svg.querySelector('.cp-trace [data-piece]')) return sg;
      var at = function (t) { return [sg[0][0] + (sg[1][0] - sg[0][0]) * t, sg[0][1] + (sg[1][1] - sg[0][1]) * t]; };
      var ok = function (t) { var q = at(t); return paintedPiece(A, q[0] + O0[0], q[1] + O0[1]) !== null; };
      var edge = function (out, inn) { for (var i = 0; i < 24; i++) { var m = (out + inn) / 2; if (ok(m)) inn = m; else out = m; } return inn; };
      var near = function (q) {                          /* bout porté par un coin usiné (zone de clic du moteur) */
        var P = [q[0] + O0[0], q[1] + O0[1]], e = S.edges || {};
        return Array.prototype.some.call(A.svg.querySelectorAll('rect.hit[data-cp-id]'), function (h) {
          var k = h.getAttribute('data-cp-id'), c = [num(h.getAttribute('x')) + num(h.getAttribute('width')) / 2, num(h.getAttribute('y')) + num(h.getAttribute('height')) / 2];
          return e[k] && e[k] !== 'straight' && len(c, P) < 150;
        });
      };
      var t0 = !near(sg[0]) || ok(0.002) ? 0 : (ok(0.5) ? edge(0, 0.5) : 0), t1 = !near(sg[1]) || ok(0.998) ? 1 : (ok(0.5) ? edge(1, 0.5) : 1);
      return [at(t0), at(t1)];
    };
    if (geo && shf) seamOut = trimRaw(geo.seam).map(shf);
    if (geoU && shf) seamsU = geoU.seams.map(function (sg) { return trimRaw(sg).map(shf); });
    if (seamsG && geoG && shf) seamsG = geoG.seams.map(function (sg) { return trimRaw(sg).map(shf); });
    /*  le fil suit l'AXE de la pièce (le long de son mur, ou du front), pas sa plus longue arête ;
       longueur_axe_mm = étendue de la pièce le long de cet axe*/
    var outPieces = piecesCmd.map(function (p, i) {
      var lg = longest(p.pts), ax = rawCmd && rawCmd[i] && rawCmd[i].axis;
      var fil = ax ? ((Math.atan2(ax[1], ax[0]) * 180 / Math.PI) % 180 + 180) % 180 : lg.deg;
      var o = { id: p.id, role: p.role, contour: p.pts.map(function (q) { return [r2(q[0]), r2(q[1])]; }),
        plus_grande_arete_mm: r2(lg.l), fil_deg: r2(fil), longueur_axe_mm: r2(ax ? axisLength(p.pts, ax) : lg.l), surface_m2: r2(area(p.pts) / 1e6) };
      /* A-345 : la pièce d'angle du tarif, à la pièce : K le long de chaque mur, avant en biais (sommets 3 et 4), fini */
      if (rawCmd && rawCmd[i] && rawCmd[i].coin) o.piece_angle = { coin: rawCmd[i].coin, cote_murs_mm: paC.K, avant: 'en biais, fini', biais_mm: r2(len(p.pts[2], p.pts[3])) };
      return o;
    });

    var tex = d && d.tex, rule = (window.CP_PRODUCT && window.CP_PRODUCT.texRule) || null;
    var qtyCm = A.getBilledQtyCm ? A.getBilledQtyCm(v) : 0;
    var unitCm = A.getUnitPriceCents ? A.getUnitPriceCents() : 0;
    var base = Math.max(0, Math.round(qtyCm * unitCm));
    var sup = Math.round(num(S.optionsTotalCents));
    var q = Math.max(1, parseInt(S.orderQty, 10) || 1);
    var lignes = Array.prototype.map.call(document.querySelectorAll('#td-options li'), function (li) { return li.textContent.replace(/\s+/g, ' ').trim(); });

    var nfP = notchFini(A);                              /* encoche finie proposée par la règle : finition de chaque encoche */
    var edges = {}; Object.keys(S.edges || {}).forEach(function (k) {
      var t = S.edges[k]; if (!t || t === 'straight') return;
      edges[k] = { type: t };
      if (t === 'round1') edges[k].rayon_mm = num(S.roundRadius) || 30;
      if (t === 'bevel' && S.bevel && S.bevel[k]) edges[k].dim = S.bevel[k];
      if (t === 'biais') {                                 /* hors équerre d'un bout (cp-pierre-angle) : tout le bout coupé, du retrait le long du mur_avant (avant au coin avant, arrière au coin arrière) jusqu'à l'autre coin */
        edges[k].retrait_mm = num(S.cpBiais && S.cpBiais[k]);
        edges[k].mur_avant = typeof window.CP_biaisMur === 'function' ? window.CP_biaisMur(k) : 'horizontal';
      }
      if (t === 'notch' && S.notch && S.notch[k]) { var nk = S.notch[k]; edges[k].dim = ('fini' in nk) ? { dx: nk.dx, dy: nk.dy, offset: nk.offset } : nk; }
      if (t === 'notch' && nfP) edges[k].finition = estFinie(A, k) ? 'finie' : 'brute';
      if (usinagesSommets[k]) { edges[k].pieces = usinagesSommets[k].pieces; edges[k].sommet = usinagesSommets[k].sommet; }    
    });
    /* chants : seulement ceux de la forme affichée. Après un changement de forme,
       S.edgeBanding garde à true les clés de l'ancienne : on ne
       retient que les clés qui ont une case dans le dessin courant.*/
    var dessin = drawnEdges(A);
    var chants = Object.keys(S.edgeBanding || {}).filter(function (k) {
      return S.edgeBanding[k] === true && (!dessin.all.length || dessin.all.indexOf(k) >= 0);
    }).sort();

    var plan = {
      schema: 'plan_v1',
      unite: 'mm',
      origine: 'coin arrière gauche de l\'encombrement ; x vers la droite, y vers l\'avant',
      produit: {
        handle: (window.__PRODUCT__ && window.__PRODUCT__.handle) || '',
        variante_id: v.id || null, variante_titre: v.title || null, sku: v.sku || null,
        decor: d ? { nom: d.name, ref_interne: refVariante(d, v) || d.ref || null,
          texture: tex ? { l_mm: tex.l, h_mm: tex.h, fil_image: tex.fil,
            echelle: rule ? rule.echelle : '1 px = 1 mm', echelle_statut: rule ? rule.statut : 'à confirmer',
            fil_statut: 'estimé' } : null } : null
      },
      forme: { type: S.layout, orientation: S.layout === 'angle' ? (S.angleDir || 'right') : (S.gDir || null),
        angle_deg: S.layout === 'angle' ? ang : null,
        angles_deg: angU ? { gauche: angU.g, droite: angU.d } : angG,
        dessin: S.layout === 'angle' ? 'tracé par points (angle réel)' : ((S.layout === 'u-shape' || S.layout === 'g-shape') ? 'tracé par points (angles réels par coin)' : 'tracé par points') },
      epaisseur_mm: { valeur: num(S.thk), gamme: d ? d.thk : null },   /*  plus de clé « source » dans le code servi (valeurs du client, lues par personne)*/
      cotes: { valeurs: cotes(S) },
      pieces: outPieces,
      jonctions: S.layout === 'angle' ? [{ entre: ['plan', 'retour'], type: junctionOf(S),
        segment: seamOut.map(function (q) { return [r2(q[0]), r2(q[1])]; }) }] :
        (S.layout === 'u-shape' ? [
          { entre: ['gauche', 'fond'], type: jnUside(S).g, segment: seamsU[0].map(function (q) { return [r2(q[0]), r2(q[1])]; }) },
          { entre: ['fond', 'droite'], type: jnUside(S).d, segment: seamsU[1].map(function (q) { return [r2(q[0]), r2(q[1])]; }) }] :
        (S.layout === 'g-shape' ? (function () {
          var seg = function (i) { return seamsG[i].map(function (q) { return [r2(q[0]), r2(q[1])]; }); };
          var jg = jnGside(S);
          return [{ entre: geoG.between[0], type: jg.top, segment: seg(0) },
                  { entre: geoG.between[1], type: jg.mid, segment: seg(1) },
                  { entre: geoG.between[2], type: jg.ret, segment: seg(2) }];
        })() : [])),
      chants: chants,
      chants_aretes: chantsAretes ? chantsAretes.list.concat(cornerChants(outPieces, edges, chantsAretes.list)) : null,   /*  + chant des coins usinés*/
      usinages: edges,
      evier: S.sink && S.sink.sinkId ? S.sink : null,
      jambages: S.legs && (S.legs.left || S.legs.right)                   /*  chaque jambage avec ses dimensions*/
        ? (typeof window.CP_legs === 'function' ? Object.assign({}, S.legs, { pieces: window.CP_legs(A) }) : S.legs) : null,
      fixation: typeof window.CP_fixation === 'function' ? window.CP_fixation() : null,   /* étagère (cp-etagere) */
      facturation: sellsBySurface(A)                     /*  panneaux à la surface*/
        ? { unite: 'dm²', qte_dm2: qtyCm, surface_mm2: Math.round(surfaceMm2(A)), minimum_m2_par_panneau: minM2(A) || null, minimum_applique: minApplied(A),
            regle_arrondi: minM2(A) ? 'surface des pièces (au moins ' + minM2(A) + ' m² par panneau) arrondie au dm² le plus proche' : 'surface des pièces arrondie au dm² le plus proche',
            prix_dm2_centimes: unitCm, base_centimes: base, supplements_centimes: sup, unitaire_centimes: base + sup, quantite: q, total_centimes: (base + sup) * q, lignes: lignes }
        /* A-276 : plans joints (cp-pierre-angle) : quantité facturée = somme des pièces arrondies au cm (lignes du panier),
           et non la longueur des cotes ; la base reste celle du moteur, l'écart est dans les suppléments */
        : { qte_cm: (typeof window.CP_plansFactureCm === 'function' && window.CP_plansFactureCm()) || qtyCm, prix_cm_centimes: unitCm, base_centimes: base, supplements_centimes: sup,
            unitaire_centimes: base + sup, quantite: q, total_centimes: (base + sup) * q, lignes: lignes,
            minimum_ml: minMl(A) ? minMl(A) / 1000 : null, minimum_applique: !!(minMl(A) && num(A.getTotalLengthMm && A.getTotalLengthMm()) < minMl(A)) },
      propose: [
        'échelle des décors : 1 px = 1 mm à confirmer par la mesure d\'une répétition du motif sur un échantillon',
        'sens du fil des images : estimé par analyse d\'image'
      ]
    };
    if (typeof window.CP_etagModel === 'function') plan.etageres = window.CP_etagModel();   /* étagère V2 : rang, longueur, cm facturés, hauteur, supports */
    var boisM = typeof window.CP_boisModel === 'function' ? window.CP_boisModel() : null;   /* R133 : panneaux de boiserie (cp-etagere) ; null ailleurs */
    if (boisM) plan.boiserie = boisM;
    var ilP = typeof window.CP_ilot === 'function' ? window.CP_ilot() : null;              /* îlot en pierre (cp-pierre-angle) */
    if (ilP) plan.ilot = ilP.forme                                                          /* L et U : surface des pièces, coin compté une fois */
      ? { forme: ilP.forme, profondeur_mm: ilP.P, prix_m2_euros: ilP.m2, surface_m2: ilP.surface_m2, pieces: ilP.pieces, jonctions_droites: ilP.jonctions,
          jonction: ilP.jonction, total_centimes: ilP.total_cents, supplement_centimes: ilP.supplement_cents, chants: 'tous compris', calcul: ilP.texte }
      : { profondeur_mm: ilP.P, prix_m2_euros: ilP.m2, cm_factures: ilP.qCm, minimum_m: ilP.min_m != null ? ilP.min_m : 0.3, total_centimes: ilP.total_cents,
          supplement_centimes: ilP.supplement_cents, calcul: ilP.texte,
          /* A-296 (ADMIN 23:26) : sans « chants compris » (HPL), seuls ceux de la règle et l'arrière ; les bouts suivent « chants » */
          chants: ilP.chants_compris ? 'compris : ' + (ilP.chants_compris.length > 1 ? ilP.chants_compris.slice(0, -1).join(', ') + ' et ' + ilP.chants_compris[ilP.chants_compris.length - 1] : ilP.chants_compris.join('')) : 'compris : avant, arrière et les 2 bouts' };
    if (ilP && ilP.arriere) plan.ilot.chant_arriere = true;                                   /* plan droit fini sur 4 côtés par son chant arrière */
    if (ilP && ilP.P_facture) { plan.ilot.profondeur_facturee_mm = ilP.P_facture; plan.ilot.prix_ml_euros = ilP.prix_ml; }   /* R182-b : au prix au mètre de la profondeur du tarif (HPL : 900), profondeur réelle gardée */
    if (ilP && ilP.cotes) plan.ilot.cotes_finis = ilP.cotes;                                   /* A-298 : côtés finis, payés (cochés ou imposés par un coin) ; [] : aucun */
    if (ilP && ilP.d9b) plan.ilot.d9b = { retenu: 'ml', m2_centimes: ilP.d9b.m2_cents, ml_centimes: ilP.d9b.ml_cents, calcul_m2: ilP.d9b.texte_m2 };   /* D9b : prix au mètre, plus élevé que le m² */
    var boP = typeof window.CP_bouts === 'function' ? window.CP_bouts() : null;             /* pierre : choix de chaque bout libre */
    if (boP && boP.length) plan.bouts = boP;
    var boD = bordures(A); if (boD) plan.bordures = boD;                                     /* H18-1 : ajouté d'office à chaque bout (outil A-175) ; sinon pas de clé (AUDIT 20:42:06 : autres fiches identiques à l'octet) */
    var dcP = typeof window.CP_decoupes === 'function' ? window.CP_decoupes() : null;       /* découpes aux cotes du client (cp-decoupes) */
    if (dcP && dcP.length) plan.decoupes = dcP;
    var moP = typeof window.CP_monobloc === 'function' ? window.CP_monobloc() : null;        /* R39-b : évier monobloc (cp-decoupes) : pièces, jonctions, plan facturé */
    if (moP) plan.monobloc = moP;
    if (gPA) {                                               /* A-345 : à un coin à pièce d'angle, ses deux jonctions, bout à bout */
      var IXJ = { L: 0, g: 0, d: 1, top: 0, mid: 1, ret: 2 }, sgJ = function (sg) { return sg.map(function (q) { var m = shf(q); return [r2(m[0]), r2(m[1])]; }); };
      paC.coins.slice().sort(function (a, b) { return IXJ[b] - IXJ[a]; }).forEach(function (c) {
        var two = gPA.seams.filter(function (s) { return s.c === c; }).map(function (s) { return { entre: s.entre, type: 'piece_angle', segment: sgJ(s.segment) }; });
        if (two.length === 2) plan.jonctions.splice.apply(plan.jonctions, [IXJ[c], 1].concat(two));
      });
    }
    plan.controles = checks(A, plan, geo, geoU && { geo: geoU, seams: seamsU, pieces: pieces }, gPA ? gPA.extra : 0);
    /* A-345 : une seule description de fabrication. Avec une pièce d'angle, les pièces du modèle sont celles de la
       Composition et des lignes facturées (cp-pierre-angle, compoOption) : même nombre de pièces d'angle et, la forme
       d'équerre, mêmes longueurs au mm près. Sinon la commande est bloquée (contrôle interne, message unique) */
    var coPA = gPA && typeof window.CP_pierreAngle === 'function' ? (window.CP_pierreAngle() || {}).composition : null;
    if (coPA && coPA.plans) {
      var dPA = plan.pieces.filter(function (p) { return !p.piece_angle; }), nPA = plan.pieces.length - dPA.length;
      var equerre = (plan.forme.angle_deg === null || plan.forme.angle_deg === 90) && !Object.keys(plan.forme.angles_deg || {}).some(function (k) { return plan.forme.angles_deg[k] !== 90; });
      var ecartsPA = coPA.plans.filter(function (x) { return x.mm > 0; }).filter(function (x) {
        var p = dPA.filter(function (q) { return q.id === x.id; })[0];
        return !p || (equerre && Math.abs(p.longueur_axe_mm - x.mm) > 1);
      }).map(function (x) { return x.nom; });
      var okPA = nPA === coPA.pa && !ecartsPA.length;
      plan.controles.push({ id: 'pieces_composition', ok: okPA, bloquant: true, message: okPA
        ? 'Pièces du modèle = Composition = lignes facturées (' + dPA.length + ' plans, ' + nPA + ' pièce' + (nPA > 1 ? 's' : '') + ' d\'angle)'
        : 'Pièces du modèle différentes de la Composition : ' + nPA + ' pièce(s) d\'angle contre ' + coPA.pa + (ecartsPA.length ? ', écart sur ' + ecartsPA.join(', ') : '') });
    }
    if (typeof window.CP_etagControls === 'function') plan.controles = plan.controles.concat(window.CP_etagControls());
    var fin = finitionName(A);                            /*  variante commandée = finition choisie*/
    if (fin && (A.shopifyVariants || []).length) plan.controles.push({ id: 'variante_finition', ok: variantIs(v, fin), bloquant: true, message: variantIs(v, fin)
      ? 'Variante commandée « ' + (v.title || '') + ' » = finition choisie « ' + fin + ' »'
      : 'Variante commandée « ' + (v.title || '?') + ' » différente de la finition choisie « ' + fin + ' »' });
    /*  épaisseur vendue dans ce décor (cp-gamme, métachamp de variante
       custom.epaisseurs_disponibles_mm) ; décor sans donnée : pas de contrôle, trace console dans cp-gamme*/
    var dec = typeof window.CP_currentDecor === 'function' ? window.CP_currentDecor() : null;
    if (dec) {
      /* A-397 (AUDIT Tour 922) : boiserie, le décor de la fiche est celui des panneaux, en 18 mm (S.thk, 38 mm, est celle des
         étagères, dont chaque décor a sa variante « Étagère », contrôlée par cp-etagere) */
      var tk = plan.boiserie ? num(plan.boiserie.epaisseur_mm) : num(S.thk), okT = dec.thk.indexOf(tk) >= 0;
      plan.controles.push({ id: 'decor_epaisseur', ok: okT, bloquant: true, message: okT
        ? 'Décor « ' + dec.name + ' » disponible en ' + tk + ' mm'
        : 'Le décor « ' + dec.name + ' » n\'existe pas en ' + tk + ' mm : choisissez ' + ouListe(dec.thk) + ' mm' });   /* L1 */
    }
    /*  taille maximale du panneau selon le décor (custom.dimensions_max_mm) ; le fil suit L :
       bois, L ≤ l et P ≤ h ; iso, grand côté ≤ l et petit ≤ h (la règle du mélaminé borne déjà P à 1 200)*/
    var dmx = dmaxCheck(A, num(S.L), num(S.P));
    if (dmx) plan.controles.push({ id: 'decor_dimensions', ok: dmx.ok, bloquant: true, message: dmx.ok ? 'Décor « ' + dmx.name + ' » : ' + dmx.lim : dmx.msg });
    if (S.layout === 'g-shape' && geoG) {                /*  le retour ne ferme jamais le G*/
      var seamOkG = geoG.seams.every(function (sg, i) {  /* angles par coin : chaque jonction reste sur le bord de ses deux pièces */
        var two = geoG.between[i].map(function (id) { return geoG.pieces.filter(function (p) { return p.id === id; })[0]; });
        return sg.every(function (q) { return two.every(function (p) { return p && onBoundary(p.pts, q); }); });
      });
      plan.controles.push({ id: 'jonction_portee', ok: seamOkG, bloquant: true, message: 'Jonctions portées par le bord des pièces (écart 0 mm)' });
      var op = Math.round(geoG.opening);
      plan.forme.passage_mm = op;
      plan.controles.push({ id: 'g_ouvert', ok: op > 0, bloquant: true, message: op > 0
        ? 'Le G est ouvert : passage de ' + op + ' mm entre le retour et le montant d\'en face'
        : 'Le retour touche le montant d\'en face : le G est fermé. Raccourcissez le retour ou allongez le plan du haut' });
      if (op > 0) plan.controles.push({ id: 'g_passage', ok: op >= 800, bloquant: false, message: op >= 800
        ? 'Passage de ' + op + ' mm (800 mm conseillés au moins)'
        : 'Passage étroit : ' + op + ' mm entre le retour et le montant d\'en face (800 mm conseillés)' });
    }
    if (chantsAretes) plan.controles.push({ id: 'chants_sur_aretes', ok: !chantsAretes.errors.length, bloquant: true,
      message: chantsAretes.errors.length ? chantsAretes.errors.join(' ; ')
        : 'Chaque chant est sur une arête réelle d\'une pièce, sur toute sa partie visible (' + chantsAretes.list.length + ' arête(s)' +
          (plan.chants_aretes.length > chantsAretes.list.length ? ', plus ' + (plan.chants_aretes.length - chantsAretes.list.length) + ' chant(s) de coin usiné' : '') + ')' });
    /*  prix des usinages du récapitulatif = usinages du modèle (un par coin dessiné, au
       tarif de son type) ; un coin que le moteur oublierait de facturer bloque*/
    var epU = (A._eff || {}).edgePricesEuro || {}, attendu = 0, nbU = 0, sB = semiCompte(A);
    Array.prototype.forEach.call(A.svg ? A.svg.querySelectorAll('rect.hit[data-cp-id]') : [], function (h) {
      var k = h.getAttribute('data-cp-id'), t = (S.edges || {})[k];
      if (CORNER_LINE[t]) { nbU++; if (!(sB && t === 'semi')) attendu += Math.max(0, Math.round((t === 'notch' && nfP && estFinie(A, k) ? nfP.fini : num(epU[t])) * 100)); }
    });
    if (sB) attendu += (sB.bouts + sB.seuls) * Math.max(0, Math.round(num(epU.semi) * 100));   /* demi-rond par bout, seul ou en paire (A-290, comme semiLignes) */
    if (nbU && document.getElementById('td-options')) {
      var lu = cornerLinesCents();
      plan.controles.push({ id: 'prix_usinages', ok: lu === attendu, bloquant: true, message: lu === attendu
        ? 'Usinages facturés : ' + nbU + ' coin(s), ' + (attendu / 100).toFixed(2).replace('.', ',') + ' €'
        : 'Usinages facturés ' + (lu / 100).toFixed(2).replace('.', ',') + ' € au lieu de ' + (attendu / 100).toFixed(2).replace('.', ',') + ' € (' + nbU + ' coin(s) usiné(s))' });
    }
    /*  chaque usinage de coin déclare les pièces qu'il entame (celles du sommet et celles où la
       découpe déborde, relevées dans le dessin) ; un usinage sans pièce déclarée bloque*/
    var usK = Object.keys(plan.usinages || {}).filter(function (k) { return A.svg && A.svg.querySelector('rect.hit[data-cp-id="' + k + '"]'); });
    if (usK.length) {
      var sansPiece = usK.filter(function (k) { return !(plan.usinages[k].pieces && plan.usinages[k].pieces.length); });
      var multi = usK.filter(function (k) { return (plan.usinages[k].pieces || []).length > 1; });
      plan.controles.push({ id: 'usinages_pieces', ok: !sansPiece.length, bloquant: true, message: sansPiece.length
        ? 'Usinage sans pièce rattachée : ' + sansPiece.join(', ')
        : 'Chaque usinage déclare les pièces qu\'il entame' + (multi.length ? ' (' + multi.map(function (k) { return k + ' : ' + plan.usinages[k].pieces.join(' + '); }).join(' ; ') + ')' : '') });
    }
    /*  en filet du rappel au rendu, chaque chanfrein ou encoche dans ses bornes*/
    if (A._cpHitRect && Object.keys(A._cpHitRect).some(function (k) { var t = (S.edges || {})[k]; return t === 'bevel' || t === 'notch'; })) {
      var ovr = machOverruns(A);
      plan.controles.push({ id: 'usinages_bornes', ok: !ovr.length, bloquant: true, message: ovr.length
        ? ovr.join(' ; ')
        : 'Chanfreins et encoches dans leurs bornes (30 mm de matière gardés à l\'extrémité des pièces)' });
    }
    /* U court : aucune pièce plus courte que la longueur minimale de la règle, le long de
       son axe (toutes formes) ; en U, passage conseillé de 800 mm entre les jambes (non bloquant)*/
    var lmin = num(((A._eff || {}).lengthLimits || {}).min);
    if (lmin > 0) {
      var courtes = plan.pieces.filter(function (p) { return num(p.longueur_axe_mm) < lmin - 0.5; });
      plan.controles.push({ id: 'longueur_min_pieces', ok: !courtes.length, bloquant: true, message: !courtes.length
        ? 'Chaque pièce mesure au moins ' + lmin + ' mm le long de son axe'
        : courtes.map(function (p) { return '« ' + p.role + ' » : ' + Math.round(p.longueur_axe_mm) + ' mm de long, ' + lmin + ' mm au moins. Allongez cette partie'; }).join(' ; ') });   /* L5 */
    }
    /*  la longueur maximale de la règle n'était tenue que par la fenêtre de saisie ;
       un état réglé autrement passait (crédence : 4 151 à 4 180 mm acceptés, seule la plaque de 4 180 bloquait)*/
    var lmax = num(((A._eff || {}).lengthLimits || {}).max);
    if (lmax > 0 && S.layout === 'linear') {
      var okMax = num(S.L) <= lmax + 0.5;
      plan.controles.push({ id: 'longueur_max', ok: okMax, bloquant: true, message: okMax
        ? 'Longueur dans la limite du produit (' + lmax + ' mm au plus)'
        : 'Longueur de ' + fmtMm(num(S.L)) + ' mm : ce produit se fabrique jusqu\'à ' + fmtMm(lmax) + ' mm. Réduisez la longueur' });   /* L6 ; T7 (lot « messages 2 ») : espace des milliers */
    }
    if (S.layout === 'u-shape' && geoU) {
      var sgU = geoU.sides, gap = Math.round(Math.min(sgU.d.I1[0] - sgU.g.I1[0], sgU.d.I2[0] - sgU.g.I2[0]));
      plan.forme.passage_mm = gap;
      plan.controles.push({ id: 'u_passage', ok: gap >= 800, bloquant: false, message: gap >= 800
        ? 'Passage de ' + gap + ' mm entre les jambes (800 mm conseillés au moins)'
        : 'Passage étroit : ' + gap + ' mm entre les jambes (800 mm conseillés)' });
    }
    if (A._eff && A._eff.legsSupplementEnabled === false) {   /*  produit sans jambages (crédence, panneau plaqué)*/
      var legsOn = !!(S.legs && (S.legs.left || S.legs.right));
      plan.controles.push({ id: 'jambages_non_proposes', ok: !legsOn, bloquant: true, message: legsOn
        ? 'Ce produit ne se vend pas avec des jambages. Retirez les jambages, ou écrivez-nous'   /* L7 */
        : 'Pas de jambages sur ce produit' });
    }
    if (plan.jambages) {                                  /*  hauteur dans les bornes du champ ; épaisseur du décor*/
      var lb = typeof window.CP_legBounds === 'function' ? window.CP_legBounds() : { min: 100, max: 900 };
      var lh = num(plan.jambages.height), lt = num(plan.jambages.thickness), pt = num(S.thk);
      var lok = typeof window.CP_legThkAllowed === 'function' ? window.CP_legThkAllowed(A) : [pt];
      var okH = lh >= lb.min && lh <= lb.max, okT = lok.indexOf(lt) >= 0;
      plan.controles.push({ id: 'jambages_dimensions', ok: okH && okT, bloquant: true, message: okH && okT
        ? 'Jambages : hauteur ' + lh + ' mm (' + lb.min + ' à ' + lb.max + ' mm), épaisseur ' + lt + ' mm (' + (lt === pt ? 'celle du plan' : 'disponible dans ce décor : ' + lok.join(', ') + ' mm') + ')'
        : [okH ? '' : 'Hauteur des jambages : ' + lh + ' mm. Choisissez de ' + lb.min + ' à ' + lb.max + ' mm',   /* L8 */
           okT ? '' : 'Épaisseur des jambages : ' + lt + ' mm n\'existe pas dans ce décor. Choisissez ' + lok.join(', ') + ' mm'].filter(Boolean).join(' ; ') });   /* L9 */
    }
    /*  jambages de 40 ou 60 mm au tarif ; profondeur au-delà du dernier palier = hors tarif (L10 : ce qu'il faut changer,
       sans « sur devis » ; le motif vient de cp-jambages)*/
    var horsT = ((plan.jambages && plan.jambages.pieces) || []).filter(function (p) { return p.article && p.article.hors_tarif; });
    if (horsT.length || ((plan.jambages && plan.jambages.pieces) || []).some(function (p) { return p.article; })) {
      plan.controles.push({ id: 'jambages_article', ok: !horsT.length, bloquant: true, message: horsT.length
        ? horsT.map(function (p) { return 'Jambage ' + p.cote + ' : ' + p.article.message; }).join(' ; ')
        : 'Jambages : ' + plan.jambages.pieces.map(function (p) { return p.cote + ' ' + p.article.profondeur_tarif; }).join(' ; ') });   /*  ni fournisseur ni code d'article*/
    }
    /*  chaque jambage hors de la partie usinée de son bout, retrait dans ses bornes, et deux
       jambages de la même pièce sans se chevaucher*/
    if (plan.jambages && (plan.jambages.pieces || []).length) {
      var LL = legLimits(plan, plan.jambages.pieces), bad = [], byPiece = {}, introuvables = [];
      plan.jambages.pieces.forEach(function (p) {
        var m = LL[p.cote], r = num(p.retrait_mm);
        if (!m) { introuvables.push('Jambage ' + p.cote + ' : bout introuvable dans le modèle'); return; }   /* L62 : contrôle interne à part */
        p.retrait_min_mm = m.min; p.retrait_max_mm = m.max;
        if (m.raisons.length) p.bout_usine = m.raisons.join(', ');
        if (r < m.min) bad.push('Jambage ' + p.cote + ' trop près du coin découpé (' + m.raisons.join(', ') + ') : à ' + r + ' mm de l\'extrémité, ' + m.min + ' mm au moins. Éloignez-le de l\'extrémité');   /* L11 */
        else if (r > m.max) bad.push('Jambage ' + p.cote + ' à ' + r + ' mm de l\'extrémité : ' + m.max + ' mm au plus. Rapprochez-le de l\'extrémité');   /* L12 */
        (byPiece[m.piece] = byPiece[m.piece] || []).push({ r: r, t: m.epaisseur, lg: m.longueur });
      });
      Object.keys(byPiece).forEach(function (id) {
        var g = byPiece[id]; if (g.length < 2) return;
        var used = g.reduce(function (s, x) { return s + x.r + x.t; }, 0);
        if (used > g[0].lg) bad.push('Les deux jambages de « ' + pieceRole(A, id) + ' » se chevauchent (' + Math.round(used) + ' mm pour ' + g[0].lg + ' mm). Rapprochez-les des extrémités, ou retirez-en un');   /* L13 */
      });
      if (introuvables.length) plan.controles.push({ id: 'jambages_modele', ok: false, bloquant: true, message: introuvables.join(' ; ') });
      plan.controles.push({ id: 'jambages_retrait', ok: !bad.length, bloquant: true, message: bad.length ? bad.join(' ; ')
        : 'Jambages hors des parties usinées : ' + plan.jambages.pieces.map(function (p) {
            return p.cote + ' à ' + num(p.retrait_mm) + ' mm du bout (' + p.retrait_min_mm + ' à ' + p.retrait_max_mm + ' mm)'; }).join(', ') });
    }
    /* A2 : contrôle interne en échec → le message unique, le motif dans « detail » ; les contrôles réussis ne changent pas
       (le modèle d'une commande reste le même) */
    plan.controles.forEach(function (c) { if (!c.ok && INTERNES.test(c.id)) { c.interne = true; c.detail = c.message; c.message = MSG_INTERNE; } });
    return plan;
  }
  /* bornes du retrait des deux bouts, jambage posé ou non (fenêtre des jambages, recul automatique) */
  window.CP_legLimits = function (A) {
    A = A || getApp(); if (!A || !A.S || typeof window.CP_legsAll !== 'function') return {};
    try { return legLimits(buildPlan(A), window.CP_legsAll(A)); } catch (e) { console.warn('[cp-plan]', e); return {}; }
  };

  /* aire de l'intersection de deux polygones CONVEXES (toutes les pièces le sont) :
     découpe de Sutherland–Hodgman, puis formule du lacet */
  function convexOverlap(P, Q) { var z = clipPoly(P, Q); return z.length >= 3 ? Math.abs(area2(z)) / 2 : 0; }
  /* P découpé par le polygone convexe Q (Sutherland–Hodgman) */
  function clipPoly(P, Q) {
    var sgn = area2(Q) > 0 ? 1 : -1, out = P.slice();
    for (var i = 0; i < Q.length && out.length; i++) {
      var a = Q[i], b = Q[(i + 1) % Q.length], inp = out; out = [];
      var side = function (p) { return sgn * ((b[0] - a[0]) * (p[1] - a[1]) - (b[1] - a[1]) * (p[0] - a[0])); };
      for (var j = 0; j < inp.length; j++) {
        var c = inp[j], d = inp[(j + 1) % inp.length], sc = side(c), sd = side(d);
        if (sc >= 0) out.push(c);
        if ((sc >= 0) !== (sd >= 0)) { var t = sc / (sc - sd); out.push([c[0] + t * (d[0] - c[0]), c[1] + t * (d[1] - c[1])]); }
      }
    }
    return out;
  }
  function area2(p) { return p.reduce(function (s, a, i) { var b = p[(i + 1) % p.length]; return s + a[0] * b[1] - b[0] * a[1]; }, 0); }
  /* surface du dessin du moteur : réunion des rectangles de son contour d'assemblage (usinages
     compris dans leur rectangle) ; null si le contour a été remplacé par le tracé (hors d'équerre) */
  function drawnArea(A) {
    var ps = A.svg ? A.svg.querySelectorAll('defs #clip-assembly path') : [];
    if (!ps.length) return null;
    var rs = Array.prototype.map.call(ps, function (p) {
      var b = p.getBBox(), t = (p.getAttribute('transform') || '').match(/translate\(\s*([-\d.]+)[ ,]+([-\d.]+)\s*\)/);
      var dx = t ? +t[1] : 0, dy = t ? +t[2] : 0;
      return [b.x + dx, b.y + dy, b.x + b.width + dx, b.y + b.height + dy];
    });
    var xs = [], ys = [];
    rs.forEach(function (r) { xs.push(r[0], r[2]); ys.push(r[1], r[3]); });
    xs = xs.filter(function (v, i) { return xs.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    ys = ys.filter(function (v, i) { return ys.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    var s = 0;
    for (var i = 0; i < xs.length - 1; i++) for (var j = 0; j < ys.length - 1; j++) {
      var cx = (xs[i] + xs[i + 1]) / 2, cy = (ys[j] + ys[j + 1]) / 2;
      if (rs.some(function (r) { return cx > r[0] && cx < r[2] && cy > r[1] && cy < r[3]; })) s += (xs[i + 1] - xs[i]) * (ys[j + 1] - ys[j]);
    }
    return s;
  }

  /* ── Chants rattachés aux arêtes RÉELLES des pièces ──
     Chaque trait bleu dessiné est rattaché à la case de chant la plus proche (sa clé), puis à
     l'arête de pièce (géométrie par points) qui le porte. Partie exposée d'une arête = l'arête
     moins ses jonctions avec les autres pièces. Un chant doit être sur une arête, jamais sur une
     jonction, et couvrir toute la partie exposée qu'il touche (aux usinages de coin près).*/
  function ivUnion(iv) {
    var s = iv.slice().sort(function (a, b) { return a[0] - b[0]; }), out = [];
    s.forEach(function (c) { var l = out[out.length - 1]; if (l && c[0] <= l[1] + 0.5) l[1] = Math.max(l[1], c[1]); else out.push([c[0], c[1]]); });
    return out;
  }
  function ivMinus(A0, B) {
    var out = A0.map(function (a) { return a.slice(); });
    B.forEach(function (b) {
      var nx = [];
      out.forEach(function (a) {
        if (b[1] <= a[0] || b[0] >= a[1]) { nx.push(a); return; }
        if (b[0] > a[0]) nx.push([a[0], b[0]]);
        if (b[1] < a[1]) nx.push([b[1], a[1]]);
      });
      out = nx;
    });
    return out.filter(function (a) { return a[1] - a[0] > 0.5; });
  }
  function ivLen(iv) { return iv.reduce(function (s, a) { return s + a[1] - a[0]; }, 0); }
  /* pièce dessinée (cp-trace) qui porte le décor au point (x, y) du dessin, après toutes ses découpes
     (contour, usinages du moteur, coins découpés au sommet réel) ; null hors du décor */
  function paintedPiece(A, x, y) {
    var svg = A.svg, id = function (s) { return (s || '').replace(/^url\(#|\)$/g, ''); }, hit = null;
    var inFill = function (n) {
      var p = new DOMPoint(x, y), tl = n.transform && n.transform.baseVal;
      if (tl && tl.numberOfItems) p = p.matrixTransform(tl.consolidate().matrix.inverse());
      return typeof n.isPointInFill === 'function' && n.isPointInFill(p);
    };
    var inClip = function (ref) { var c = svg.querySelector('#' + id(ref)); return !c || Array.prototype.some.call(c.children, inFill); };
    Array.prototype.some.call(svg.querySelectorAll('.cp-trace [data-piece]'), function (g) {
      if (!inClip(g.getAttribute('clip-path'))) return false;
      for (var n = g.firstElementChild; n && n.getAttribute && n.getAttribute('clip-path'); n = n.firstElementChild)
        if (!inClip(n.getAttribute('clip-path'))) return false;
      hit = g.getAttribute('data-piece');
      return true;
    });
    return hit;
  }
  /* trait sur le bord du contour usiné : décor d'un seul côté, à 15, 50 et 85 % ; renvoie la pièce */
  function machinedEdgePiece(A, sg, eps) {
    if (!A.svg || !A.svg.querySelector('.cp-trace [data-piece]')) return null;
    var dx = sg[1][0] - sg[0][0], dy = sg[1][1] - sg[0][1], l = Math.hypot(dx, dy);
    if (l < 0.5) return null;
    var nx = -dy / l * eps, ny = dx / l * eps, pid = null;
    /* la face d'un usinage au sommet d'un onglet est à cheval sur les deux pièces : la pièce retenue est
       celle du milieu du trait ; une jonction (décor des deux côtés) reste refusée */
    var ok = [0.5, 0.15, 0.85].every(function (t) {
      var x = sg[0][0] + dx * t, y = sg[0][1] + dy * t, a = paintedPiece(A, x + nx, y + ny), b = paintedPiece(A, x - nx, y - ny);
      if (!a === !b) return false;
      if (!pid) pid = a || b;
      return true;
    });
    return ok ? pid : null;
  }
  /* plus petite largeur d'un contour convexe (distance au sommet le plus éloigné, minimum sur les arêtes) :
     le petit côté d'un rectangle, même incliné ; la boîte englobante le surestimait hors d'équerre */
  function minWidth(p) {
    return Math.min.apply(null, p.map(function (a, i) {
      var b = p[(i + 1) % p.length], L = len(a, b); if (L < 1e-9) return Infinity;
      return Math.max.apply(null, p.map(function (q) { return Math.abs((q[0] - a[0]) * (b[1] - a[1]) - (q[1] - a[1]) * (b[0] - a[0])) / L; }));
    }));
  }
  function segDist(p, a, b) {
    var dx = b[0] - a[0], dy = b[1] - a[1], L2 = dx * dx + dy * dy, t = L2 ? ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / L2 : 0;
    t = Math.max(0, Math.min(1, t));
    return Math.hypot(p[0] - a[0] - t * dx, p[1] - a[1] - t * dy);
  }
  /* plus grand usinage de coin (arrondi, biseau, encoche) : un chant peut s'arrêter à cette distance du coin */
  /*  hors d'équerre, le tracé du moteur est déformé près du coin (jusqu'à ~10 % : chanfrein de
     50 mm à 85°, chant arrêté à 55 mm) ; la longueur de tangence d'un arrondi va jusqu'à r / tan 42,5°
     (1,09 r). Marge unique : 1,15 × la taille de l'usinage.*/
  var FEAT_K = 1.15;
  function featureAllowance(S, finiteOnly) {              /* finiteOnly : sans les demi-ronds (taille des encoches, chanfreins, arrondis) */
    var f = 0, e = S.edges || {};
    Object.keys(e).forEach(function (k) {
      var t = e[k], b = (S.bevel || {})[k] || {}, n = (S.notch || {})[k] || {};
      if (t === 'round1') f = Math.max(f, num(S.roundRadius) || 30);
      else if (t === 'semi') { if (!finiteOnly) f = Infinity; }
      else if (t === 'bevel') f = Math.max(f, num(b.dx) || 50, num(b.dy) || 50);
      else if (t === 'notch') f = Math.max(f, (num(n.dx) || 50) + (num(n.offset) || 0), num(n.dy) || 50);
    });
    return f * FEAT_K;
  }
  /* A-345 : un chant relevé sur le dessin du moteur (plan et retour jusqu'à l'angle intérieur) garde sa partie sur la pièce
     raccourcie ; la partie devant la pièce d'angle tombe (son avant en biais est fini, compris dans son prix) */
  function chantsPA(list, ks, sh, K) {
    var cut = function (sg, C, d) {
      var f = function (p) { return (p[0] - C[0]) * d[0] + (p[1] - C[1]) * d[1] - K; }, fa = f(sg[0]), fb = f(sg[1]);
      if (fa >= -0.5 && fb >= -0.5) return sg;
      if (fa < -0.5 && fb < -0.5) return null;
      var t = fa / (fa - fb), m = [sg[0][0] + t * (sg[1][0] - sg[0][0]), sg[0][1] + t * (sg[1][1] - sg[0][1])];
      return fa >= -0.5 ? [sg[0], m] : [m, sg[1]];
    };
    var kk = ks.map(function (k) { return Object.assign({}, k, { C: sh(k.C) }); });
    return list.map(function (c) {
      var sg = c.arete, avant = sg;
      kk.forEach(function (k) { var d = c.piece === k.A ? k.u : c.piece === k.B ? k.v : null; if (sg && d) sg = cut(sg, k.C, d); });
      if (sg === avant) return c;
      if (!sg || len(sg[0], sg[1]) < 0.5) return null;
      var L = r2(len(sg[0], sg[1])), o = Object.assign({}, c, { arete: sg.map(function (q) { return [r2(q[0]), r2(q[1])]; }), longueur_chant_mm: Math.min(num(c.longueur_chant_mm), L) });
      if (o.longueur_arete_mm != null) o.longueur_arete_mm = L;
      if (o.longueur_exposee_mm != null) o.longueur_exposee_mm = Math.min(num(c.longueur_exposee_mm), L);
      return o;
    }).filter(Boolean);
  }
  function mapChants(A, raw, sh, O) {
    var marks = A._cpMarks || { lines: [], boxes: [] }, TOL = 3, errs = [], out = [];
    var P = raw.map(function (p) { return { id: p.id, pts: p.pts.map(function (q) { return [q[0] + O[0], q[1] + O[1]]; }) }; });
    var edges = [];
    P.forEach(function (p, i) { p.pts.forEach(function (a, j) { var b = p.pts[(j + 1) % p.pts.length]; if (len(a, b) > 0.5) edges.push({ piece: i, j: j, a: a, b: b, L: len(a, b) }); }); });
    var proj = function (e, q) {
      var ux = (e.b[0] - e.a[0]) / e.L, uy = (e.b[1] - e.a[1]) / e.L, dx = q[0] - e.a[0], dy = q[1] - e.a[1];
      return { t: dx * ux + dy * uy, d: Math.abs(dx * uy - dy * ux) };
    };
    edges.forEach(function (e) {                         /* jonctions : parties d'arête communes à deux pièces */
      var j = [];
      edges.forEach(function (f) {
        if (f.piece === e.piece) return;
        var s = proj(e, f.a), t = proj(e, f.b);
        if (s.d > 1 || t.d > 1) return;
        var lo = Math.max(0, Math.min(s.t, t.t)), hi = Math.min(e.L, Math.max(s.t, t.t));
        if (hi - lo > 1) j.push([lo, hi]);
      });
      e.joint = ivUnion(j);
      e.exposed = ivMinus([[0, e.L]], e.joint);
    });
    var lines = marks.lines.filter(function (el) { return el.isConnected; }).map(function (el) {
      return [[num(el.getAttribute('x1')), num(el.getAttribute('y1'))], [num(el.getAttribute('x2')), num(el.getAttribute('y2'))]];
    });
    var boxes = marks.boxes.filter(function (b) { return b.el && b.el.isConnected; }).map(function (b) {
      var v = b.el.querySelector ? b.el.querySelector('.edge-checkbox-visual') : null;
      return { k: b.k, p: b.p, on: !!(v && v.classList.contains('checked')) };
    });
    var byKey = {};
    lines.forEach(function (l) {                         /* chaque trait -> la case la plus proche */
      var best = null, bd = Infinity;
      boxes.forEach(function (bx) { var d = segDist(bx.p, l[0], l[1]); if (d < bd) { bd = d; best = bx; } });
      if (best) (byKey[best.k] = byKey[best.k] || []).push(l);
    });
    var F = featureAllowance(A.S), keys = [], edgeUse = {};
    /*  la marge d'un chant arrêté court se compte par BOUT d'arête, d'après les coins
       usinés dont le sommet est sur la ligne de cette arête : un usinage retire au plus sa taille (× 1,15)
       depuis son sommet ; ailleurs, aucune marge (une encoche en bas à gauche n'excuse plus un chant
       raccourci à droite).*/
    var feats = [];
    Array.prototype.forEach.call(A.svg ? A.svg.querySelectorAll('rect.hit[data-cp-id]') : [], function (h) {
      var k = h.getAttribute('data-cp-id'), t = (A.S.edges || {})[k]; if (!t || t === 'straight') return;
      var c = [num(h.getAttribute('x')) + num(h.getAttribute('width')) / 2, num(h.getAttribute('y')) + num(h.getAttribute('height')) / 2], best = null;
      P.forEach(function (p) { p.pts.forEach(function (q) { var d = len(q, c); if (!best || d < best.d) best = { d: d, q: q, p: p }; }); });
      if (!best || best.d > 400) return;
      var b = (A.S.bevel || {})[k] || {}, n = (A.S.notch || {})[k] || {};
      var dep = Math.min.apply(null, P.filter(function (p) { return p.pts.some(function (q) { return len(q, best.q) < 1; }); }).map(function (p) { return minWidth(p.pts); }));   /* largeur vraie des pièces du sommet */
      var size = t === 'bevel' ? Math.max(num(b.dx) || 50, num(b.dy) || 50) : t === 'notch' ? Math.max((num(n.dx) || 50) + num(n.offset), num(n.dy) || 50)
        : t === 'round1' ? Math.min(num(A.S.roundRadius) || 30, dep / 2) / Math.tan(42.5 * Math.PI / 180) : dep / 2;
      feats.push({ V: best.q, size: size * FEAT_K });
    });
    var allowAt = function (e, t) {
      var Q = [e.a[0] + (e.b[0] - e.a[0]) * t / e.L, e.a[1] + (e.b[1] - e.a[1]) * t / e.L], m = 0;
      feats.forEach(function (f) {
        var dl = Math.abs((f.V[0] - e.a[0]) * (e.b[1] - e.a[1]) - (f.V[1] - e.a[1]) * (e.b[0] - e.a[0])) / e.L;   /* sommet sur la ligne de l'arête */
        if (dl <= TOL) m = Math.max(m, f.size - len(Q, f.V));
      });
      return m;
    };
    boxes.forEach(function (b) { if (b.on && keys.indexOf(b.k) < 0) keys.push(b.k); });
    keys.sort().forEach(function (k) {
      var segs = byKey[k] || [], perEdge = {};
      if (!segs.length) { if (F === 0) errs.push('chant « ' + k + ' » coché sans trait sur une arête'); return; }
      segs.forEach(function (sg) {
        var hit = null;
        edges.forEach(function (e) {
          if (hit) return;
          var s = proj(e, sg[0]), t = proj(e, sg[1]);
          if (s.d <= TOL && t.d <= TOL && Math.min(s.t, t.t) >= -TOL && Math.max(s.t, t.t) <= e.L + TOL)
            hit = { e: e, iv: [Math.max(0, Math.min(s.t, t.t)), Math.min(e.L, Math.max(s.t, t.t))] };
        });
        if (!hit) {
          /*  faces d'un usinage (encoche, chanfrein…). Le moteur y fait suivre le chant ;
             le contour brut du modèle ne les porte pas. Arête réelle = bord du contour USINÉ, celui de la
             découpe du décor : le décor d'un seul côté du trait, en 3 points. Une jonction
             (décor des deux côtés) reste refusée.*/
          /* tolérance : hors d'équerre (jusqu'à 5°), le moteur trace le tour d'une encoche tourné d'autant
             par rapport à la découpe réelle, soit un écart jusqu'à ~9 % de la taille de l'usinage */
          var face = -1, pid = machinedEdgePiece(A, sg, Math.min(15, 2 * TOL + 0.09 * featureAllowance(A.S, true)));
          if (pid !== null) P.some(function (p, pi) { if (p.id === pid) { face = pi; return true; } return false; });
          if (face >= 0) {
            out.push({ cle: k, piece: P[face].id, usinage: true, arete: sg.map(function (q) { var m = sh([q[0] - O[0], q[1] - O[1]]); return [r2(m[0]), r2(m[1])]; }),
              longueur_chant_mm: r2(len(sg[0], sg[1])) });
            return;
          }
          errs.push('trait du chant « ' + k + ' » hors de toute arête de pièce'); return;
        }
        var id = hit.e.piece + ':' + hit.e.j;
        (perEdge[id] = perEdge[id] || { e: hit.e, iv: [] }).iv.push(hit.iv);
      });
      Object.keys(perEdge).forEach(function (id) {
        var e = perEdge[id].e, cov = ivUnion(perEdge[id].iv), nom = P[e.piece].id;
        (edgeUse[id] = edgeUse[id] || []).forEach(function (u) {        /*  deux clés sur la même arête*/
          var common = ivLen(cov) - ivLen(ivMinus(cov, u.cov));
          if (common > TOL) errs.push('deux chants (« ' + u.k + ' » et « ' + k + ' ») sur la même arête de la pièce ' + nom);
        });
        edgeUse[id].push({ k: k, cov: cov });
        if (ivLen(cov) - ivLen(ivMinus(cov, e.joint)) > TOL) errs.push('chant « ' + k + ' » posé sur une jonction (pièce ' + nom + ')');
        e.exposed.forEach(function (x) {
          var touched = cov.some(function (c) { return Math.min(c[1], x[1]) - Math.max(c[0], x[0]) > 1; });
          if (!touched) return;
          var need = [x[0] + allowAt(e, x[0]) + TOL, x[1] - allowAt(e, x[1]) - TOL];
          if (need[1] > need[0] && ivMinus([need], cov).length)
            errs.push('chant « ' + k + ' » sur une partie seulement d\'une arête de la pièce ' + nom + ' (' + Math.round(ivLen(cov)) + ' mm sur ' + Math.round(x[1] - x[0]) + ')');
        });
        out.push({ cle: k, piece: nom, arete: [e.a, e.b].map(function (q) { var m = sh([q[0] - O[0], q[1] - O[1]]); return [r2(m[0]), r2(m[1])]; }),
          longueur_arete_mm: r2(e.L), longueur_exposee_mm: r2(ivLen(e.exposed)), longueur_chant_mm: r2(ivLen(cov)) });
      });
    });
    return { list: out, errors: errs };
  }

  /*  chaque usinage de coin rattaché à sa (ses) pièce(s) et à son sommet réel. Le coin est
     repéré par la zone de clic du moteur (rect.hit, clé du coin), portée sur le tracé réel ; son
     sommet est le sommet de pièce le plus proche ; toutes les pièces qui ont ce sommet sont listées
     (coin extérieur d'un L en coupe à 45° : plan et retour).*/
  function mapCorners(A, raw, sh, O) {
    var out = {}, P = raw.map(function (p) { return { id: p.id, pts: p.pts.map(function (q) { return [q[0] + O[0], q[1] + O[1]]; }) }; });
    Array.prototype.forEach.call(A.svg ? A.svg.querySelectorAll('rect.hit[data-cp-id]') : [], function (h) {
      var k = h.getAttribute('data-cp-id'), c = [num(h.getAttribute('x')) + num(h.getAttribute('width')) / 2, num(h.getAttribute('y')) + num(h.getAttribute('height')) / 2];
      var best = null;
      P.forEach(function (p) { p.pts.forEach(function (q) { var d = len(q, c); if (!best || d < best.d) best = { d: d, q: q }; }); });
      if (!best || best.d > 400) return;
      var ids = P.filter(function (p) { return p.pts.some(function (q) { return len(q, best.q) < 1; }); }).map(function (p) { return p.id; });
      /*  un usinage qui déborde sur la pièce voisine l'entame aussi (dessin et image)*/
      var t = (A.S.edges || {})[k];
      if (t && t !== 'straight') touchedPieces(A, k, P, best.q, ids).forEach(function (id) { if (ids.indexOf(id) < 0) ids.push(id); });
      var m = sh([best.q[0] - O[0], best.q[1] - O[1]]);
      out[k] = { pieces: ids, sommet: [r2(m[0]), r2(m[1])] };
    });
    return out;
  }
  /*  pièces (autres que celles du sommet) que la découpe d'un usinage entame. La découpe est
     calculée comme dans le dessin (cp-trace, cornerCutPath) : au sommet, le long des deux murs du
     contour (arêtes du sommet qui ne sont pas une jonction), puis croisée avec chaque pièce voisine
     (découpe de Sutherland–Hodgman) ; entamée au-delà de 0,5 mm².*/
  function touchedPieces(A, k, P, V, owners) {
    var S = A.S, dirs = [], unit = function (a, b) { var l = len(a, b) || 1; return [(b[0] - a[0]) / l, (b[1] - a[1]) / l]; }, dep = Infinity;
    P.forEach(function (p, pi) {
      var n = p.pts.length, i = p.pts.findIndex(function (q) { return len(q, V) < 1; }); if (i < 0) return;
      dep = Math.min(dep, minWidth(p.pts));                                    /* largeur vraie (pièce inclinée : pas sa boîte) */
      [p.pts[(i + n - 1) % n], p.pts[(i + 1) % n]].forEach(function (w) {
        var mid = [(V[0] + w[0]) / 2, (V[1] + w[1]) / 2];
        if (P.some(function (o, oi) { return oi !== pi && onBoundary(o.pts, mid); })) return;   /* jonction ou onglet */
        var u = unit(V, w); if (!dirs.some(function (d) { return Math.abs(d[0] - u[0]) < 1e-6 && Math.abs(d[1] - u[1]) < 1e-6; })) dirs.push(u);
      });
    });
    if (dirs.length !== 2) return [];
    var u1 = dirs[0], u2 = dirs[1], t = (S.edges || {})[k], cut = null, at = function (a, b) { return [V[0] + u1[0] * a + u2[0] * b, V[1] + u1[1] * a + u2[1] * b]; };
    var h1 = Math.abs(u1[0]) >= Math.abs(u1[1]);
    if (t === 'bevel' || t === 'notch') {
      var bb = ((t === 'bevel' ? S.bevel : S.notch) || {})[k] || {}, dx = num(bb.dx) || 50, dy = num(bb.dy) || 50, off = t === 'notch' ? num(bb.offset) : 0;
      var a1 = h1 ? dx : dy, a2 = h1 ? dy : dx;
      if (t === 'bevel') cut = [V, at(a1, 0), at(0, a2)];
      else if (off > 0) cut = h1 ? [at(off, 0), at(off + dx, 0), at(off + dx, dy), at(off, dy)] : [at(0, off), at(0, off + dx), at(dy, off + dx), at(dy, off)];
      else cut = [V, at(a1, 0), at(a1, a2), at(0, a2)];
    } else if (t === 'round1' || t === 'semi') {
      var r = t === 'semi' ? dep / 2 : Math.min(num(S.roundRadius) || 30, dep / 2), th = Math.acos(Math.max(-1, Math.min(1, u1[0] * u2[0] + u1[1] * u2[1])));
      var tt = r / Math.tan(th / 2), bl = Math.hypot(u1[0] + u2[0], u1[1] + u2[1]) || 1, bis = [(u1[0] + u2[0]) / bl, (u1[1] + u2[1]) / bl], dc = r / Math.sin(th / 2);
      var Cc = [V[0] + bis[0] * dc, V[1] + bis[1] * dc], T1 = at(tt, 0), T2 = at(0, tt);
      var g1 = Math.atan2(T1[1] - Cc[1], T1[0] - Cc[0]), g2 = Math.atan2(T2[1] - Cc[1], T2[0] - Cc[0]), dg = g2 - g1;
      while (dg > Math.PI) dg -= 2 * Math.PI; while (dg < -Math.PI) dg += 2 * Math.PI;
      cut = [V, T1];
      for (var s = 1; s < 16; s++) { var g = g1 + dg * s / 16; cut.push([Cc[0] + r * Math.cos(g), Cc[1] + r * Math.sin(g)]); }
      cut.push(T2);
    }
    if (!cut) return [];
    /* le moteur borne l'usinage à sa pièce (clampBevel) : une pièce voisine n'est entamée que si le
       dessin (et donc l'image de commande) y a perdu du décor, dans la zone commune */
    var drawn = A && A.svg && A.svg.querySelector('.cp-trace [data-piece]');
    return P.filter(function (p) {
      if (owners.indexOf(p.id) >= 0) return false;
      var z = clipPoly(cut, p.pts); if (z.length < 3 || Math.abs(area2(z)) / 2 <= 0.5) return false;
      if (!drawn) return true;
      var c = z.reduce(function (s, q) { return [s[0] + q[0] / z.length, s[1] + q[1] / z.length]; }, [0, 0]);
      return [c].concat(z.map(function (q) { return [c[0] + (q[0] - c[0]) * 0.6, c[1] + (q[1] - c[1]) * 0.6]; }))
        .some(function (q) { return paintedPiece(A, q[0], q[1]) === null; });
    }).map(function (p) { return p.id; });
  }

  /*  chant d'un coin arrondi, demi-rond ou chanfreiné. Le dessin le trace toujours, sans
     case (drawCornerBanding) et le moteur impose alors les chants voisins : il n'est donc pas dans les
     traits relevés par mapChants. Même découpe que le dessin (cp-trace, cornerCutPath : murs du sommet
     hors jonction, arrondi au plus la moitié de la largeur et 0,49 du mur, demi-rond : moitié de la
     largeur ; chanfrein : dx le long du mur le plus horizontal). Une entrée par pièce du sommet ; coin
     partagé en coupe à 45° : la part de chaque pièce, coupée à la jonction. Longueur réelle de l'arc.*/
  function cornerChants(pieces, U, prev) {
    var P = pieces.map(function (p) { return { id: p.id, pts: p.contour }; }), out = [];
    var onSeg = function (a, b, q, tol) {                                   /* q sur le segment a–b, à tol mm près */
      var L = len(a, b); if (L < 0.5) return false;
      var s = ((q[0] - a[0]) * (b[0] - a[0]) + (q[1] - a[1]) * (b[1] - a[1])) / L, d = Math.abs((b[0] - a[0]) * (q[1] - a[1]) - (b[1] - a[1]) * (q[0] - a[0])) / L;
      return d <= tol && s >= -tol && s <= L + tol;
    };
    var onB = function (pts, q) { return pts.some(function (a, i) { return onSeg(a, pts[(i + 1) % pts.length], q, 1); }); };
    Object.keys(U || {}).sort().forEach(function (k) {
      var u = U[k], t = u.type, V = u.sommet;
      if (!V || (t !== 'round1' && t !== 'semi' && t !== 'bevel')) return;
      var owners = P.filter(function (p) { return p.pts.some(function (q) { return len(q, V) < 1; }); });
      var walls = [];
      owners.forEach(function (p) {
        var n = p.pts.length, i = p.pts.findIndex(function (q) { return len(q, V) < 1; });
        [p.pts[(i + n - 1) % n], p.pts[(i + 1) % n]].forEach(function (w) {
          var mid = [(V[0] + w[0]) / 2, (V[1] + w[1]) / 2], l = len(V, w);
          if (l < 0.5 || P.some(function (o) { return o !== p && onB(o.pts, mid); })) return;   /* jonction ou onglet */
          var d = [(w[0] - V[0]) / l, (w[1] - V[1]) / l];
          if (!walls.some(function (x) { return Math.abs(x.u[0] - d[0]) < 1e-6 && Math.abs(x.u[1] - d[1]) < 1e-6; })) walls.push({ u: d, L: l });
        });
      });
      if (walls.length !== 2) return;
      var u1 = walls[0].u, u2 = walls[1].u, at = function (a, b) { return [V[0] + u1[0] * a + u2[0] * b, V[1] + u1[1] * a + u2[1] * b]; };
      var path, C = null, r = 0;
      if (t === 'bevel') {
        var dim = u.dim || {}, h1 = Math.abs(u1[0]) >= Math.abs(u1[1]), dx = num(dim.dx) || 50, dy = num(dim.dy) || 50;
        path = [at(h1 ? dx : dy, 0), at(0, h1 ? dy : dx)];
      } else {
        var dep = Math.min.apply(null, owners.map(function (p) { return minWidth(p.pts); }));
        r = t === 'semi' ? dep / 2 : Math.min(num(u.rayon_mm) || 30, dep / 2);
        var th = Math.acos(Math.max(-1, Math.min(1, u1[0] * u2[0] + u1[1] * u2[1]))), half = Math.tan(th / 2), tt = r / half;
        var cap = Math.min(walls[0].L, walls[1].L) * (t === 'semi' ? 1 : 0.49);
        if (tt > cap) { tt = cap; r = tt * half; }
        var bl = Math.hypot(u1[0] + u2[0], u1[1] + u2[1]) || 1, dc = r / Math.sin(th / 2);
        C = [V[0] + (u1[0] + u2[0]) / bl * dc, V[1] + (u1[1] + u2[1]) / bl * dc];
        var T1 = at(tt, 0), T2 = at(0, tt), g1 = Math.atan2(T1[1] - C[1], T1[0] - C[0]), dg = Math.atan2(T2[1] - C[1], T2[0] - C[0]) - g1;
        while (dg > Math.PI) dg -= 2 * Math.PI; while (dg < -Math.PI) dg += 2 * Math.PI;
        path = [];
        for (var s = 0; s <= 64; s++) path.push(s === 0 ? T1 : s === 64 ? T2 : [C[0] + r * Math.cos(g1 + dg * s / 64), C[1] + r * Math.sin(g1 + dg * s / 64)]);
      }
      owners.forEach(function (p) {
        var n = p.pts.length, i = p.pts.findIndex(function (q) { return len(q, V) < 1; }), part = path;
        var isWall = function (w) { var l = len(V, w) || 1, d = [(w[0] - V[0]) / l, (w[1] - V[1]) / l]; return walls.some(function (x) { return Math.abs(x.u[0] - d[0]) < 1e-6 && Math.abs(x.u[1] - d[1]) < 1e-6; }); };
        var prv = p.pts[(i + n - 1) % n], nxt = p.pts[(i + 1) % n], wp = isWall(prv), wn = isWall(nxt);
        if (!wp && !wn) return;
        if (!(wp && wn)) {                                                   /* un seul mur : coupé à la jonction V–J */
          var J = wp ? nxt : prv, cr = function (q) { return (J[0] - V[0]) * (q[1] - V[1]) - (J[1] - V[1]) * (q[0] - V[0]); };
          var cen = p.pts.reduce(function (a, q) { return [a[0] + q[0] / n, a[1] + q[1] / n]; }, [0, 0]), side = Math.sign(cr(cen));
          var ins = function (q) { return cr(q) * side >= -1e-6; }, keep = [];
          for (var j = 0; j < path.length; j++) {
            if (ins(path[j])) { if (j > 0 && !ins(path[j - 1])) { var a = path[j - 1], c0 = cr(a), c1 = cr(path[j]), f = c0 / ((c0 - c1) || 1); keep.push([a[0] + (path[j][0] - a[0]) * f, a[1] + (path[j][1] - a[1]) * f]); } keep.push(path[j]); }
            else if (j > 0 && ins(path[j - 1])) { var b = path[j - 1], d0 = cr(b), d1 = cr(path[j]), g = d0 / ((d0 - d1) || 1); keep.push([b[0] + (path[j][0] - b[0]) * g, b[1] + (path[j][1] - b[1]) * g]); }
          }
          part = keep;
        }
        if (part.length < 2) return;
        var L = 0; for (var m = 1; m < part.length; m++) {                    /* arc : rayon × angle, exact */
          if (!C) { L += len(part[m - 1], part[m]); continue; }
          var ga = Math.atan2(part[m - 1][1] - C[1], part[m - 1][0] - C[0]), gb = Math.atan2(part[m][1] - C[1], part[m][0] - C[0]), dgm = Math.abs(gb - ga);
          L += r * Math.min(dgm, 2 * Math.PI - dgm);
        }
        if (L < 1) return;
        var A0 = part[0], A1 = part[part.length - 1];
        /* face de chanfrein déjà relevée comme trait : pas de doublon*/
        if (t === 'bevel' && (prev || []).some(function (c) { return c.usinage && c.piece === p.id && onSeg(A0, A1, c.arete[0], 5) && onSeg(A0, A1, c.arete[1], 5); })) return;
        var e = { cle: k, piece: p.id, usinage: true, coin: t === 'bevel' ? 'chanfrein' : t === 'semi' ? 'demi-rond' : 'arrondi',
          arete: [[r2(A0[0]), r2(A0[1])], [r2(A1[0]), r2(A1[1])]], longueur_chant_mm: r2(L) };
        if (C) { e.centre = [r2(C[0]), r2(C[1])]; e.rayon_mm = r2(r); }
        out.push(e);
      });
    });
    return out;
  }

  /*
     (retrait choisi). Pour chaque bout qui porte, ou peut porter, un jambage : retrait minimal = longueur,
     le long du côté de la pièce, de la découpe de ses coins (même découpe que le dessin, cornerCutPath) :
     arrondi = sa tangente (rayon au plus la moitié de la largeur et 0,49 du mur), demi-rond = moitié de la
     largeur, chanfrein et encoche = leur cote le long du côté (dx le long du mur le plus horizontal),
     encoche décalée le long du côté = décalage + dx, en travers du bout = dy. Retrait maximal : LEG_MAX
     (porte-à-faux au plus 600 mm, la profondeur courante d'un plan : au-delà, un plan de 20 à 40 mm sans
     appui fléchit), sans sortir de la pièce (longueur − épaisseur du jambage), jamais sous le minimum.
     Pièce et bout : même repérage que la vue 3D (cp-3d, legFootprint).*/
  var LEG_MAX = 600;
  function legLimits(plan, legs) {
    var out = {}, U = plan.usinages || {}, t0 = num(plan.epaisseur_mm && plan.epaisseur_mm.valeur) || 20;
    var J = (plan.jonctions || []).map(function (j) { return [(num(j.segment[0][0]) + num(j.segment[1][0])) / 2, (num(j.segment[0][1]) + num(j.segment[1][1])) / 2]; });
    var LBL = { round1: 'arrondi', semi: 'demi-rond', bevel: 'chanfrein', notch: 'encoche' };
    (legs || []).forEach(function (leg) {
      var pc = plan.pieces.filter(function (p) { return p.role === leg.piece; })[0] ||
        plan.pieces.filter(function (p) { return String(p.role).indexOf(leg.piece) === 0; })[0];
      if (!pc) return;
      var pts = pc.contour.map(function (q) { return [num(q[0]), num(q[1])]; }), n = pts.length;
      var a = num(pc.fil_deg) * Math.PI / 180, ax = [Math.cos(a), Math.sin(a)];
      var pr = pts.map(function (q) { return q[0] * ax[0] + q[1] * ax[1]; }), lo = Math.min.apply(null, pr), hi = Math.max.apply(null, pr);
      var ends = [lo, hi].map(function (v) { return pts.map(function (q, i) { return i; }).filter(function (i) { return Math.abs(pr[i] - v) < 1; }); })
        .filter(function (e) { return e.length >= 2; });
      if (!ends.length) return;
      var mid = function (e) { return [(pts[e[0]][0] + pts[e[1]][0]) / 2, (pts[e[0]][1] + pts[e[1]][1]) / 2]; }, ex = leg.extremite || '', pick;
      if (/gauche/.test(ex)) pick = ends.slice().sort(function (x, y) { return mid(x)[0] - mid(y)[0]; })[0];
      else if (/droit/.test(ex)) pick = ends.slice().sort(function (x, y) { return mid(y)[0] - mid(x)[0]; })[0];
      else {
        var dJ = function (e) { var m = mid(e); return J.length ? Math.min.apply(null, J.map(function (c) { return len(c, m); })) : m[1]; };
        pick = ends.slice().sort(function (x, y) { return dJ(y) - dJ(x); })[0];
      }
      var dep = minWidth(pts), t = num(leg.epaisseur_mm) || t0, lg = hi - lo, min = 0, raisons = [];
      pick.forEach(function (i) {
        var V = pts[i], k = Object.keys(U).filter(function (key) {
          var u = U[key]; return u.sommet && len([num(u.sommet[0]), num(u.sommet[1])], V) < 1 && (!u.pieces || u.pieces.indexOf(pc.id) >= 0);
        })[0];
        if (!k) return;
        var u = U[k], ty = u.type; if (!ty || ty === 'straight') return;
        var P1 = pts[(i + n - 1) % n], P2 = pts[(i + 1) % n], w1 = [P1[0] - V[0], P1[1] - V[1]], w2 = [P2[0] - V[0], P2[1] - V[1]];
        var l1 = Math.hypot(w1[0], w1[1]) || 1, l2 = Math.hypot(w2[0], w2[1]) || 1; w1 = [w1[0] / l1, w1[1] / l1]; w2 = [w2[0] / l2, w2[1] / l2];
        var d1 = Math.abs(w1[0] * ax[0] + w1[1] * ax[1]), d2 = Math.abs(w2[0] * ax[0] + w2[1] * ax[1]);
        var side = d1 >= d2 ? w1 : w2, endw = d1 >= d2 ? w2 : w1, sideL = d1 >= d2 ? l1 : l2, endL = d1 >= d2 ? l2 : l1, cosA = Math.max(d1, d2);
        var sideH = Math.abs(side[0]) >= Math.abs(side[1]), dim = u.dim || {}, along = 0, lab = LBL[ty] || ty;
        if (ty === 'round1' || ty === 'semi') {
          var r = ty === 'semi' ? dep / 2 : Math.min(num(u.rayon_mm) || 30, dep / 2);
          var th = Math.acos(Math.max(-1, Math.min(1, side[0] * endw[0] + side[1] * endw[1]))), half = Math.tan(th / 2) || 1, tt = r / half;
          var cap = Math.min(sideL, endL) * (ty === 'semi' ? 1 : 0.49); if (tt > cap) { tt = cap; r = tt * half; }
          along = tt; if (ty === 'round1') lab += ' R ' + Math.round(r);
        } else if (ty === 'bevel' || ty === 'notch') {
          var dx = num(dim.dx) || 50, dy = num(dim.dy) || 50, off = ty === 'notch' ? num(dim.offset) : 0;
          along = off > 0 ? (sideH ? off + dx : dy) : (sideH ? dx : dy);
          lab += ' ' + Math.round(dx) + ' × ' + Math.round(dy);
        }
        var m = Math.ceil(along * cosA - 0.01);
        if (m > 0) { if (raisons.indexOf(lab) < 0) raisons.push(lab); if (m > min) min = m; }
      });
      var max = Math.max(min, Math.min(LEG_MAX, Math.floor(lg - t)));
      out[leg.cote] = { cote: leg.cote, piece: pc.id, min: min, max: max, raisons: raisons, longueur: Math.round(lg), epaisseur: t };
    });
    return out;
  }

  /* surface couverte par les blocs du moteur (il peut dessiner une pièce sous l'autre) */
  function engineCover(A) {
    var eng = (A._cpPieces || []), inter = 0, sum = 0;
    eng.forEach(function (a, i) {
      sum += a.w * a.h;
      for (var j = i + 1; j < eng.length; j++) {
        var b = eng[j], w = Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x), h = Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y);
        if (w > 0 && h > 0) inter += w * h;
      }
    });
    return { n: eng.length, area: sum - inter };
  }

  /* ── 2. Contrôles ── */
  function checks(A, plan, geo, u, extraPA) {                   /* extraPA : surface des pièces d'angle hors du dessin du moteur (A-345) */
    var S = A.S, out = [], add = function (id, ok, msg, bloquant) { out.push({ id: id, ok: !!ok, message: msg, bloquant: !!bloquant }); };
    var d = plan.produit.decor, gm = plan.epaisseur_mm.gamme;
    /* textes d'échec du lot « messages 1 » (COMMERCIAL, AUDIT Tour 597) : ce qu'il faut changer, sans point final (la garde
       joint par « ; » et met « . ») ; textes de réussite inchangés, pour l'outil */
    var amin = GAMME.angle_min_deg.valeur, amax = GAMME.angle_max_deg.valeur;
    var epG = plan.boiserie ? plan.boiserie.epaisseur_mm : plan.epaisseur_mm.valeur;   /* A-397 : boiserie, les panneaux (18 mm) */
    if (gm) { var okG = gm.indexOf(epG) >= 0; add('epaisseur_gamme', okG, okG
      ? 'Épaisseur ' + epG + ' mm disponible dans le décor (' + gm.join('/') + ' mm)'
      : 'Le décor n\'existe pas en ' + epG + ' mm : choisissez ' + gm.join('/') + ' mm', true); }   /* L14 */
    if (plan.forme.angle_deg !== null && plan.forme.angle_deg !== 90) { var okA = plan.forme.angle_deg >= amin && plan.forme.angle_deg <= amax; add('angle_plage', okA, okA
      ? 'Angle ' + plan.forme.angle_deg + '° compris entre ' + amin + ' et ' + amax + '°'
      : 'Angle de ' + plan.forme.angle_deg + '° impossible : choisissez de ' + amin + ' à ' + amax + '°', true); }   /* L15 */
    var angs = plan.forme.angles_deg || {};
    Object.keys(angs).forEach(function (k) {
      if (angs[k] === 90) return;
      var okC = angs[k] >= amin && angs[k] <= amax;
      add('angle_plage_' + k, okC, okC ? 'Angle du coin ' + k + ' : ' + angs[k] + '° compris entre ' + amin + ' et ' + amax + '°'
        : 'Angle du ' + (NOMS_ANGLES[k] || 'coin ' + k) + ' : ' + angs[k] + '° impossible, choisissez de ' + amin + ' à ' + amax + '°', true);   /* L16 */
    });
    if (u) {                                              /* U : jonctions portées ; à 90°, tracé = dessin du moteur */
      var seamOkU = u.seams.every(function (sg, i) {
        var two = [u.pieces[i], u.pieces[1]];            /* gauche|fond, puis droite|fond */
        if (i === 1) two = [u.pieces[2], u.pieces[1]];
        return sg.every(function (q) { return two.every(function (p) { return onBoundary(p.pts, q); }); });
      });
      add('jonction_portee', seamOkU, 'Jonctions portées par le bord des pièces (écart 0 mm)', true);
      if (angs.gauche === 90 && angs.droite === 90) {
        var ec = engineCover(A), ma = u.pieces.reduce(function (s, p) { return s + area(p.pts); }, 0);
        add('coherence_dessin', ec.n === u.pieces.length && Math.abs(ec.area - ma) <= 1,
          'Tracé par points identique au dessin affiché (surface ' + r2(ec.area / 1e6) + ' m² contre ' + r2(ma / 1e6) + ' m²)', false);
      }
    }
    /*   jamais deux pièces sur la même surface ; et, quand le dessin du moteur est
       connu (plan droit, U et G d'équerre), surface des pièces = surface dessinée*/
    var ov = 0, cs = plan.pieces.map(function (p) { return p.contour; });
    /* étagère V2 : les étagères sont l'une au-dessus de l'autre (plan.etageres, hauteurs) ; vues de dessus, elles se
       recouvrent par nature, et le dessin est une vue de face (pas de surface dessinée à comparer) */
    var etag = !!plan.etageres;
    if (!etag) for (var i = 0; i < cs.length; i++) for (var j = i + 1; j < cs.length; j++) ov = Math.max(ov, convexOverlap(cs[i], cs[j]));
    /* 50 mm² : les contours sont arrondis au 1/100 mm (1 à 3 mm² le long d'une jonction de
       600 mm, hors d'équerre) ; un vrai recouvrement se compte en dizaines de milliers de mm² */
    add('pieces_sans_chevauchement', ov <= 50, etag ? 'Étagères superposées : une pièce par étagère, chacune à sa hauteur' : ov <= 50 ? 'Aucune surface commune à deux pièces'
      : 'Deux pièces se recouvrent sur ' + Math.round(ov) + ' mm² : le plan de découpe serait faux', true);
    var da = !etag && (S.layout === 'linear' || S.layout === 'u-shape' || S.layout === 'g-shape') &&
      !(plan.forme.angles_deg && Object.keys(plan.forme.angles_deg).some(function (k) { return plan.forme.angles_deg[k] !== 90; })) ? drawnArea(A) : null;
    if (da !== null) {
      var pa = plan.pieces.reduce(function (s, p) { return s + area(p.contour); }, 0) - (extraPA || 0);
      add('surface_dessin', Math.abs(pa - da) <= 1, 'Surface des pièces ' + r2(pa / 1e6) + ' m² = surface dessinée ' + r2(da / 1e6) + ' m²' +
        (extraPA ? ' (sans l\'avant en biais des pièces d\'angle, ' + r2(extraPA / 1e6) + ' m²)' : ''), true);
    }
    var max = maxPiece(A, S.layout === 'linear');                      /* A-307 : le maximum de pièce de la règle, 4 180 sans règle */
    plan.pieces.forEach(function (p) {
      add('contour_' + p.id, p.contour.length >= 3 && simple(p.contour), 'Pièce « ' + p.role + ' » : contour fermé et non croisé', true);
      var okL = p.plus_grande_arete_mm <= max + EPS, cote = okL || typeof window.CP_coteDe !== 'function' ? null : window.CP_coteDe(A, 'piece:' + p.id);
      /* A-307 : la cote qui allonge cette pièce, et sa borne (cp-forme). R1 (COMMERCIAL, AUDIT Tour 639) : le nom de pieceNom,
         comme partout ailleurs ; les pièces p1…pn du repli piecesFromEngine ne sont pas numérotées sur le dessin : « Une pièce
         du plan » */
      var nomP = { plan: 1, retour: 1, fond: 1, haut: 1, gauche: 1, droite: 1 }[p.id] ? pieceNom(S, p.id) : plan.pieces.length > 1 ? 'Une pièce du plan' : 'Le plan';
      add('plaque_' + p.id, okL, okL
        ? 'Pièce « ' + p.role + ' » : plus grande arête ' + Math.round(p.plus_grande_arete_mm) + ' mm ≤ ' + max + ' mm (longueur maximale d\'une plaque)'
        : nomP + ' mesure ' + fmtMm(p.plus_grande_arete_mm) + ' mm : c\'est plus que le plus grand panneau (' + fmtMm(max) + ' mm). ' +
          (cote ? 'Réduisez la cote ' + cote.k + ' à ' + fmtMm(cote.max) + ' mm au plus' : 'Réduisez la longueur') +
          ((plan.jonctions || []).length ? ', ou choisissez une autre jonction' : ''), true);   /* L17 : une jonction à changer seulement s'il y en a une */
    });
    if (geo) {
      var seamOk = geo.seam.every(function (q) { return geo.pieces.every(function (p) { return onBoundary(p.pts, q); }); });
      add('jonction_portee', seamOk, 'Jonction portée par le bord des deux pièces (écart 0 mm)', true);
      var Lw = num(S.P1) + num(S.L2), end = [geo.corner[0] + geo.dirV[0] * Lw, geo.corner[1] + geo.dirV[1] * Lw];
      var onP = geo.pieces.some(function (p) { return p.pts.some(function (q) { return len(q, end) < EPS; }); });
      add('mur_retour', onP, 'Mur du retour = P1 + L2 = ' + Lw + ' mm', true);
      /* banc d'essai : à 90° et jonction droite, le tracé par points = les rectangles du moteur */
      if (plan.forme.angle_deg === 90 && plan.jonctions[0].type !== 'onglet') {
        /* le moteur peut dessiner une pièce sous l'autre : on compare la SURFACE COUVERTE */
        var eng = (A._cpPieces || []), inter = 0, sum = 0;
        eng.forEach(function (a, i) {
          sum += a.w * a.h;
          for (var j = i + 1; j < eng.length; j++) {
            var b = eng[j], w = Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x), h = Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y);
            if (w > 0 && h > 0) inter += w * h;
          }
        });
        var ma = geo.pieces.reduce(function (s, p) { return s + area(p.pts); }, 0);
        add('coherence_dessin', eng.length === geo.pieces.length && Math.abs((sum - inter) - ma) <= 1,
          'Tracé par points identique au dessin affiché (surface ' + r2((sum - inter) / 1e6) + ' m² contre ' + r2(ma / 1e6) + ' m²)', false);
      }
    }
    /* chants du modèle = cases cochées du dessin*/
    var dc = drawnEdges(A);
    if (dc.all.length) add('chants_dessin', dc.checked.join(',') === plan.chants.join(','),
      'Chants du modèle (' + plan.chants.length + ') = cases cochées du dessin (' + dc.checked.length + ')', false);
    var f = plan.facturation, shown = parseEuroCents((document.getElementById('td-prix-total') || {}).textContent);
    if (shown !== null) add('prix_coherent', Math.abs(shown - f.unitaire_centimes) <= 1,
      'Prix du modèle ' + (f.unitaire_centimes / 100).toFixed(2) + ' € = prix affiché ' + (shown / 100).toFixed(2) + ' €', true);
    return out;
  }

  /* ── 3. Empreinte : JSON canonique (clés triées) puis SHA-256 ── */
  function canon(x) {
    if (Array.isArray(x)) return '[' + x.map(canon).join(',') + ']';
    if (x && typeof x === 'object') return '{' + Object.keys(x).sort().map(function (k) { return JSON.stringify(k) + ':' + canon(x[k]); }).join(',') + '}';
    return JSON.stringify(x === undefined ? null : x);
  }
  function sha256(txt) {
    var data = new TextEncoder().encode(txt);
    return crypto.subtle.digest('SHA-256', data).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    });
  }
  window.CP_plan = function () { var A = getApp(); return A ? buildPlan(A) : null; };
  /* ── A-307 (AUDIT Tours 567, 588, 607) : un seul maximum par pièce ──
     Celui de la règle (« Longueur maximale d'une pièce »), sinon sa « Longueur max », borné par la longueur du décor choisi
     (custom.dimensions_max_mm) : le BR_MAX de cp-pierre-angle. Plan droit : sans le décor, que decor_dimensions contrôle
     avec son propre message. Produit sans règle : la plaque du tarif du stratifié (GAMME), comme avant. */
  function maxPiece(A, sansDecor) {
    var e = A._eff || {}, id = Number(e.matchedCollectionId) || 0, rs = (window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || [], r = null;
    for (var i = 0; i < rs.length && !r; i++) if (Number(rs[i].collectionId) === id) r = rs[i];
    var m = r ? (num(r.pieceMaxMm) > 0 ? num(r.pieceMaxMm) : num((e.lengthLimits || {}).max)) : 0;
    if (!(m > 0)) return GAMME.longueur_max_mm.valeur;
    if (!sansDecor) {
      try {
        var v = A.getSelectedShopifyVariant ? A.getSelectedShopifyVariant() : null, dm = v && window.CP_DMAX && window.CP_DMAX[v.title];
        if (dm && num(dm.l) > 0 && num(dm.l) < m) m = num(dm.l);
      } catch (x) {}
    }
    return m;
  }
  /* pièces d'un L, d'un U ou d'un G d'après l'état seul : la géométrie de buildPlan, sans rendu ni lecture de la page ; la
     borne des cotes (cp-forme) y lit ce qu'une cote allonge */
  function piecesForme(S) {
    var g = null;
    if (S.layout === 'angle') g = geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: num(S.innerAngle || 90), jn: junctionOf(S), dir: S.angleDir === 'left' ? 'left' : 'right' });
    else if (S.layout === 'u-shape') {
      var a = cornerAnglesOf(S), j = jnUside(S);
      g = geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr), jl: j.g, jr: j.d, aL: a.g, aR: a.d });
    } else if (S.layout === 'g-shape') g = geomG(gParams(S));
    return g ? g.pieces : null;
  }
  window.CP_maxPiece = function (A) { A = A || getApp(); return A ? maxPiece(A) : 0; };
  window.CP_longueursPieces = function (A) {
    A = A || getApp(); var ps = A && A.S ? piecesForme(A.S) : null; if (!ps) return [];
    var mx = maxPiece(A);
    return ps.map(function (p) { return { cle: 'piece:' + p.id, nom: p.role, mm: longest(p.pts).l, max: mx }; });
  };
  /* ── Prix d'un chant selon la profondeur (réglage de la règle « Prix d'un chant selon la profondeur », chantsProfondeur :
     « 600:39, 630:59, 900:59 » = jusqu'à 600 mm de profondeur, 39 € par chant ; jusqu'à 630, 59 € ; jusqu'à 900, 59 € ;
     au-delà, le dernier). Vide : le « Supplément par chant » de la règle, comme avant. Le prix du moteur
     (_eff.edgeBandingUnitEuro) est posé avant chaque calcul des suppléments. ── */
  function paliersChant(A) {
    var id = A && A._eff ? Number(A._eff.matchedCollectionId) : 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    var t = rg && rg.chantsProfondeur ? String(rg.chantsProfondeur) : ''; if (!t.trim()) return null;
    var out = t.split(/[,;\n]+/).map(function (s) { var m = s.trim().match(/^(\d+)\s*:\s*(\d+(?:[.,]\d+)?)$/); return m ? { mm: num(m[1]), eur: parseFloat(m[2].replace(',', '.')) } : null; })
      .filter(Boolean).sort(function (a, b) { return a.mm - b.mm; });
    return out.length ? out : null;
  }
  function prixChantSelonProf(A) {
    var p = paliersChant(A); if (!p) return null;
    var P = profPlan(A.S), x = p.filter(function (q) { return P <= q.mm; })[0] || p[p.length - 1];
    return x.eur;
  }
  /* ── R180 (AUDIT Tours 1111 et 1113 ; docs\r180-plan-code.md) : réglage de la règle « Selon l'épaisseur » (parEpaisseur), une
     ligne par épaisseur : « 180: formes=droit; prof_max_mm=630; ilot=non; piece_angle=non; bouts_libres=non; coins=non;
     decoupes=non; chant_prix=0; bouts_office=oui; facture_min_mm=300 ». Lu à chaque rendu, d'après S.thk : seules les clés
     écrites changent la règle, pour cette épaisseur ; les autres épaisseurs gardent la règle telle quelle. ── */
  function parEpTout(A) {
    var id = Number(((A && A._eff) || {}).matchedCollectionId) || 0, out = {};
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    String((rg && rg.parEpaisseur) || '').split(/\n+/).forEach(function (l) {
      var m = l.match(/^\s*(\d+)\s*:(.*)$/); if (!m) return;
      var o = {}; m[2].split(';').forEach(function (kv) { var p = kv.split('='); if (p.length === 2 && p[0].trim()) o[p[0].trim()] = p[1].trim(); });
      out[num(m[1])] = o;
    });
    return out;
  }
  function parEp(A, mm) { return parEpTout(A)[num(mm == null ? A && A.S && A.S.thk : mm)] || null; }
  window.CP_parEp = function (A, mm) { A = A || getApp(); return A ? parEp(A, mm) : null; };
  window.CP_parEpTout = function (A) { A = A || getApp(); return A ? parEpTout(A) : {}; };
  /* bouts d'office (bordures) : comme avant si aucune épaisseur n'en parle ; sinon, seulement pour celle qui dit « oui » */
  function officeEp(A) { var t = parEpTout(A); return !Object.keys(t).some(function (k) { return t[k].bouts_office != null; }) || (parEp(A) || {}).bouts_office === 'oui'; }
  /* avant chaque rendu : côtés verrouillés « (imposé) » pour les bouts d'office, types de coins fermés ; les valeurs de la règle
     sont gardées (A.__cpEffBase) et reviennent aux autres épaisseurs */
  function appliqueParEp(A) {
    var E = A && A._eff; if (!E || !A.S) return;
    var b = A.__cpEffBase; if (!b) { var bl0 = E.bandingLocked || {}; b = A.__cpEffBase = { s: bl0.linear_sides === true, r: bl0.linear_right === true, types: JSON.stringify(E.edgeTypes || {}) }; }
    var q = parEp(A), office = !!(q && q.bouts_office === 'oui') || arrCotes(A);   /* R182-a : 2e cause, le chant arrière sur un cœur noir */
    E.bandingLocked = E.bandingLocked || {}; E.bandingLocked.linear_sides = office || b.s; E.bandingLocked.linear_right = office || b.r;
    var types = q && q.coins === 'non' ? { round1: false, semi: false, bevel: false, notch: false } : JSON.parse(b.types);
    if (JSON.stringify(types) !== JSON.stringify(E.edgeTypes || {})) { E.edgeTypes = types; if (typeof window.CFG_applyEdgeTypes === 'function') window.CFG_applyEdgeTypes(A, types); }
  }
  /* A-428 (AUDIT Tour 1211 ; ADMIN Tour 1035) : reposé par cp-pierre-angle dans le rendu, une fois le chant arrière réglé par les
     coins (syncCoins, A-291). Un coin rond posé au coin arrière impose le chant arrière, donc les 2 côtés (R182-a), après le
     verrou posé avant le rendu : le moteur les comptait aussi en « Chants supp. » (payés deux fois). Retiré, le verrou d'avant
     restait sur ce rendu : côtés dessinés verrouillés */
  window.CP_appliqueParEp = function (A) { A = A || getApp(); if (A && A.__cpPlanWrapped) appliqueParEp(A); };
  /* ── R180, refus (COMMERCIAL, docs\commercial-r180-textes.md § 9 et § 10 ; AUDIT 21:26 et Tour 1113) : une épaisseur qui a sa
     ligne « Selon l'épaisseur » (le 18 cm) est grisée tant que la configuration ne s'y prête pas (forme, profondeur, coins,
     découpes) ; une fois dedans, les formes et les profondeurs qu'elle n'a pas sont grisées. Rien n'est retiré au client : le choix
     grisé dit pourquoi dans une bulle (toucher, clic, clavier) et dans son nom lu. Les nombres viennent de la règle servie. ── */
  function ouTxt(l) { return l.length > 1 ? l.slice(0, -1).join(', ') + ' ou ' + l[l.length - 1] : (l[0] || ''); }
  function epLabel(mm) { var o = ((window.CONFIGURATOR_CONFIG || {}).thicknessOptions || []).filter(function (x) { return num(x.mm) === num(mm); })[0]; return o && o.label ? String(o.label) : mm + ' mm'; }
  function autresEp(A, mm) {
    var l = (((A._eff || {}).thicknessRule || {}).allowed || []).map(Number).filter(function (x) { return x !== num(mm) && !parEp(A, x); }).sort(function (a, b) { return a - b; });
    return l.length ? ouTxt(l.map(String)) + ' mm' : '';
  }
  function profsRegle(A) {
    var al = ((A._eff || {}).depthRule || {}).allowed || [];
    return ((window.CONFIGURATOR_CONFIG || {}).depthStandards || []).filter(function (o) { return al.indexOf(String(o.id)) >= 0; }).map(function (o) { return num(o.depth_mm); }).sort(function (a, b) { return a - b; });
  }
  function cm(mm) { return String(num(mm) / 10).replace('.', ','); }
  var COIN_NOM = { round1: ['coin arrondi', 'le '], semi: ['demi-rond', 'le '], bevel: ['chanfrein', 'le '], notch: ['encoche', 'l\''], biais: ['bord en biais', 'le '] };
  function coinsPoses(A) {
    var E = A.S.edges || {}, out = [];
    Object.keys(E).forEach(function (k) {
      var ty = E[k], n = COIN_NOM[ty]; if (!n) return;
      if (ty === 'biais' && A.S.cpCoupeMode && Object.keys(A.S.cpCoupeMode).some(function (b) { return A.S.cpCoupeMode[b] === 'hors' && A.S.cpHorsDernier && A.S.cpHorsDernier[b] === k; })) n = ['hors équerre', 'le '];
      var ti = typeof window.CP_titreCoin === 'function' ? String(window.CP_titreCoin(A, k) || '').replace(/^Coin : /, '') : '';
      out.push({ nom: n[0] + (ti ? ' (' + ti + ')' : ''), art: n[1] });
    });
    return out;
  }
  function decoupesPosees(A) {
    var l = typeof window.CP_decoupes === 'function' ? window.CP_decoupes() : null;
    return (l || []).filter(function (d) { return d.forme !== 'monobloc'; }).map(function (d) { var n = String(d.nom || ''); return 'découpe n° ' + d.numero + (n ? ' (' + n.charAt(0).toLowerCase() + n.slice(1) + ')' : ''); });   /* R39-b : l'évier monobloc est sa propre cause */
  }
  function monoPose(A) { return ((typeof window.CP_decoupes === 'function' ? window.CP_decoupes() : null) || []).some(function (d) { return d.forme === 'monobloc'; }); }
  /* raisons de refuser l'épaisseur mm à la configuration d'aujourd'hui : { bulle, nom } ou null */
  function refusEp(A, mm) {
    var q = parEp(A, mm); if (!q) return null;
    var S = A.S, E = 'Le ' + epLabel(mm), g = [], seul = null, raisons = 0, max = num(q.prof_max_mm), ok = profsRegle(A).filter(function (p) { return !max || p <= max; });
    if (q.formes === 'droit' && S.layout !== 'linear') { raisons++; g.push('choisissez la forme « Droit »'); seul = { bulle: E + ' se fait en plan droit seulement. Choisissez la forme « Droit » pour passer en ' + epLabel(mm) + '.', nom: 'plan droit seulement' }; }
    if (max && S.layout === 'linear' && num(S.P) > max) { var pc = ok.map(cm).join('/') + ' cm'; raisons++; g.push('choisissez la profondeur ' + pc); seul = { bulle: E + ' se fait en ' + ouTxt(ok.map(cm)) + ' cm de profondeur seulement. Choisissez la profondeur ' + pc + ' pour passer en ' + epLabel(mm) + '.', nom: ouTxt(ok.map(cm)) + ' cm de profondeur seulement' }; }
    /* R182-b (COMMERCIAL Tour 226 : après la profondeur, avant les coins) : le chant arrière coché dès 600 (cp-pierre-angle) et une
       épaisseur sans îlot (18 cm : « ilot=non ») ne vont pas ensemble ; sans ce refus, le 18 cm gardait l'arrière coché, fini et
       compris pour rien */
    if (q.ilot === 'non' && typeof window.CP_arriereCoche === 'function' && window.CP_arriereCoche(A)) { raisons++; g.push('décochez le chant arrière'); seul = { bulle: E + ' se fait sans chant arrière. Décochez d\'abord le chant arrière.', nom: 'sans chant arrière' }; }
    if (q.coins === 'non') { var cs = coinsPoses(A); if (cs.length) { raisons++; cs.forEach(function (c) { g.push('retirez ' + c.art + c.nom); }); seul = { bulle: E + ' se fait sans usinage des coins. Retirez d\'abord : ' + cs.map(function (c) { return c.nom; }).join(' ; ') + '.', nom: 'sans usinage des coins' }; } }
    if (q.decoupes === 'non') { var ds = decoupesPosees(A); if (ds.length) { raisons++; ds.forEach(function (d) { g.push('retirez la ' + d); }); seul = { bulle: E + ' se fait sans découpe. Retirez d\'abord : ' + ds.join(' ; ') + '.', nom: 'sans découpe' }; } }
    /* R39-b (COMMERCIAL, docs\commercial-r39b-textes.md § 5 : une cause de plus, « retirez l'évier monobloc ») ; seule, la forme de
       R182-b */
    if (q.decoupes === 'non' && monoPose(A)) { raisons++; g.push('retirez l\'évier monobloc'); seul = { bulle: E + ' se fait sans évier monobloc. Retirez d\'abord l\'évier monobloc.', nom: 'sans évier monobloc' }; }
    if (!raisons) return null;
    /* nom lu (COMMERCIAL § 9.3) : « 18 cm, indisponible : {raison} », ou « … : voir les conditions » ; la bulle détaille */
    if (raisons > 1) return { bulle: E + ' n\'est pas possible avec cette configuration. Pour y passer : ' + g.join(' ; ') + '.', nom: epLabel(mm) + ', indisponible : voir les conditions' };
    return { bulle: seul.bulle, nom: epLabel(mm) + ', indisponible : ' + seul.nom };
  }
  function marquer(el, refus, nom, lab) {
    var cible = lab || el;
    if (refus) { el.setAttribute('data-cp-r180', refus); el.setAttribute('aria-disabled', 'true'); el.setAttribute('aria-label', nom); cible.classList.add(lab ? 'cp-thk-na' : 'cp-r180-na'); }
    else if (el.hasAttribute('data-cp-r180')) { el.removeAttribute('data-cp-r180'); el.removeAttribute('aria-disabled'); el.removeAttribute('aria-label'); cible.classList.remove(lab ? 'cp-thk-na' : 'cp-r180-na'); }
  }
  function refus180(A) {
    if (!A || !A.S || !A._eff) return;
    if (!document.getElementById('cp-r180-css')) { var st = document.createElement('style'); st.id = 'cp-r180-css'; st.textContent = '.layout-btn.cp-r180-na,#edge-popup-content .depth-btn.cp-r180-na{opacity:.55;cursor:not-allowed}#thk-container label.cp-thk-na{opacity:.6;cursor:not-allowed}'; document.head.appendChild(st); }
    var tout = parEpTout(A), cur = parEp(A), lab = epLabel(num(A.S.thk));
    Array.prototype.forEach.call(document.querySelectorAll('#thk-container input[name="thk"]'), function (i) {
      var mm = num(i.value); if (!tout[mm] || mm === num(A.S.thk)) { marquer(i, null, null, document.querySelector('#thk-container label[for="' + i.id + '"]')); return; }
      var r = refusEp(A, mm); marquer(i, r && r.bulle, r && r.nom, document.querySelector('#thk-container label[for="' + i.id + '"]'));
    });
    var autres = cur ? autresEp(A, A.S.thk) : '', FORME = { angle: 'L', 'u-shape': 'U', 'g-shape': 'G' };
    Array.prototype.forEach.call(document.querySelectorAll('.layout-btn[data-layout]'), function (b) {
      var f = FORME[b.getAttribute('data-layout')], non = !!(cur && cur.formes === 'droit' && f);
      marquer(b, non ? 'Le ' + lab + ' se fait en plan droit seulement. Pour un plan en ' + f + ', choisissez l\'épaisseur ' + autres + '.' : null, 'En ' + f + ', indisponible en ' + lab);
    });
    refusProf(A);
  }
  function refusProf(A) {
    var cur = A && A.S && parEp(A), max = cur ? num(cur.prof_max_mm) : 0, lab = cur ? epLabel(num(A.S.thk)) : '', autres = cur ? autresEp(A, A.S.thk) : '';
    var ok = max ? profsRegle(A).filter(function (p) { return p <= max; }).map(cm) : [];
    Array.prototype.forEach.call(document.querySelectorAll('#edge-popup-content .depth-btn[data-type="standard"][data-value]'), function (b) {
      var v = num(b.getAttribute('data-value')), non = !!(max && v > max);
      marquer(b, non ? 'Le ' + lab + ' se fait en ' + ouTxt(ok) + ' cm de profondeur seulement. Pour ' + cm(v) + ' cm, choisissez l\'épaisseur ' + autres + '.' : null, cm(v) + ' cm, indisponible en ' + lab);
    });
  }
  /* le choix grisé : la bulle, et rien d'autre (avant le moteur : capture sur window) */
  ['click', 'change'].forEach(function (ev) {
    window.addEventListener(ev, function (e) {
      var el = e.target && e.target.closest && e.target.closest('[data-cp-r180], label[for]'); if (!el) return;
      if (el.tagName === 'LABEL') { var inp = document.getElementById(el.getAttribute('for')); el = inp && inp.hasAttribute('data-cp-r180') ? inp : null; if (!el) return; }
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (el.type === 'radio') { var A = getApp(), c = A && document.querySelector('#thk-container input[name="thk"][value="' + num(A.S.thk) + '"]'); if (c) c.checked = true; }
      if (ev === 'click' && window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(el.getAttribute('data-cp-r180'), 'info', 9000);
    }, true);
  });
  /* R180 (AUDIT Tour 1143, UX) : l'épaisseur choisie se lit partout avec le libellé de la liste (« 18 cm ») : chiffre et texte
     de la barre, récapitulatif (la note du jambage le prend par CP_epLabel). Le panier garde « 180 mm » : la propriété
     Épaisseur, que le moteur lit dans le récapitulatif, est remise en mm (buildLineItemProperties, plus bas). */
  function epAffiche(A) {
    var mm = num(A && A.S && A.S.thk), lab = mm ? epLabel(mm) : ''; if (!lab || lab === mm + ' mm') return;
    [['bar-value-thickness', lab], ['td-epaisseur', lab]].forEach(function (x) { var el = document.getElementById(x[0]); if (el && el.textContent !== x[1]) el.textContent = x[1]; });
    /* la pastille de la barre (22 px de dedans à 375, 26 à 600) : le nombre, son unité en petit dessous (« 18 cm » en entier était
       coupé en « 8 cr » à 375, « 18cm » sur une ligne fait 27,5 px) */
    var pv = document.getElementById('bar-preview-thk'), m = lab.match(/^(\S+)\s+(\S+)$/);
    if (pv && pv.textContent !== (m ? m[1] + m[2] : lab)) {
      pv.textContent = m ? '' : lab;
      if (m) [[m[1], ''], [m[2], 'font-size:.5em;font-weight:600;']].forEach(function (x) {
        var e = document.createElement(x[1] ? 'small' : 'span'); e.textContent = x[0]; e.style.cssText = 'display:block;line-height:1;text-align:center;' + x[1]; pv.appendChild(e);
      });
    }
  }
  window.CP_epLabel = function (mm) { return epLabel(mm); };
  function prixChantProf(A) {
    var q = parEp(A), e = q && q.chant_prix != null && q.chant_prix !== '' ? num(q.chant_prix) : prixChantSelonProf(A);   /* R180 : le prix d'un chant de l'épaisseur */
    if (e != null && A._eff) A._eff.edgeBandingUnitEuro = e;
  }
  window.CP_prixChant = function (A) { A = A || getApp(); return A ? prixChantSelonProf(A) : null; };
  /* cases des côtés (plan droit) : « Côté gauche : chant de la couleur du décor (+39,00 €) » */
  function nommerCotes(A) {
    var e = prixChantSelonProf(A); if (e == null || !A.dims || (A.S && A.S.layout) !== 'linear') return;
    [['sides', 'Côté gauche'], ['right', 'Côté droit']].forEach(function (c) {
      var cb = A.dims.querySelector('.edge-checkbox-visual[data-edge="' + c[0] + '"]'); if (!cb) return;
      var t = typeof window.CP_texteChant === 'function' ? window.CP_texteChant(A, cb) : null; if (!t) return;   /* R148-b3 : « Chant du côté gauche : brut. Cocher pour le finir, +39,00 €. » */
      if (cb.getAttribute('aria-label') !== t) cb.setAttribute('aria-label', t);
      if (cb.title !== t) cb.title = t;
    });
  }
  /* ── Lot « crédences » (R35, A-328) : chant au mètre linéaire (réglage de la règle « Prix d'un chant au mètre linéaire »,
     chantPrixMl ; crédences quartz et Silestone, plan droit). Chaque chant coché et payant (mêmes règles que le moteur : ni
     verrouillé au produit, ni imposé par « tous les chants » ou par la profondeur) est facturé à sa longueur : le haut à la
     longueur L, un côté à la hauteur P. Le moteur ne compte alors rien (prix par chant mis à 0 avant son calcul) ; une ligne
     par chant, au même total. Sans le réglage, rien ne change. ── */
  function chantMlEur(A) {
    var id = Number(((A && A._eff) || {}).matchedCollectionId) || 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    var v = rg ? num(rg.chantPrixMl) : 0; return v > 0 ? v : 0;
  }
  var CHANT_ML = { back: { nom: 'Chant du haut', bord: 'haut', cote: 'L' }, front: { nom: 'Chant du bas', bord: 'bas', cote: 'L' }, sides: { nom: 'Chant du côté gauche', bord: 'côté gauche', cote: 'P' }, right: { nom: 'Chant du côté droit', bord: 'côté droit', cote: 'P' } };
  function chantsMl(A) {
    var e = chantMlEur(A), S = A.S, E = A._eff || {}; if (!e || !A.dims || (S && S.layout) !== 'linear') return [];
    var locked = E.bandingLocked || {}, out = [];
    Object.keys(CHANT_ML).forEach(function (k) {
      var b = A.dims.querySelector('.edge-checkbox-visual.checked[data-edge="' + k + '"]'); if (!b) return;
      var why = b.dataset.forceReason || 'none';
      if (locked['linear_' + k] === true || E.forceAllBanding === true || why === 'forceAll' || why === 'depthThreshold') return;
      var mm = num(S[CHANT_ML[k].cote]); if (!(mm > 0)) return;
      out.push({ cle: k, nom: CHANT_ML[k].nom, mm: mm, eur: e, cents: Math.round(mm * e / 10) });   /* mm / 1000 × € × 100 centimes */
    });
    return out;
  }
  function chantsMlLignes(A) {
    var l = chantsMl(A), td = document.getElementById('td-options'); if (!l.length || !td) return;
    var ul = td.querySelector('.td-options-list:not(.cp-ilot-opt)');
    if (!ul) {
      var hid = td.querySelector('.td-options-list.cp-ilot-opt');
      td.innerHTML = '<details class="td-options-dropdown" open><summary></summary><div class="td-options-scroll"><ul class="td-options-list"></ul></div></details>';
      ul = td.querySelector('ul'); if (hid) td.appendChild(hid);
    }
    var extra = 0;
    l.forEach(function (c) {
      var li = document.createElement('li');
      li.textContent = c.nom + ' : ' + mlTxt(c.mm / 1000) + NB + 'ml × ' + rate(c.eur) + NB + '€/ml = +' + eur(c.cents / 100) + NB + '€';   /* COMMERCIAL Tour 126, § 6.2 ; N7 */
      ul.appendChild(li); extra += c.cents;
    });
    A.S.optionsTotalCents = num(A.S.optionsTotalCents) + extra;          /* même total : prix affiché, panier, contrôle */
    var sum = td.querySelector('.td-options-dropdown > summary'); if (sum) sum.textContent = 'Suppléments : +' + eurFmt(A.S.optionsTotalCents) + '€';
  }
  /* cases du haut et des côtés (COMMERCIAL Tour 126, § 6.2) : « Chant : haut (brut). Cocher pour un chant fini. », puis
     « Chant : haut (fini) » une fois cochée ; aide sous le dessin. Le prix n'est que sur la ligne. */
  function nommerChantsMl(A) {
    var e = chantMlEur(A), aide = document.getElementById('cp-chants-ml-aide');
    if (!e || !A.dims || (A.S && A.S.layout) !== 'linear') { if (aide && aide.parentNode) aide.parentNode.removeChild(aide); return; }
    Object.keys(CHANT_ML).forEach(function (k) {
      var cb = A.dims.querySelector('.edge-checkbox-visual[data-edge="' + k + '"]'); if (!cb) return;
      /* R148-b3 : « Chant du haut : brut. Cocher pour le finir, +12,34 €. » ; le prix est celui de sa ligne (longueur × prix au mètre) */
      var mm = num(A.S && A.S[CHANT_ML[k].cote]), pc = mm > 0 ? ', +' + eur(Math.round(mm * e / 10) / 100) + ' €' : '', dis = cb.classList.contains('disabled');
      var t = 'Chant du ' + CHANT_ML[k].bord + ' : ' + (cb.classList.contains('checked') ? (dis ? 'fini d\'office, compris dans le prix' : 'fini' + pc) : 'brut. Cocher pour le finir' + pc) + '.';
      if (cb.getAttribute('aria-label') !== t) cb.setAttribute('aria-label', t);
      if (cb.title !== t) cb.title = t;
    });
    var host = document.getElementById('cp-stage-extras') || (document.getElementById('stage') && document.getElementById('stage').parentNode);
    if (!host) return;
    if (!aide) { aide = document.createElement('p'); aide.id = 'cp-chants-ml-aide'; aide.setAttribute('role', 'note'); aide.style.cssText = 'margin:0;font-size:13px;line-height:1.45;color:#374151'; host.appendChild(aide); }
    var ta = 'Les chants sont bruts : cochez ceux qui restent visibles, ils seront finis.';
    if (aide.textContent !== ta) aide.textContent = ta;
    if (host.hidden) host.hidden = false;
  }
  /* ── Lot H18-1 (R19 ; AUDIT 26/10 vers 20:24 ; COMMERCIAL, docs\commercial-h18-textes.md) : réglage de la règle « Ajouté
     d'office à chaque bout » (officeBoutNom, officeBoutEur ; HPL 18 cm : « Bordure latérale », 69 €). Plan droit : une pièce
     par bout, sur une ligne des suppléments au format du moteur (« Bordure latérale : 2 × 69,00 € = +138,00 € »), dans le
     même total (prix affiché, panier, contrôle) ; _cfg_model.bordures ; sur le dessin (consigne 3), le texte de la case de
     chant de chaque bout et une étiquette à chaque bout, posée hors des cases, des cotes et de l'autre étiquette. Sans le
     réglage, rien ne change.
     R191 (Romain : « ce texte "bordure laterale" n a jamais été demandé et n a pas lieu d exister » ; « on a des traits bleu avec
     des checbox depuis le début » ; AUDIT Tours 1036 et 1037) : aucun texte visible ne vient plus du réglage, qui reste un simple
     déclencheur (non vide = 2 bouts d'office). Plus d'étiquette ni d'infobulle propre : les 2 bouts se montrent comme les autres
     chants, par le trait bleu et la case cochée. La ligne est au format des chants des autres plans : « Chants supp. : 2 ×
     69,00 € = +138,00 € » ; même montant, même total. _cfg_model.bordures inchangé (donnée de l'atelier, cachée). ── */
  function bordures(A) {
    var id = Number(((A && A._eff) || {}).matchedCollectionId) || 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    var nom = rg ? String(rg.officeBoutNom || '').trim() : '', u = rg ? Math.round(num(rg.officeBoutEur) * 100) : 0;
    if (!nom || !A.S || A.S.layout !== 'linear') return null;
    /* R182-a : chant arrière sur un cœur noir (cp-pierre-angle), au prix d'un chant de la vraie profondeur (39 € en 60/63, 59 € en 90) */
    if (arrCotes(A)) { var c = prixChantSelonProf(A), uc = c == null ? 0 : Math.round(num(c) * 100); return uc > 0 ? { nom: nom, quantite: 2, prix_unitaire_centimes: uc, prix_centimes: 2 * uc, bouts: ['bout gauche', 'bout droit'] } : null; }
    if (!(u > 0) || !officeEp(A)) return null;   /* R180 : selon l'épaisseur */
    return { nom: nom, quantite: 2, prix_unitaire_centimes: u, prix_centimes: 2 * u, bouts: ['bout gauche', 'bout droit'] };
  }
  function arrCotes(A) { return typeof window.CP_arrCotes === 'function' && window.CP_arrCotes(A) === true; }
  function borduresLigne(A) {
    var b = bordures(A), td = document.getElementById('td-options'); if (!b || !td) return;
    var ul = td.querySelector('.td-options-list:not(.cp-ilot-opt)');
    if (!ul) {
      var hid = td.querySelector('.td-options-list.cp-ilot-opt');
      td.innerHTML = '<details class="td-options-dropdown" open><summary></summary><div class="td-options-scroll"><ul class="td-options-list"></ul></div></details>';
      ul = td.querySelector('ul'); if (hid) td.appendChild(hid);
    }
    /* R148-b2 (COMMERCIAL 17:58 ; AUDIT 17:59) : une ligne par chant, « Chant du côté gauche : +69,00 € », toujours les deux,
       d'office ; même montant, même total */
    ['côté gauche', 'côté droit'].forEach(function (n) {
      var li = document.createElement('li');
      li.textContent = ligneSupp('Chant du ' + n, 1, b.prix_unitaire_centimes);
      li.setAttribute('data-cp-bouts', '1');                           /* R191 : pas un chant du moteur (backP80Options la laisse) */
      ul.appendChild(li);
    });
    A.S.optionsTotalCents = num(A.S.optionsTotalCents) + b.prix_centimes;   /* même total : prix affiché, panier, contrôle */
    var sum = td.querySelector('.td-options-dropdown > summary'); if (sum) sum.textContent = 'Suppléments : +' + eurFmt(A.S.optionsTotalCents) + '€';
  }
  /* R180 (COMMERCIAL, docs\commercial-r180-textes.md § 8, texte d'AUDIT) : un côté fini d'office, touché, dit pourquoi il ne se
     décoche pas : « En 18 cm, les chants des 2 côtés sont finis d'office, à 69 € chacun : ce chant ne peut pas être retiré. » */
  window.addEventListener('click', function (e) {
    var cb = e.target && e.target.closest && e.target.closest('#dims .edge-checkbox-visual[data-edge="sides"], #dims .edge-checkbox-visual[data-edge="right"]');
    var A = cb && cb.classList.contains('disabled') ? getApp() : null, b = A && A.S ? bordures(A) : null; if (!b) return;
    var u = b.prix_unitaire_centimes, prix = u % 100 ? (u / 100).toFixed(2).replace('.', ',') : String(u / 100);
    /* R182-a (COMMERCIAL Tour 225 ; AUDIT Tour 1152) : la cause dite, et le geste qui la lève */
    var t = arrCotes(A) ? 'Sur ce décor, le chant arrière impose les 2 côtés finis, à ' + prix + ' € chacun. Pour retirer ce chant, décochez d\'abord le chant arrière.'
      : 'En ' + epLabel(num(A.S.thk)) + ', les chants des 2 côtés sont finis d\'office, à ' + prix + ' € chacun : ce chant ne peut pas être retiré.';
    if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(t, 'info', 7000);
  }, true);
  /* ── Lot R, rehausses (R17 ; AUDIT Tour 771 ; COMMERCIAL Tours 79, 117 et 131) : réglage de la règle « Hauteur fixée par la
     variante » (hauteurVariante). La cote P est la hauteur de la variante choisie (CP_HAUTEUR, métachamp custom.hauteur_mm) :
     elle ne se modifie pas et se nomme « Hauteur ». Plusieurs hauteurs pour un décor (quartz 5 / 8 cm) : des boutons sous
     l'épaisseur. Les options en « cm » ne sont pas lues comme des profondeurs (depthKey éteint). La longueur est ramenée au
     maximum du décor (règle, puis custom.dimensions_max_mm), avec le message de COMMERCIAL. Sans le réglage, rien ne change. ── */
  function hauteurVar(A) {
    var id = Number(((A && A._eff) || {}).matchedCollectionId) || 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    return !!(rg && rg.hauteurVariante === true);
  }
  function hautDe(v) { var t = window.CP_HAUTEUR || {}; return v ? num(t[String(v.id)]) : 0; }
  function variantesDecor(A) { var name = finitionName(A), all = A.shopifyVariants || []; return name ? all.filter(function (v) { return normName(v.title) === normName(name) || variantIs(v, name); }) : []; }
  function hauteursDecor(A) { var out = []; variantesDecor(A).forEach(function (v) { var h = hautDe(v); if (h > 0 && out.indexOf(h) < 0) out.push(h); }); return out.sort(function (a, b) { return a - b; }); }
  /* variante de la hauteur choisie (P) ; sinon la première */
  function byHauteur(A, list) { var P = num(A.S && A.S.P); return list.filter(function (v) { return hautDe(v) === P; })[0] || list[0] || null; }
  /* P = une hauteur du décor (celle d'avant si le décor l'a, sinon la première) ; vrai si P change */
  function syncHauteur(A) {
    if (!hauteurVar(A) || !A.S || A.S.layout !== 'linear') return false;
    var hs = hauteursDecor(A); if (!hs.length) return false;
    if (hs.indexOf(num(A.S.P)) >= 0) return false;
    A.S.P = hs[0]; return true;
  }
  /* un rendu du moteur fait avant le branchement du rendu (wrap, qui attend d'autres modules) gardait P = profondeur de départ
     de la section (300) jusqu'au rendu suivant (relevé CODE, rehausse HPL, 26/10 14:58) : au branchement, P prend la hauteur
     du décor et la fiche est redessinée */
  function hauteurDepart(A) {
    try { if (hauteurVar(A) && typeof A.render === 'function') { syncHauteur(A); A.render(); } } catch (e) { console.warn('[cp-plan]', e); }
  }
  /* longueur maximale du décor : celle de la règle, puis custom.dimensions_max_mm de la variante (Albâtre HPL : 3 000) */
  function maxDecor(A) {
    var m = num(((A && A._eff) || {}).lengthLimits && A._eff.lengthLimits.max) || 0;
    var v = A.getSelectedShopifyVariant ? A.getSelectedShopifyVariant() : null, dm = v && window.CP_DMAX && window.CP_DMAX[v.title];
    if (dm && num(dm.l) > 0) m = m ? Math.min(m, num(dm.l)) : num(dm.l);
    return m;
  }
  function msgRamenee(max) { return 'Longueur ramenée à ' + fmtMm(max) + ' mm : c\'est la longueur maximale de ce décor.'; }   /* COMMERCIAL Tour 117, R3 */
  /* décor changé pour un décor plus court : longueur ramenée, avec le même message */
  function clampLongueur(A) {
    if (!hauteurVar(A) || !A.S || A.S.layout !== 'linear') return null;
    var mx = maxDecor(A); if (!(mx > 0) || !(num(A.S.L) > mx)) return null;
    A.S.L = mx; return msgRamenee(mx);
  }
  /* A-360 : la hauteur se voit sans ouvrir de fenêtre. Le bouton de la barre dit « Épaisseur · Hauteur », « 20 mm · 5 cm » ;
     le choix 5 / 8 cm reste dans sa fenêtre. Réécrit après CFG_UI.updateThicknessButton et après chaque rendu */
  var BAR_HAUT = 'Épaisseur · Hauteur';
  function barHauteur(A) {
    if (!hauteurVar(A) || !A.S || A.S.layout !== 'linear' || !hauteursDecor(A).length) return;
    var btn = document.getElementById('bar-btn-thickness'), lb = btn && btn.querySelector('.bar-item-label'), vl = document.getElementById('bar-value-thickness');
    if (lb && lb.textContent !== BAR_HAUT) lb.textContent = BAR_HAUT;
    var t = (num(A.S.thk) || 30) + NB + 'mm' + NB + '· ' + cmTxt(num(A.S.P)) + NB + 'cm';
    if (vl && vl.textContent !== t) vl.textContent = t;
  }
  /* A-360 : note du cœur noir (HPL, métachamp de variante custom.coeur = « noir », jamais déduit de la hauteur : AUDIT Tour
     771) sous le dessin, visible avant l'ajout au panier ; elle était dans la fenêtre « Épaisseur », fermée */
  function noteCoeur(A) {
    var nt = document.getElementById('cp-coeur-note'), v = A && A.getSelectedShopifyVariant ? A.getSelectedShopifyVariant() : null;
    var on = hauteurVar(A) && A.S && A.S.layout === 'linear' && v && window.CP_COEUR && window.CP_COEUR[String(v.id)] === 'noir';
    if (!on) { if (nt && nt.parentNode) nt.parentNode.removeChild(nt); return; }
    var host = document.getElementById('cp-stage-extras') || (document.getElementById('stage') && document.getElementById('stage').parentNode);
    if (!host) return;
    if (!nt) { nt = document.createElement('p'); nt.id = 'cp-coeur-note'; nt.setAttribute('role', 'note'); nt.style.cssText = 'margin:0;font-size:13px;line-height:1.45;color:#374151'; }
    if (nt.parentNode !== host) host.appendChild(nt);
    var t = 'Chant du dessus bordé ; les chants des deux côtés restent noirs, couleur du cœur du panneau.';   /* COMMERCIAL § 3, Tour 117 */
    if (nt.textContent !== t) nt.textContent = t;
    if (host.hidden) host.hidden = false;
  }
  /* sous l'épaisseur : « Hauteur : {h} cm » (une hauteur) ou des boutons « 5 cm » / « 8 cm » (quartz) avec leur aide */
  function cmTxt(mm) { return String(mm / 10).replace('.', ','); }
  function blocHauteur(A) {
    var box = document.getElementById('cp-hauteur');
    if (!hauteurVar(A) || !A.S || A.S.layout !== 'linear') { if (box && box.parentNode) box.parentNode.removeChild(box); return; }
    var hs = hauteursDecor(A); if (!hs.length) { if (box && box.parentNode) box.parentNode.removeChild(box); return; }
    var host = document.getElementById('thk-container'); if (!host || !host.parentNode) return;
    if (!box) { box = document.createElement('div'); box.id = 'cp-hauteur'; box.style.cssText = 'margin:8px 0 0;font-size:14px;line-height:1.4'; }
    if (box.previousElementSibling !== host) host.parentNode.insertBefore(box, host.nextSibling);
    var P = num(A.S.P), cle = hs.join(',') + '|' + P; if (box.__cpCle === cle) return;
    box.__cpCle = cle; box.innerHTML = '';
    if (hs.length > 1) {
      var lg = document.createElement('div'); lg.setAttribute('role', 'group'); lg.setAttribute('aria-label', 'Hauteur');
      lg.style.cssText = 'display:flex;flex-wrap:wrap;align-items:center;gap:8px';
      var tt = document.createElement('span'); tt.textContent = 'Hauteur'; tt.style.fontWeight = '600'; lg.appendChild(tt);
      hs.forEach(function (h) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = cmTxt(h) + NB + 'cm'; b.setAttribute('aria-pressed', h === P ? 'true' : 'false');
        b.style.cssText = 'min-height:44px;min-width:64px;padding:0 14px;border-radius:8px;font:inherit;cursor:pointer;border:1px solid ' + (h === P ? '#1f2937;background:#1f2937;color:#fff' : '#9ca3af;background:#fff;color:#1f2937');
        b.addEventListener('click', function () { var B = getApp(); if (!B || num(B.S.P) === h) return; B.S.P = h; B.render(); });
        lg.appendChild(b);
      });
      box.appendChild(lg);
      var ai = document.createElement('p'); ai.style.cssText = 'margin:4px 0 0;font-size:13px;color:#374151'; ai.textContent = 'Même prix en 5 ou 8 cm.'; box.appendChild(ai);   /* COMMERCIAL § 3 */
    } else {
      var p1 = document.createElement('p'); p1.style.margin = '0'; p1.textContent = 'Hauteur : ' + cmTxt(hs[0]) + NB + 'cm'; box.appendChild(p1);
    }
  }
  /* récapitulatif (COMMERCIAL Tour 131) : Forme et Jonction masquées ; « Hauteur : {h} cm » sous Épaisseur. A-362 : par la
     classe « hidden » du moteur (display:none!important) ; l'attribut hidden ne suffisait pas, .recap-item est en display:flex */
  function recapHauteur(A) {
    var on = hauteurVar(A) && A.S && A.S.layout === 'linear', ep = document.getElementById('td-epaisseur'), row = ep && ep.closest('.recap-item');
    ['td-forme', 'td-jonction'].forEach(function (id) { var e = document.getElementById(id), r = e && e.closest('.recap-item'); if (r && on && !r.classList.contains('hidden')) r.classList.add('hidden'); });
    var hr = document.getElementById('cp-recap-hauteur');
    if (!on || !row) { if (hr && hr.parentNode) hr.parentNode.removeChild(hr); return; }
    if (!hr) {
      hr = row.cloneNode(true); hr.id = 'cp-recap-hauteur';
      Array.prototype.forEach.call(hr.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
      var lb = hr.querySelector('.recap-label') || hr.firstElementChild; if (lb) lb.textContent = 'Hauteur';
      row.parentNode.insertBefore(hr, row.nextSibling);
    }
    var vl = hr.querySelector('.recap-value') || hr.lastElementChild, t = cmTxt(num(A.S.P)) + NB + 'cm';
    if (vl && vl.textContent !== t) vl.textContent = t;
  }
  window.CP_planHash = function () { var p = window.CP_plan(); return p ? sha256(canon(p)).then(function (h) { return { hash: h, plan: p }; }) : Promise.resolve(null); };

  /* ── 4. Vue réelle (forme en L) ── */
  var NS = 'http://www.w3.org/2000/svg';
  function el(n, a, txt) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (txt) e.textContent = txt; return e; }
  function pathOf(p) { return 'M' + p.map(function (q) { return q[0].toFixed(2) + ' ' + q[1].toFixed(2); }).join(' L') + ' Z'; }

  function drawReal(A, svg) {
    var plan = buildPlan(A), S = A.S, d = decor(), url = A.getWorkImageUrl && A.getWorkImageUrl();
    var geo = geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: num(S.innerAngle || 90), jn: junctionOf(S), dir: S.angleDir === 'left' ? 'left' : 'right' });
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var all = [].concat.apply([], geo.pieces.map(function (p) { return p.pts; })), pad = 420;
    var minx = Math.min.apply(null, all.map(function (q) { return q[0]; })) - pad, maxx = Math.max.apply(null, all.map(function (q) { return q[0]; })) + pad;
    var maxy = Math.max.apply(null, all.map(function (q) { return q[1]; })) + pad;
    svg.setAttribute('viewBox', minx + ' ' + (-pad) + ' ' + (maxx - minx) + ' ' + (maxy + pad));
    svg.appendChild(el('defs', {}));
    var fallback = (A.variantsMeta && A.variantsMeta[S.variant] && A.variantsMeta[S.variant].fallbackColor) || (d && d.hex) || '#e5e7eb';
    geo.pieces.forEach(function (p, i) {
      var fill = fallback;
      if (d && d.tex && url && window.CP_texture) {
        var lg = longest(p.pts);
        fill = 'url(#' + window.CP_texture.makePattern(svg, 'cp-real-' + i, url, d.tex, p.pts[0][0], p.pts[0][1], window.CP_texture.grainAngle(d.tex.fil, lg.deg), p.pts) + ')';   /*  une image par pièce*/
      }
      svg.appendChild(el('path', { d: pathOf(p.pts), fill: fill, stroke: '#1d4a36', 'stroke-width': 6, 'stroke-linejoin': 'round' }));
    });
    svg.appendChild(el('line', { x1: geo.seam[0][0], y1: geo.seam[0][1], x2: geo.seam[1][0], y2: geo.seam[1][1], stroke: '#b3261e', 'stroke-width': 8, 'stroke-dasharray': '30 18' }));
    /* murs et angle */
    var C = geo.corner, dv = geo.dirV, back = S.angleDir === 'left' ? 1 : -1, ang = num(S.innerAngle || 90);
    svg.appendChild(el('line', { x1: C[0] + back * 1200, y1: C[1] - 22, x2: C[0], y2: C[1] - 22, stroke: '#9ca3af', 'stroke-width': 12 }));
    svg.appendChild(el('line', { x1: C[0] + (back > 0 ? -22 : 22), y1: C[1], x2: C[0] + dv[0] * 1200 + (back > 0 ? -22 : 22), y2: C[1] + dv[1] * 1200, stroke: '#9ca3af', 'stroke-width': 12 }));
    var R = 300, a0 = back > 0 ? 0 : Math.PI, a1 = Math.atan2(dv[1], dv[0]);
    var p0 = [C[0] + R * Math.cos(a0), C[1] + R * Math.sin(a0)], p1 = [C[0] + R * Math.cos(a1), C[1] + R * Math.sin(a1)];
    svg.appendChild(el('path', { d: 'M' + p0 + ' A' + R + ' ' + R + ' 0 0 ' + (back > 0 ? 1 : 0) + ' ' + p1, fill: 'none', stroke: '#0d3527', 'stroke-width': 8 }));
    var am = (a0 + a1) / 2;
    svg.appendChild(el('text', { x: C[0] + (R + 170) * Math.cos(am), y: C[1] + (R + 170) * Math.sin(am) + 40, 'font-size': 130, 'text-anchor': 'middle', fill: '#0d3527', 'font-weight': 700, 'font-family': 'Arial, sans-serif' }, ang + '°'));
    /* cotes principales */
    var t = function (x, y, s) { svg.appendChild(el('text', { x: x, y: y, 'font-size': 110, 'text-anchor': 'middle', fill: '#111827', 'font-family': 'Arial, sans-serif' }, s)); };
    t((minx + maxx) / 2, -pad / 2, 'L1 : ' + num(S.L1) + ' mm');
    var endW = [C[0] + dv[0] * (num(S.P1) + num(S.L2)), C[1] + dv[1] * (num(S.P1) + num(S.L2))];
    t((C[0] + endW[0]) / 2 + back * -420, (C[1] + endW[1]) / 2, 'Mur : ' + (num(S.P1) + num(S.L2)) + ' mm');
    return plan;
  }

  function injectCss() {
    if (document.getElementById('cp-real-css')) return;
    var st = document.createElement('style'); st.id = 'cp-real-css';
    st.textContent =
      '#cp-real-btn{border:1px solid #1d4a36;background:#fff;color:#1d4a36;border-radius:999px;padding:.3rem .8rem;font-size:.8rem;cursor:pointer}' +
      '#cp-real-btn.is-warn{background:#1d4a36;color:#fff}' +
      '#cp-real{position:absolute;inset:0;background:#fff;z-index:1000;display:flex;flex-direction:column}' +
      '#cp-real[hidden]{display:none}' +
      '#cp-real header{display:flex;justify-content:space-between;align-items:center;gap:.5rem;padding:.5rem .8rem;font-size:.85rem;border-bottom:1px solid #e5e7eb}' +
      '#cp-real header button{border:0;background:#f3f4f6;border-radius:6px;padding:.25rem .6rem;cursor:pointer}' +
      '#cp-real svg{flex:1;width:100%;min-height:0}' +
      '#cp-real ul{margin:0;padding:.4rem .9rem .6rem 1.8rem;font-size:.75rem;color:#374151;max-height:30%;overflow:auto}' +
      '#cp-real li.ko{color:#b3261e;font-weight:600}';
    document.head.appendChild(st);
  }

  function syncRealButton(A) {
    /*  le dessin principal est désormais le tracé réel (cp-trace.js, étape 5) ;
       la « Vue réelle » à part est retirée.*/
    var old = document.getElementById('cp-real-btn'); if (old) old.remove();
    var ov = document.getElementById('cp-real'); if (ov) ov.remove();
    return;
    var bar = document.getElementById('stage-toolbar'), stage = document.getElementById('stage');
    if (!bar || !stage) return;
    injectCss();
    var btn = document.getElementById('cp-real-btn');
    if (!btn) {
      btn = document.createElement('button'); btn.type = 'button'; btn.id = 'cp-real-btn';
      var spacer = bar.querySelector('.stage-toolbar-spacer'); bar.insertBefore(btn, spacer || null);
      btn.addEventListener('click', function () { openReal(getApp()); });
    }
    var isAngle = A.S.layout === 'angle', ang = num(A.S.innerAngle || 90);
    btn.hidden = !isAngle;
    btn.textContent = ang !== 90 ? 'Vue réelle ' + ang + '°' : 'Vue réelle';
    btn.classList.toggle('is-warn', ang !== 90);
    var box = document.getElementById('cp-real');
    if (box && !box.hidden) { if (isAngle) fillReal(A, box); else box.hidden = true; }
  }

  function fillReal(A, box) {
    var plan = drawReal(A, box.querySelector('svg'));
    var ul = box.querySelector('ul'); ul.innerHTML = '';
    plan.controles.forEach(function (c) {
      var li = document.createElement('li'); li.className = c.ok ? 'ok' : 'ko';
      li.textContent = (c.ok ? '✓ ' : '✗ ') + c.message; ul.appendChild(li);
    });
    var tx = plan.produit.decor && plan.produit.decor.texture;
    box.querySelector('.cp-real-sub').textContent = 'Tracé point par point' +
      (tx ? ' · décor ' + tx.l_mm + ' × ' + tx.h_mm + ' mm (' + tx.echelle + ', échelle ' + tx.echelle_statut + ')' : '');
  }

  function openReal(A) {
    var stage = document.getElementById('stage'); if (!stage) return;
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    var box = document.getElementById('cp-real');
    if (!box) {
      box = document.createElement('div'); box.id = 'cp-real';
      box.innerHTML = '<header><div><strong>Vue réelle</strong> <span class="cp-real-sub"></span></div><button type="button">Fermer</button></header>' +
        '<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"></svg><ul></ul>';
      stage.appendChild(box);
      box.querySelector('header button').addEventListener('click', function () { box.hidden = true; });
    }
    box.hidden = false;
    fillReal(A, box);
  }

  /* ── Chants imposés par un coin usiné ──
     Lus dans l'état réel, jamais écrits en dur : cases que le moteur impose à cause d'un usinage
     (raison « edge ») dont l'arête touche le sommet réel de CE coin (modèle : chants_aretes et
     usinages[].sommet). Coût : règle du moteur (updateTdOptionsList) : une case cochée, ni
     verrouillée au produit, ni imposée par « tous les chants » ou par la profondeur, compte
     _eff.edgeBandingUnitEuro. Un chant qu'un autre coin usiné impose déjà ne coûte rien de plus.*/
  function imposedBy(A, key) {
    if (typeof window.CP_coinDuBout === 'function' && window.CP_coinDuBout(key)) return null;   /* biais ou arrondi d'un bout : livré fini, chant compris */
    var S = A.S, E = A._eff || {}, plan = buildPlan(A), u = (plan.usinages || {})[key];
    if (!u || !u.sommet || !plan.chants_aretes) return null;
    var V = u.sommet, at = function (q) { return len(q, V) < 1; };
    var special = function (k) { var t = (S.edges || {})[k]; return !!t && t !== 'straight' && t !== 'notch'; };
    var boxOf = function (k) { return A.dims && A.dims.querySelector('.edge-checkbox-visual.checked[data-edge="' + k + '"]'); };
    var lay = S.layout || 'linear', pre = lay === 'linear' ? 'linear_' : lay === 'angle' ? 'angle_' : lay === 'u-shape' ? 'u_' : null;
    var locked = function (k) { var p = pre || (/GL(?:_|$)/.test(k) ? 'gl_' : 'g_'); return (E.bandingLocked || {})[p + k] === true; };
    var ff = num(E.forceBandingFromDepth), dp = { linear: ['P'], angle: ['P1', 'P2'], 'u-shape': ['Pc', 'Pl', 'Pr'], 'g-shape': ['Pgtop', 'Pgleft', 'Pgright', 'Pgreturn'] }[lay] || [];
    var included = E.forceAllBanding === true || (ff > 0 && dp.length && dp.every(function (k) { return num(S[k]) >= ff; }));
    var seen = {}, list = [];
    plan.chants_aretes.forEach(function (c) {
      if (c.usinage || seen[c.cle] || !(at(c.arete[0]) || at(c.arete[1]))) return;
      var b = boxOf(c.cle); if (!b || b.dataset.forceReason !== 'edge' || locked(c.cle)) return;   /* verrouillé au produit : toujours là, rien d'ajouté */
      seen[c.cle] = true;
      var other = at(c.arete[0]) ? c.arete[1] : c.arete[0];
      var shared = Object.keys(plan.usinages).some(function (k) { var w = plan.usinages[k]; return k !== key && special(k) && w.sommet && len(w.sommet, other) < 1; });
      /* R148-b3 (ADMIN Tour 980) : le bord, lu dans « Chant du {bord} : {état} » (ou l'ancien « Chant : {bord} (imposé) ») */
      var host = b.closest('[aria-label]') || b, al = b.getAttribute('aria-label') || host.getAttribute('aria-label') || '', mb = al.match(/^Chant du (.+?) : /);
      var nom = mb ? mb[1] : (al || c.cle).replace(/^Chant\s*:\s*/, '').replace(/\s*\(imposé\)\s*$/, '');
      list.push({ cle: c.cle, nom: nom, shared: shared, paid: !included && !locked(c.cle) && !shared });
    });
    var unit = Math.round(num(E.edgeBandingUnitEuro) * 100);
    return { list: list, cents: unit * list.filter(function (x) { return x.paid; }).length };
  }
  window.CP_imposedChants = function (key) { var A = getApp(); return A ? imposedBy(A, key) : null; };

  /*  la fenêtre du coin borne ses cotes sur le rectangle du moteur. En L en retour
     filant, le coin extérieur appartient au retour (1800 × 600) mais il est borné sur la bande du plan
     (2370 mm à l'horizontale). Quand une borne dépasse le mur de la pièce du sommet et que le contour
     continue sur une pièce voisine, la fenêtre dit à partir d'où l'usinage entame celle-ci.*/
  /* sommet réel d'un coin (zone de clic du moteur, portée sur le tracé) et ses deux murs : arêtes des pièces
     du sommet qui ne sont pas une jonction ; next = pièce sur laquelle le contour continue, tout droit,
     au bout du mur (null : le mur finit sur un bout libre ou sur un angle rentrant) */
  function cornerWalls(A, k) {
    var svg = A.svg, h = svg && svg.querySelector('rect.hit[data-cp-id="' + k + '"]');
    if (!h) return null;
    var c = [num(h.getAttribute('x')) + num(h.getAttribute('width')) / 2, num(h.getAttribute('y')) + num(h.getAttribute('height')) / 2], P = [], V = null, dv = Infinity;
    Array.prototype.forEach.call(svg.querySelectorAll('.cp-trace [data-piece]'), function (g) {
      var poly = svg.querySelector((g.getAttribute('clip-path') || '').replace(/^url\(|\)$/g, '') + ' polygon'); if (!poly) return;
      var pts = poly.getAttribute('points').trim().split(/\s+/).map(function (s) { return s.split(',').map(Number); });
      P.push({ id: g.getAttribute('data-piece'), pts: pts });
      pts.forEach(function (q) { var d = len(q, c); if (d < dv) { dv = d; V = q; } });
    });
    return (!V || dv > 400) ? null : wallsAt(P, V);
  }
  /* dessin du moteur, à 90° (repère du dessin) : la même géométrie à 90°, coupes à 45° dessinées en
     « retour filant » comme le moteur les dessine (cp-jonction) */
  function engineGeom(A) {
    var S = A.S, bs = (A._cpPieces || []).filter(function (b) { return isFinite(b.x) && isFinite(b.y); }), g = null, fl = function (j) { return j === 'onglet' ? 'retour' : j; };
    if (!bs.length) return null;
    var O = [Math.min.apply(null, bs.map(function (b) { return num(b.x); })), Math.min.apply(null, bs.map(function (b) { return num(b.y); }))];
    if (S.layout === 'angle') g = geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: 90, jn: S.junctionType === 'overlap' && !S.cpJ45 ? 'barre' : 'retour', dir: S.angleDir === 'left' ? 'left' : 'right' });
    else if (S.layout === 'u-shape') { var j = jnUside(S); g = geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr), jl: fl(j.g), jr: fl(j.d), aL: 90, aR: 90 }); }
    else if (S.layout === 'g-shape') {
      var jg = jnGside(S);
      g = geomG({ Gtop: num(S.Gtop), Gleft: num(S.Gleft), Gright: num(S.Gright), Greturn: num(S.Greturn), Pgtop: num(S.Pgtop), Pgleft: num(S.Pgleft), Pgright: num(S.Pgright), Pgreturn: num(S.Pgreturn),
        top: fl(jg.top), mid: fl(jg.mid), ret: fl(jg.ret), dir: S.gDir === 'left' ? 'left' : 'right', aTop: 90, aMid: 90, aRet: 90 });
    }
    else if (S.layout === 'linear') g = geomLinear({ L: num(S.L), P: num(S.P) });
    return g ? g.pieces.map(function (p) { return { id: p.id, pts: p.pts.map(function (q) { return [q[0] + O[0], q[1] + O[1]]; }) }; }) : null;
  }
  function wallsAt(P, V) {
    var walls = [], onEdgeOf = function (o, q) { return o.pts.some(function (a, i) { return segDist(q, a, o.pts[(i + 1) % o.pts.length]) <= 0.2; }); };
    P.forEach(function (p) {
      var n = p.pts.length, i = p.pts.findIndex(function (q) { return len(q, V) < 1; }); if (i < 0) return;
      [p.pts[(i + n - 1) % n], p.pts[(i + 1) % n]].forEach(function (w) {
        var L = len(V, w); if (L < 1) return;
        var u = [(w[0] - V[0]) / L, (w[1] - V[1]) / L], e = L;
        /* partie exposée depuis le sommet : l'arête peut être commune plus loin avec une autre pièce (en
           retour filant, le bas de l'arête intérieure du retour est exposé, le haut est la jonction) */
        P.forEach(function (o) {
          if (o.id === p.id) return;
          o.pts.forEach(function (a, j) {
            var b = o.pts[(j + 1) % o.pts.length], cr = function (q) { return Math.abs((q[0] - V[0]) * u[1] - (q[1] - V[1]) * u[0]); };
            if (cr(a) > 0.2 || cr(b) > 0.2) return;
            var ta = (a[0] - V[0]) * u[0] + (a[1] - V[1]) * u[1], tb = (b[0] - V[0]) * u[0] + (b[1] - V[1]) * u[1];
            var lo = Math.max(0, Math.min(ta, tb)), hi = Math.min(L, Math.max(ta, tb));
            if (hi - lo > 1) e = Math.min(e, lo);
          });
        });
        if (e < 1) return;                                 /* arête de jonction (onglet, bout de pièce contre une autre) */
        var q = [V[0] + u[0] * (e + 1), V[1] + u[1] * (e + 1)];
        var nx = e < L - 0.5 ? null : P.filter(function (o) { return o.id !== p.id && onEdgeOf(o, q); })[0];   /* jonction avant le bout : angle rentrant */
        walls.push({ u: u, e: e, own: p.id, hz: Math.abs(u[0]) >= Math.abs(u[1]), next: nx ? nx.id : null });
      });
    });
    return walls.length === 2 ? { V: V, P: P, walls: walls } : null;
  }
  /*  le long d'un mur qui ne continue pas sur une pièce voisine (bout libre, ou angle
     rentrant d'une jonction), un chanfrein ou une encoche garde 30 mm de matière, comme le moteur le fait
     au bout de sa pièce (MIN_REST). Sans cela, une encoche de 2 370 mm au bas d'un plan de 1 800 mm
     traversait la jonction et coupait le retour en plein milieu. La borne vaut sur le tracé réel ET sur
     le dessin du moteur à 90° (rect, corner : rectangle et coin reçus par la fenêtre) : hors d'équerre,
     un plan plus long que dans le dessin du moteur y ferait encore traverser l'encoche, et le moteur y
     fait suivre le chant. Renvoie les bornes horizontale et verticale (Infinity : celle du moteur reste).*/
  function cornerBound(A, k, rect, corner) {
    var S = A.S, t = (S.edges || {})[k], b = { h: Infinity, v: Infinity, w: {} };
    if (t !== 'bevel' && t !== 'notch') return b;
    var off = t === 'notch' ? num(((S.notch || {})[k] || {}).offset) : 0, sets = [cornerWalls(A, k)];
    if (rect && corner) {
      var E = engineGeom(A), Ve = [num(rect.x) + (/r$/.test(corner) ? num(rect.w) : 0), num(rect.y) + (/^b/.test(corner) ? num(rect.h) : 0)];
      if (E && E.some(function (p) { return p.pts.some(function (q) { return len(q, Ve) < 1; }); })) sets.push(wallsAt(E, Ve));
    }
    sets.forEach(function (cw) {
      (cw ? cw.walls : []).forEach(function (w) {
        if (w.next) return;                                /* le contour continue : l'usinage peut s'y prolonger*/
        var lim = Math.floor(w.e - (w.hz ? off : 0) - 30 + 0.05);        /* tracé arrondi au centième */
        if (w.hz) { if (lim < b.h) { b.h = lim; b.w.h = w; } } else if (lim < b.v) { b.v = lim; b.w.v = w; }
      });
    });
    return b;
  }
  window.CP_cornerBound = function (k) { var A = getApp(); return A ? { walls: (cornerWalls(A, k) || {}).walls || null, bornes: cornerBound(A, k) } : null; };
  /* bornes d'un chanfrein ou d'une encoche : celles de la fenêtre du moteur (côté − 30 mm) et celles du
     mur de la pièce (cornerBound), au moins le minimum du moteur (encoche 30 mm, chanfrein 10 mm) */
  function machLimits(A, k, rect, corner) {
    var t = (A.S.edges || {})[k];
    if ((t !== 'bevel' && t !== 'notch') || !rect) return null;
    var bd = cornerBound(A, k, rect, corner), mn = t === 'notch' ? 30 : 10;
    return { t: t, bd: bd, h: Math.max(mn, Math.min(Math.round(num(rect.w)) - 30, bd.h)), v: Math.max(mn, Math.min(Math.round(num(rect.h)) - 30, bd.v)) };
  }
  function clampMsg(A, t, ch, cv, bd) {
    var w0 = ch !== null ? bd.w.h : bd.w.v, ro = w0 && w0.own ? pieceRole(A, w0.own) : 'pièce';
    return (t === 'bevel' ? 'Chanfrein' : 'Encoche') + ' ramené' + (t === 'notch' ? 'e' : '') + ' à ' +
      [ch !== null ? ch + ' mm à l\'horizontale' : '', cv !== null ? cv + ' mm à la verticale' : ''].filter(Boolean).join(' et ') +
      ' : ' + (t === 'notch' ? 'elle' : 'il') + ' garde 30 mm de matière à l\'extrémité ' + (/^(jambe|pièce)/.test(ro) ? 'de la ' : 'du ') + ro + '.';
  }
  /*  après un rendu, chaque usinage au-delà de sa borne y est ramené ; renvoie les messages*/
  function clampMachining(A) {
    var S = A.S, R = A._cpHitRect || {}, msgs = [];
    Object.keys(R).forEach(function (k) {
      var lm = machLimits(A, k, R[k].rect, R[k].corner); if (!lm) return;
      var d = ((lm.t === 'bevel' ? S.bevel : S.notch) || {})[k]; if (!d) return;
      var ch = num(d.dx) > lm.h ? lm.h : null, cv = num(d.dy) > lm.v ? lm.v : null;
      if (ch === null && cv === null) return;
      if (ch !== null) d.dx = ch;
      if (cv !== null) d.dy = cv;
      msgs.push(clampMsg(A, lm.t, ch, cv, lm.bd));
    });
    return msgs;
  }
  /* contrôle en filet : usinages dans leurs bornes (liste des dépassements) */
  function machOverruns(A) {
    var S = A.S, R = A._cpHitRect || {}, out = [];
    Object.keys(R).forEach(function (k) {
      var lm = machLimits(A, k, R[k].rect, R[k].corner); if (!lm) return;
      var d = ((lm.t === 'bevel' ? S.bevel : S.notch) || {})[k] || {};
      if (!(num(d.dx) > lm.h + 0.5 || num(d.dy) > lm.v + 0.5)) return;
      /* L4 (lot « messages 1 ») : le coin par le nom de la liste « Usinage des coins », celui du titre de sa fenêtre */
      var nm = (A.__cpCoins || []).filter(function (x) { return x.k === k; })[0], coin = nm ? ' (' + nm.nom + ')' : '';
      out.push((lm.t === 'bevel' ? 'Le chanfrein' + coin + ' est trop grand' : 'L\'encoche' + coin + ' est trop grande') + ' : ' + num(d.dx) + ' × ' + num(d.dy) + ' mm, ' +
        lm.h + ' × ' + lm.v + ' mm au plus. ' + (lm.t === 'bevel' ? 'Réduisez-le' : 'Réduisez-la'));
    });
    return out;
  }
  function pieceRole(A, id) {                             /* nom de pièce du modèle, d'après son id dans le tracé */
    var L = A.S.layout, m = L === 'u-shape' ? { gauche: 'jambe gauche', droite: 'jambe droite', fond: 'fond du U' }
      : L === 'g-shape' ? { gauche: 'montant gauche', droite: 'montant droit', haut: 'plan principal', retour: 'retour' }
      : L === 'angle' ? { plan: 'plan principal', retour: 'retour' } : { plan: 'plan' };
    return m[id] || id;
  }
  function reachNote(A, k, pl) {
    var S = A.S, t = (S.edges || {})[k], cw = /^(bevel|notch|round1)$/.test(t || '') ? cornerWalls(A, k) : null;
    if (!cw) return '';
    var V = cw.V, P = cw.P, walls = cw.walls;
    var maxOf = function (id) { var f = document.getElementById(id); return f ? num(f.getAttribute('max')) : 0; };
    var cosT = walls[0].u[0] * walls[1].u[0] + walls[0].u[1] * walls[1].u[1], tanH = Math.tan(Math.acos(Math.max(-1, Math.min(1, cosT))) / 2);
    var off = t === 'notch' ? num(((S.notch || {})[k] || {}).offset) : 0, role = function (id) {
      var pc = ((pl && pl.pieces) || []).filter(function (x) { return x.id === id; })[0], r = pc ? pc.role : id;
      return (/^jambe/.test(r) ? 'la ' : 'le ') + r;
    };
    var out = [];
    walls.forEach(function (w) {
      var hz = Math.abs(w.u[0]) >= Math.abs(w.u[1]), lim, max, how;
      if (t === 'round1') { lim = w.e * tanH; max = maxOf('edge-r'); how = 'de rayon'; }  /* l'arc quitte le mur à r / tan(θ/2) */
      else if (t === 'bevel') { lim = w.e; max = maxOf(hz ? 'edge-bx' : 'edge-by'); how = hz ? 'à l\'horizontale' : 'à la verticale'; }
      else { lim = w.e - (hz ? off : 0); max = maxOf(hz ? 'edge-nx' : 'edge-ny'); how = hz ? 'en longueur' : 'en profondeur'; }
      if (!max || lim >= max - 0.5 || lim < 1 || !w.next) return;
      if (out.every(function (x) { return x.how !== how; })) out.push({ how: how, lim: Math.floor(lim), nb: role(w.next) });
    });
    return out.map(function (x, i) { return (i ? 'au-delà' : 'Au-delà') + ' de ' + x.lim + ' mm ' + x.how + ', l\'usinage entame aussi ' + x.nb; }).join(' ; ') + (out.length ? '.' : '');
  }

  /* coins que le moteur facture (configurator-main, updateTdOptionsList) et libellés de ses lignes */
  var ENGINE_CORNER_KEYS = {
    linear: ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'],
    angle: ['endHTL', 'endHTR', 'endHBL', 'endHBR', 'endVTL', 'endVTR', 'endVBL', 'endVBR'],
    'u-shape': ['footLTL', 'footLBL', 'footLBR', 'footRTR', 'footRBL', 'footRBR'],
    'g-shape': ['gLeftTL', 'gLeftBL', 'gLeftBR', 'gTopTL', 'gTopTR', 'gTopBR', 'gRightTR', 'gRightBL', 'gRightBR', 'gReturnTL', 'gReturnTR', 'gReturnBL']
  };
  var CORNER_LINE = { round1: 'Coins arrondis', semi: 'Demi-ronds', bevel: 'Chanfreins', notch: 'Encoches' };
  var SEMI_SEUL = 'Demi-rond';                                       /* demi-rond seul, quand les coins arrondis sont comptés avec les bouts */
  function eurFmt(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function addMissingCornerLines(A) {
    var S = A.S, list = ENGINE_CORNER_KEYS[S.layout], add = {};
    if (!list || !A.svg) return;
    Array.prototype.forEach.call(A.svg.querySelectorAll('rect.hit[data-cp-id]'), function (h) {
      var k = h.getAttribute('data-cp-id'), t = (S.edges || {})[k];
      if (list.indexOf(k) < 0 && CORNER_LINE[t]) add[t] = (add[t] || 0) + 1;
    });
    var ep = (A._eff || {}).edgePricesEuro || {}, td = document.getElementById('td-options'), extra = 0;
    if (!td) return;
    Object.keys(add).forEach(function (t) {
      var unit = Math.round(num(ep[t]) * 100), q = add[t]; if (!(unit > 0)) return;
      var ul = td.querySelector('.td-options-list:not(.cp-ilot-opt)');
      if (!ul) {                                        /* liste cachée (îlot, retour fini 4 côtés) : gardée telle quelle, à part */
        var hid = td.querySelector('.td-options-list.cp-ilot-opt');
        td.innerHTML = '<details class="td-options-dropdown" open><summary></summary><div class="td-options-scroll"><ul class="td-options-list"></ul></div></details>';
        ul = td.querySelector('ul'); if (hid) td.appendChild(hid);
      }
      var li = Array.prototype.filter.call(ul.querySelectorAll('li'), function (l) { return estLigne(l.textContent, CORNER_LINE[t]); })[0];
      var lu = li && lireSupp(li.textContent), n = lu ? lu.q : 0;           /* N4 : quantité des deux formes (1 sans « × ») */
      if (!li) { li = document.createElement('li'); ul.appendChild(li); }
      li.textContent = ligneSupp(CORNER_LINE[t], n + q, unit);
      extra += unit * q;
    });
    if (!extra) return;
    S.optionsTotalCents = num(S.optionsTotalCents) + extra;                /* même total : prix affiché, panier, contrôle */
    var sum = td.querySelector('.td-options-dropdown > summary'); if (sum) sum.textContent = 'Suppléments : +' + eurFmt(S.optionsTotalCents) + '€';
  }

  /* ── Demi-rond facturé par bout (réglage de la règle « Demi-rond facturé par bout ») ──
     Les 2 coins demi-rond du petit côté d'une même pièce font un bout arrondi : un demi-rond facturé. Un coin demi-rond
     seul est une découpe arrondie : facturé au prix du coin arrondi. Le dessin ne change pas. Coins comptés : ceux du
     dessin (zones de clic), comme le contrôle des usinages. Sans le réglage, rien ne change (un demi-rond par coin). */
  var SEMI_PAIRES = {
    linear: [['topLeft', 'bottomLeft'], ['topRight', 'bottomRight']],
    angle: [['endHTL', 'endHBL'], ['endHTR', 'endHBR'], ['endVTL', 'endVTR'], ['endVBL', 'endVBR']],
    'u-shape': [['footLBL', 'footLBR'], ['footRBL', 'footRBR']],
    'g-shape': [['gLeftBL', 'gLeftBR'], ['gRightTL', 'gRightTR'], ['gRightBL', 'gRightBR'], ['gTopTR', 'gTopBR'], ['gReturnTL', 'gReturnBL'], ['gReturnTR', 'gReturnBR']]
  };
  function semiParBoutOn(A) {
    var id = Number(((A && A._eff) || {}).matchedCollectionId) || 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    return !!(rg && rg.semiParBout === true);
  }
  /* { bouts, seuls, coins } des coins demi-rond dessinés ; null sans le réglage */
  function semiCompte(A) {
    if (!semiParBoutOn(A) || !A.svg) return null;
    var S = A.S, ed = S.edges || {}, semi = [], pris = 0, bouts = 0;
    Array.prototype.forEach.call(A.svg.querySelectorAll('rect.hit[data-cp-id]'), function (h) {
      var k = h.getAttribute('data-cp-id'); if (ed[k] === 'semi' && semi.indexOf(k) < 0) semi.push(k);
    });
    (SEMI_PAIRES[S.layout] || []).forEach(function (p) { if (semi.indexOf(p[0]) >= 0 && semi.indexOf(p[1]) >= 0) { bouts++; pris += 2; } });
    return { bouts: bouts, seuls: semi.length - pris, coins: semi.length };
  }
  /* lignes « Demi-ronds » et « Coins arrondis » du récapitulatif refaites d'après ce compte, écart reporté au total */
  function semiLignes(A) {
    var c = semiCompte(A), td = document.getElementById('td-options'), ul = td && td.querySelector('.td-options-list:not(.cp-ilot-opt)');
    if (!c || !c.coins || !ul) return;
    var ep = (A._eff || {}).edgePricesEuro || {}, uS = Math.round(num(ep.semi) * 100), uR = Math.round(num(ep.round1) * 100);
    if (!uR && typeof window.CP_arrondiEur === 'function') uR = Math.round(num(window.CP_arrondiEur()) * 100);   /* coin arrondi du bout (prix de la règle, compté avec les bouts) */
    var ligne = function (lab) { return Array.prototype.filter.call(ul.querySelectorAll('li'), function (l) { return estLigne(l.textContent, lab); })[0] || null; };
    var montant = function (l) { var x = l && lireSupp(l.textContent); return x ? x.tot : 0; };   /* N5 : total des deux formes (sans « = » pour une seule) */
    var lS = ligne(CORNER_LINE.semi), lR = ligne(CORNER_LINE.round1), lU = ligne(SEMI_SEUL), avant = montant(lS) + montant(lR) + montant(lU);
    var lrS = lR && lireSupp(lR.textContent), nR = lrS ? lrS.q : 0, apres = 0;
    var pose = function (l, t, unit, q, avantDe, lab) {
      if (!(q > 0) || !(unit > 0)) { if (l) l.parentNode.removeChild(l); return null; }
      if (!l) { l = document.createElement('li'); if (avantDe && avantDe.parentNode === ul) ul.insertBefore(l, avantDe); else ul.appendChild(l); }
      l.textContent = ligneSupp(lab || CORNER_LINE[t], q, unit);
      apres += unit * q; return l;
    };
    /* A-290 (06/10) : un demi-rond est facturé par bout, au prix du demi-rond, une fois, à un coin ou aux deux. Seul (un coin
       du bout) : sa ligne « Demi-rond : +179,00 € », au prix du demi-rond, plus au prix du coin arrondi sur « Coins
       arrondis » (stratifié : 99 au lieu de 179, en ligne). HPL (A-283) : même ligne, même montant (179). Les coins arrondis
       restent sur leur ligne ; les chants imposés ne changent pas */
    pose(lR, 'round1', uR, nR, lS);
    pose(lU, 'semi', uS, c.seuls, lS, SEMI_SEUL);
    pose(lS, 'semi', uS, c.bouts, null);
    if (apres === avant) return;
    A.S.optionsTotalCents = num(A.S.optionsTotalCents) - avant + apres;   /* même total : prix affiché, panier, contrôle */
    var sum = td.querySelector('.td-options-dropdown > summary'); if (sum) sum.textContent = 'Suppléments : +' + eurFmt(A.S.optionsTotalCents) + '€';
  }
  /* montant des usinages lu dans le récapitulatif (lignes du moteur, complétées ci-dessus) */
  function cornerLinesCents() {
    var td = document.getElementById('td-options'), c = 0, labs = Object.keys(CORNER_LINE).map(function (k) { return CORNER_LINE[k]; }).concat([NOTCH_B, NOTCH_F, SEMI_SEUL]);
    Array.prototype.forEach.call(td ? td.querySelectorAll('.td-options-list li') : [], function (l) {
      var t = l.textContent.trim(), x = labs.some(function (lb) { return estLigne(t, lb); }) && lireSupp(t);
      if (x) c += x.tot;
    });
    return c;
  }

  /* ── Encoche finie (réglages de la règle « Encoche finie proposée » et « Supplément encoche finie ») ──
     Proposée seulement si l'encoche l'est et si son supplément est au moins celui de l'encoche brute. Le choix de chaque
     encoche (S.notch[coin].fini) se fait dans sa fenêtre ; il part avec l'encoche. Sans le réglage, rien ne change. */
  var NOTCH_B = 'Encoches brutes', NOTCH_F = 'Encoches finies';
  function notchFini(A) {
    var e = (A && A._eff) || {}, id = Number(e.matchedCollectionId) || 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    var nf = rg && rg.notchFini, brute = num((e.edgePricesEuro || {}).notch), fini = nf ? num(nf.eur) : 0;
    if (!nf || nf.on !== true || !(e.edgeTypes && e.edgeTypes.notch === true) || !(fini > 0) || fini < brute) return null;
    return { brute: brute, fini: fini };
  }
  window.CP_notchFini = function (A) { A = A || getApp(); return A ? notchFini(A) : null; };
  function estFinie(A, k) { var n = (A.S.notch || {})[k]; return !!(n && n.fini); }
  /* Réglage de la règle « Encoche finie selon le chant arrière » : pas de choix du client. Une encoche est finie si
     l'arrière d'une pièce qu'elle entame est chanté, ou si le plan est un îlot (tous ses bords finis) ; brute sinon.
     S.notch[coin].fini est recalculé à chaque calcul du prix : récapitulatif, dessin, contrôle et panier le suivent. */
  function notchAuto(A) {
    var id = Number(((A && A._eff) || {}).matchedCollectionId) || 0;
    var rg = ((window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || []).filter(function (r) { return Number(r.collectionId) === id; })[0];
    return !!(rg && rg.notchFini && rg.notchFini.auto === true);
  }
  function arriereChante(A, piece) {
    if (document.documentElement.classList.contains('cp-ilot')) return true;
    var S = A.S, T = S.layout === 'linear' ? { back: 'plan' } : arrTable(S); if (!T || !A.dims || !A.dims.querySelector) return false;
    return Object.keys(T).some(function (k) {
      if (T[k] !== piece) return false;
      var el = A.dims.querySelector('.edge-checkbox-visual[data-edge="' + k + '"]'); return !!(el && el.classList.contains('checked'));
    });
  }
  function notchSync(A) {
    if (!notchFini(A) || !notchAuto(A)) return;
    var ks = notchKeys(A); if (!ks.length) return;
    var U = (buildPlan(A) || {}).usinages || {};
    A.S.notch = A.S.notch || {};
    ks.forEach(function (k) {
      var cur = A.S.notch[k] = A.S.notch[k] || { dx: 100, dy: 100, offset: 0 };
      cur.fini = ((U[k] && U[k].pieces) || []).some(function (p) { return arriereChante(A, p); });
    });
  }
  /* coins à encoche comptés au récapitulatif : ceux du moteur, puis les zones de clic qu'il ne connaît pas */
  function notchKeys(A) {
    var S = A.S, e = S.edges || {}, list = (ENGINE_CORNER_KEYS[S.layout] || []).slice();
    Array.prototype.forEach.call(A.svg ? A.svg.querySelectorAll('rect.hit[data-cp-id]') : [], function (h) { var k = h.getAttribute('data-cp-id'); if (list.indexOf(k) < 0) list.push(k); });
    return list.filter(function (k) { return e[k] === 'notch'; });
  }
  /* récapitulatif : « Encoches brutes » et « Encoches finies » à la place de « Encoches » ; l'écart d'une finie
     (finie − brute) rejoint le même total (prix affiché, panier, contrôle) */
  function notchLines(A) {
    var nf = notchFini(A), ks = nf ? notchKeys(A) : []; if (!ks.length) return;
    var S = A.S, m = ks.filter(function (k) { return estFinie(A, k); }).length, n = ks.length - m;
    var td = document.getElementById('td-options'); if (!td) return;
    var ul = td.querySelector('.td-options-list:not(.cp-ilot-opt)');
    if (!ul) {
      var hid = td.querySelector('.td-options-list.cp-ilot-opt');                  /* liste cachée (îlot, retour fini 4 côtés) : gardée telle quelle */
      td.innerHTML = '<details class="td-options-dropdown" open><summary></summary><div class="td-options-scroll"><ul class="td-options-list"></ul></div></details>';
      ul = td.querySelector('ul'); if (hid) td.appendChild(hid);
    }
    var li = Array.prototype.filter.call(ul.querySelectorAll('li'), function (l) { return estLigne(l.textContent, CORNER_LINE.notch); })[0];
    var uB = Math.round(nf.brute * 100), uF = Math.round(nf.fini * 100), ref = li ? li.nextSibling : null;
    if (li) ul.removeChild(li);
    var mk = function (lab, q, u) { var x = document.createElement('li'); x.textContent = ligneSupp(lab, q, u); ul.insertBefore(x, ref); };   /* N6 */
    if (n && uB > 0) mk(NOTCH_B, n, uB);
    if (m) mk(NOTCH_F, m, uF);
    var extra = m * (uF - uB); if (!extra) return;
    S.optionsTotalCents = num(S.optionsTotalCents) + extra;
    /* titre = somme des lignes VISIBLES : le total des options porte aussi des écarts sans ligne (plan au m², fini 4 côtés) */
    var sum = td.querySelector('.td-options-dropdown > summary'), vis = 0;
    Array.prototype.forEach.call(td.querySelectorAll('.td-options-list li'), function (l) {
      if (l.hidden || l.style.display === 'none' || (l.closest && l.closest('[hidden]'))) return;
      var mm = l.textContent.replace(/\s+/g, ' ').match(/([+-])\s?([\d\s  .]+,\d{2})\s?€\s*$/);
      if (mm) vis += (mm[1] === '-' ? -1 : 1) * Math.round(parseFloat(mm[2].replace(/[\s  .]/g, '').replace(',', '.')) * 100);
    });
    if (sum) sum.textContent = 'Suppléments : +' + eurFmt(vis) + '€';
  }
  /* pièces du dessin (repère du SVG) : même géométrie que le modèle, à l'origine des blocs du moteur */
  function piecesDessin(A) {
    var S = A.S, raw = null;
    if (typeof window.CP_etagPieces === 'function') return null;
    if (S.layout === 'angle') raw = geomAngle({ L1: num(S.L1), P1: num(S.P1), L2: num(S.L2), P2: num(S.P2), ang: num(S.innerAngle || 90), jn: junctionOf(S), dir: S.angleDir === 'left' ? 'left' : 'right' }).pieces;
    else if (S.layout === 'u-shape') { var aU = cornerAnglesOf(S), jU = jnUside(S); raw = geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr), jl: jU.g, jr: jU.d, aL: aU.g, aR: aU.d }).pieces; }
    else if (S.layout === 'g-shape') raw = geomG(gParams(S)).pieces;
    else if (S.layout === 'linear') raw = geomLinear({ L: num(S.L), P: num(S.P) }).pieces;
    var bs = (A._cpPieces || []).filter(function (b) { return isFinite(b.x) && isFinite(b.y); });
    if (!raw || !bs.length) return null;
    var O = [Math.min.apply(null, bs.map(function (b) { return num(b.x); })), Math.min.apply(null, bs.map(function (b) { return num(b.y); }))];
    return raw.map(function (p) { return { id: p.id, pts: p.pts.map(function (q) { return [q[0] + O[0], q[1] + O[1]]; }) }; });
  }
  /* bords d'une encoche dans le dessin : même découpe que cp-trace (cornerCutPath : dx le long du mur le plus
     horizontal, dy le long de l'autre ; encoche décalée : trois bords) */
  function notchEdges(A, k, P) {
    var h = A.svg.querySelector('rect.hit[data-cp-id="' + k + '"]'); if (!h) return null;
    var c = [num(h.getAttribute('x')) + num(h.getAttribute('width')) / 2, num(h.getAttribute('y')) + num(h.getAttribute('height')) / 2], best = null;
    P.forEach(function (p) { p.pts.forEach(function (q) { var d = len(q, c); if (!best || d < best.d) best = { d: d, q: q }; }); });
    if (!best || best.d > 400) return null;
    var V = best.q, walls = [], onSeg = function (a, b, q) { var L = len(a, b); if (L < 0.5) return false; var s = ((q[0] - a[0]) * (b[0] - a[0]) + (q[1] - a[1]) * (b[1] - a[1])) / L, d = Math.abs((b[0] - a[0]) * (q[1] - a[1]) - (b[1] - a[1]) * (q[0] - a[0])) / L; return d <= 1 && s >= -1 && s <= L + 1; };
    P.forEach(function (p) {
      var n = p.pts.length, i = p.pts.findIndex(function (q) { return len(q, V) < 1; }); if (i < 0) return;
      [p.pts[(i + n - 1) % n], p.pts[(i + 1) % n]].forEach(function (w) {
        var mid = [(V[0] + w[0]) / 2, (V[1] + w[1]) / 2], l = len(V, w);
        if (l < 0.5 || P.some(function (o) { return o !== p && o.pts.some(function (a, j) { return onSeg(a, o.pts[(j + 1) % o.pts.length], mid); }); })) return;   /* jonction */
        var d = [(w[0] - V[0]) / l, (w[1] - V[1]) / l];
        if (!walls.some(function (x) { return Math.abs(x[0] - d[0]) < 1e-6 && Math.abs(x[1] - d[1]) < 1e-6; })) walls.push(d);
      });
    });
    if (walls.length !== 2) return null;
    var b = (A.S.notch || {})[k] || {}, u1 = walls[0], u2 = walls[1], h1 = Math.abs(u1[0]) >= Math.abs(u1[1]);
    var dx = num(b.dx) || 50, dy = num(b.dy) || 50, off = num(b.offset);
    if (off > 0) {
      var uh = h1 ? u1 : u2, uv = h1 ? u2 : u1, q = function (s, t) { return [V[0] + uh[0] * s + uv[0] * t, V[1] + uh[1] * s + uv[1] * t]; };
      return [[q(off + dx, 0), q(off + dx, dy)], [q(off + dx, dy), q(off, dy)], [q(off, dy), q(off, 0)]];
    }
    var a1 = h1 ? dx : dy, a2 = h1 ? dy : dx, A1 = [V[0] + u1[0] * a1, V[1] + u1[1] * a1], A2 = [V[0] + u2[0] * a2, V[1] + u2[1] * a2], Q = [A1[0] + u2[0] * a2, A1[1] + u2[1] * a2];
    return [[A1, Q], [Q, A2]];
  }
  /* dessin : trait de bord fini sur les bords d'une encoche finie, jamais sur ceux d'une brute (le moteur le pose
     d'après les chants voisins : au coin avant de la pierre, une encoche brute paraissait finie). Après le rendu ; les
     traits relevés pour le modèle (_cpMarks) suivent. */
  function notchTraits(A) {
    var nf = notchFini(A), ks = nf && A.svg && A._cpMarks ? notchKeys(A) : []; if (!ks.length) return;
    var P = piecesDessin(A); if (!P) return;
    var lines = A._cpMarks.lines;
    var onE = function (el, e) {
      var p1 = [num(el.getAttribute('x1')), num(el.getAttribute('y1'))], p2 = [num(el.getAttribute('x2')), num(el.getAttribute('y2'))];
      return segDist(p1, e[0], e[1]) < 2 && segDist(p2, e[0], e[1]) < 2 && len(p1, p2) > 1;
    };
    ks.forEach(function (k) {
      var E = notchEdges(A, k, P); if (!E) return;
      var fini = estFinie(A, k);
      E.forEach(function (e) {
        var hits = lines.filter(function (el) { return el && el.isConnected && el.tagName === 'line' && onE(el, e); });
        if (!fini) hits.forEach(function (el) { el.parentNode.removeChild(el); lines.splice(lines.indexOf(el), 1); });
        else if (!hits.length && typeof A.SV === 'function') {
          var el = A.SV('line', { x1: e[0][0], y1: e[0][1], x2: e[1][0], y2: e[1][1], stroke: '#1F51FF', 'stroke-width': '16', 'stroke-linecap': 'round', opacity: '0.8', 'pointer-events': 'none' });
          el.setAttribute('data-cp-encoche', k); A.svg.appendChild(el); lines.push(el);
        }
      });
    });
  }
  /* fenêtre de l'encoche : « Finition de l'encoche », brute (par défaut) ou finie, avec leur supplément */
  function notchChoix(A, k) {
    var content = document.getElementById('edge-popup-content'); if (!content) return;
    var old = content.querySelector('.cp-encoche-fin'); if (old) old.parentNode.removeChild(old);
    var S = A.S, nf = notchFini(A); if (!nf || !k || (S.edges || {})[k] !== 'notch') return;
    S.notch = S.notch || {}; var cur = S.notch[k] = S.notch[k] || { dx: 100, dy: 100, offset: 0 };
    if (notchAuto(A)) {                                  /* finition décidée par le chant arrière : pas de choix, l'étiquette la dit */
      var t0 = document.querySelector('#edge-dims-popup .ep-tag'), e0 = function (v) { return Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €'; };
      if (t0) t0.textContent = 'Encoche' + (cur.fini ? ' finie' : ' brute') + ' · +' + e0(cur.fini ? nf.fini : nf.brute);
      return;
    }
    if (!document.getElementById('cp-encoche-css')) {
      var st = document.createElement('style'); st.id = 'cp-encoche-css';
      st.textContent = '.cp-encoche-fin{border:0;margin:10px 0 4px;padding:0;min-width:0}.cp-encoche-fin legend{font-size:13px;font-weight:600;color:#374151;margin-bottom:4px;padding:0}' +
        '.cp-encoche-fin label{display:flex;align-items:center;gap:10px;min-height:44px;padding:0 10px;border:1px solid #d1d5db;border-radius:8px;margin-top:6px;cursor:pointer;font-size:14px;color:#111827;background:#fff}' +
        '.cp-encoche-fin label:has(input:checked){border-color:#0b3527;box-shadow:0 0 0 1px #0b3527}' +
        /* les champs de la fenêtre du coin ont une largeur, une bordure et un fond imposés (width:100px!important) : la radio
           garde sa taille et son dessin natifs */
        '.edge-dims-popup .cp-encoche-fin input[type="radio"],.cp-encoche-fin input[type="radio"]{-webkit-appearance:radio!important;appearance:auto!important;width:18px!important;height:18px!important;min-width:0!important;' +
        'padding:0!important;margin:0!important;border:0!important;border-radius:50%!important;background:none!important;box-shadow:none!important;flex:0 0 18px!important;accent-color:#0b3527}' +
        '.edge-dims-popup .cp-encoche-fin input[type="radio"]:focus-visible{outline:3px solid #0b3527!important;outline-offset:2px}' +
        '.cp-encoche-fin label>span{flex:1 1 auto;text-align:left;margin:0}.cp-encoche-fin label>span.cp-ef-prix{flex:0 0 auto;margin-left:auto;font-weight:600;white-space:nowrap}';
      document.head.appendChild(st);
    }
    var eur = function (v) { return Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' €'; };
    var box = document.createElement('fieldset'); box.className = 'cp-encoche-fin';
    box.innerHTML = '<legend>Finition de l\'encoche</legend>' +
      '<label><input type="radio" name="cp-encoche-fin" value="brute"><span>Brute, bords sciés</span><span class="cp-ef-prix"></span></label>' +
      '<label><input type="radio" name="cp-encoche-fin" value="finie"><span>Finie, bords polis</span><span class="cp-ef-prix"></span></label>';
    var px = box.querySelectorAll('.cp-ef-prix'); px[0].textContent = '+' + eur(nf.brute); px[1].textContent = '+' + eur(nf.fini);
    var ins = box.querySelectorAll('input'); ins[cur.fini ? 1 : 0].checked = true;
    var tag = function () { var t = document.querySelector('#edge-dims-popup .ep-tag'); if (t) t.textContent = 'Encoche' + (cur.fini ? ' finie' : '') + ' · +' + eur(cur.fini ? nf.fini : nf.brute); };
    tag();
    Array.prototype.forEach.call(ins, function (i) {
      i.addEventListener('change', function () {
        if (!i.checked) return;
        cur.fini = i.value === 'finie'; tag();
        try { A.render(); } catch (e) { console.warn('[cp-plan]', e); }
        var again = document.querySelector('.cp-encoche-fin input[value="' + i.value + '"]'); if (again && document.activeElement !== again) again.focus();
      });
    });
    var ap = Array.prototype.filter.call(content.querySelectorAll('button'), function (b) { return /Supprimer|Appliquer/.test(b.textContent); })[0];
    var row = ap && ap.parentNode !== content ? ap.parentNode : ap;
    if (row && row.parentNode) row.parentNode.insertBefore(box, row); else content.appendChild(box);
  }

  /* ── Branchements ── */
  function wrap(A) {
    if (A.__cpPlanWrapped) return;
    A.__cpPlanWrapped = true;
    /*  la variante commandée n'était pas toujours la finition choisie. Le produit
       ne donne pas options_with_values au moteur (App.options vide, colorOptionIndex = -1) : il retombait sur
       « la première variante dont le titre CONTIENT le nom » (Noyer → Noyer blond, Marbre gris → Marbre gris
       clair), et c'est elle qui partait au panier, au prix et dans _cfg_model. Égalité exacte du nom d'abord
       (titre, puis option) ; la recherche du moteur ensuite, pour un nom sans variante exacte.*/
    var oVar = A.getSelectedShopifyVariant;
    if (typeof oVar === 'function') A.getSelectedShopifyVariant = function () {
      return exactVariant(this) || oVar.apply(this, arguments);
    };
    /*  rectangle et coin du moteur de chaque zone de clic (bornes de l'usinage)*/
    var oHit = A.addHit;
    if (typeof oHit === 'function') A.addHit = function (x, y, w, h, key, rect, corner) {
      if (key && rect) (this._cpHitRect = this._cpHitRect || {})[key] = { rect: { x: num(rect.x), y: num(rect.y), w: num(rect.w), h: num(rect.h) }, corner: corner };
      return oHit.apply(this, arguments);
    };
    /*  la borne d'un usinage dépend des cotes, de l'angle, des jonctions et de la forme. Après chaque
       rendu, un chanfrein ou une encoche au-delà de sa borne y est ramené, avec un message, puis redessiné
       (toute la chaîne des rendus) ; le contrôle bloquant « usinages_bornes » reste en filet. :
       encoche de 1770 mm posée, puis L1 passée à 1000 mm : le retour était coupé en deux.*/
    var oRenderB = A.render;
    A.render = function () {
      if (!this.__cpClamp) this._cpHitRect = {};
      var r = oRenderB.apply(this, arguments);
      if (!this.__cpClamp) {
        var msgs = [];
        try { msgs = clampMachining(this); } catch (e) { console.warn('[cp-plan]', e); }
        if (msgs.length) {
          this.__cpClamp = true;
          try { this._cpHitRect = {}; this.render(); } finally { this.__cpClamp = false; }
          setTimeout(function () { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msgs.join(' '), 'info', 8000); }, 0);
        }
      }
      return r;
    };
    /*  le moteur ne facture que les coins de sa liste (updateTdOptionsList,
       LAYOUT_EDGE_KEYS) ; en G gauche, gRightTL et gReturnBR n'y sont pas : leurs usinages étaient
       gratuits et absents de la ligne de commande. Ajoutés ici au même prix, dans la même ligne.*/
    var oOptsU = A.updateTdOptionsList;
    if (typeof oOptsU === 'function') A.updateTdOptionsList = function () {
      try { prixChantProf(this); } catch (e) { console.warn('[cp-plan]', e); }   /* prix d'un chant selon la profondeur, avant le calcul */
      try { if (chantMlEur(this) && this._eff) this._eff.edgeBandingUnitEuro = 0; } catch (e) { console.warn('[cp-plan]', e); }   /* R35 : chant au mètre, compté plus bas */
      var r = oOptsU.apply(this, arguments);
      try { chantsMlLignes(this); } catch (e) { console.warn('[cp-plan]', e); }    /* R35 : une ligne par chant, à sa longueur */
      try { borduresLigne(this); } catch (e) { console.warn('[cp-plan]', e); }     /* H18-1 : ajouté d'office à chaque bout */
      try { addMissingCornerLines(this); } catch (e) { console.warn('[cp-plan]', e); }
      try { semiLignes(this); } catch (e) { console.warn('[cp-plan]', e); }        /* demi-rond par bout */
      try { notchSync(this); } catch (e) { console.warn('[cp-plan]', e); }         /* encoche finie selon le chant arrière */
      try { notchLines(this); } catch (e) { console.warn('[cp-plan]', e); }        /* encoches brutes / finies */
      var selfC = this; Promise.resolve().then(function () { try { chantsParLigne(selfC); } catch (e) { console.warn('[cp-plan]', e); } });   /* R148-b2 : après tous les modules du rendu */
      return r;
    };
    var oRenderC = A.render;                             /* nom des cases de côté avec leur prix (après le nommage de cp-a11y) */
    if (typeof oRenderC === 'function') A.render = function () {
      var r = oRenderC.apply(this, arguments), self = this;
      try { nommerCotes(self); nommerChantsMl(self); setTimeout(function () { nommerCotes(self); nommerChantsMl(self); }, 0); } catch (e) {}
      return r;
    };
    /* lot R : avant le rendu, P = hauteur du décor et longueur ramenée au maximum du décor ; après, bloc « Hauteur », ligne
       du récapitulatif, bouton de la barre et note du cœur (A-360) ; la cote P est dite à addDim (A-361) */
    var oRenderE = A.render;                             /* R180 : la règle selon l'épaisseur, avant chaque rendu */
    if (typeof oRenderE === 'function') A.render = function () {
      try { appliqueParEp(this); } catch (e) { console.warn('[cp-plan]', e); }
      var r = oRenderE.apply(this, arguments), self = this;
      /* A-422 : les écarts sous les épaisseurs réécrits après le refus (le moteur et cp-gamme les écrivent avant) */
      var ecarts = function () { if (typeof window.CP_thkDeltas === 'function') window.CP_thkDeltas(); };
      try { refus180(self); epAffiche(self); ecarts(); setTimeout(function () { try { refus180(self); epAffiche(self); ecarts(); } catch (e) {} }, 0); } catch (e) { console.warn('[cp-plan]', e); }   /* R180 : choix grisés ; « 18 cm » */
      return r;
    };
    var oRenderR = A.render;
    if (typeof oRenderR === 'function') A.render = function () {
      var msg = null;
      try { if (hauteurVar(this)) { syncHauteur(this); msg = clampLongueur(this); } } catch (e) { console.warn('[cp-plan]', e); }
      var r = oRenderR.apply(this, arguments), self = this;
      try { blocHauteur(self); recapHauteur(self); barHauteur(self); noteCoeur(self); if (hauteurVar(self)) setTimeout(function () { recapHauteur(self); barHauteur(self); }, 0); } catch (e) { console.warn('[cp-plan]', e); }
      if (msg && window.CFG_UI && window.CFG_UI.toast) setTimeout(function () { window.CFG_UI.toast(msg, 'info', 7000); }, 0);
      return r;
    };
    var oDepthSel = A.showDepthSelector;                 /* lot R : la hauteur ne se choisit pas dans une fenêtre */
    if (typeof oDepthSel === 'function') A.showDepthSelector = function () { if (hauteurVar(this)) return; return oDepthSel.apply(this, arguments); };
    var UI = window.CFG_UI;                              /* lot R (A-360) : la barre garde « Épaisseur · Hauteur » quand le moteur la réécrit */
    if (UI && typeof UI.updateThicknessButton === 'function') {
      var oThkBtn = UI.updateThicknessButton;
      UI.updateThicknessButton = function (app) { var r = oThkBtn.apply(this, arguments); try { barHauteur(app || A); epAffiche(app || A); } catch (e) { console.warn('[cp-plan]', e); } return r; };   /* R180 : « 18 cm » */
    }
    var oPropsEp = A.buildLineItemProperties;           /* R180 : le panier garde l'épaisseur en mm (« 180 mm ») ; le récapitulatif dit « 18 cm » */
    if (typeof oPropsEp === 'function') A.buildLineItemProperties = async function () {
      var p = await oPropsEp.apply(this, arguments);
      try { var mm = num(this.S.thk), lab = mm ? epLabel(mm) : ''; if (p && lab && lab !== mm + ' mm' && p['Épaisseur'] === lab) p['Épaisseur'] = mm + ' mm'; } catch (e) { console.warn('[cp-plan]', e); }
      return p;
    };
    var oPropsR = A.buildLineItemProperties;            /* lot R : propriété « Hauteur » au panier, après l'épaisseur (COMMERCIAL Tour 131) */
    if (typeof oPropsR === 'function') A.buildLineItemProperties = async function () {
      var p = await oPropsR.apply(this, arguments);
      try {
        if (p && hauteurVar(this) && num(this.S.P) > 0) {
          var h = cmTxt(num(this.S.P)) + NB + 'cm', q = {}, mis = false;
          Object.keys(p).forEach(function (k) { q[k] = p[k]; if (!mis && /paisseur/i.test(k)) { q.Hauteur = h; mis = true; } });
          if (!mis) q.Hauteur = h;
          return q;
        }
      } catch (e) { console.warn('[cp-plan]', e); }
      return p;
    };
    var oPop = A.showEdgePopup;                          /* ligne sous la fenêtre du coin */
    if (typeof oPop === 'function') A.showEdgePopup = function (rect, corner, edgeKey) {
      /*  bornes réduites au mur de la pièce quand il ne continue pas sur une voisine. Le moteur
         tire ses bornes du rectangle reçu (maximum = côté − 30 mm) : un rectangle réduit suffit, et
         champs, indications, curseurs et schéma suivent. Valeur déjà trop grande : ramenée, avec un message.*/
      var args = [].slice.call(arguments), S = this.S, t = edgeKey && (S.edges || {})[edgeKey], clamped = null;
      try {
        var lm = machLimits(this, edgeKey, rect, corner);
        if (lm && (lm.h < rect.w - 30 || lm.v < rect.h - 30)) {
          var cur = ((t === 'bevel' ? S.bevel : S.notch) || {})[edgeKey] || {};
          args[0] = Object.assign({}, rect, { w: lm.h + 30, h: lm.v + 30 });
          if (num(cur.dx) > lm.h || num(cur.dy) > lm.v) clamped = clampMsg(this, t, num(cur.dx) > lm.h ? lm.h : null, num(cur.dy) > lm.v ? lm.v : null, lm.bd);
        }
      } catch (e) { console.warn('[cp-plan]', e); }
      var r = oPop.apply(this, args);
      try { notchChoix(this, edgeKey); } catch (e) { console.warn('[cp-plan]', e); }   /* finition de l'encoche (réglage de la règle) */
      if (clamped) {                                       /* le moteur a ramené la valeur en ouvrant la fenêtre : dessin et prix à jour */
        var B = this;
        setTimeout(function () { try { B.render(); } catch (e) {} if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(clamped, 'info', 7000); }, 0);
      }
      try {
        var content = document.getElementById('edge-popup-content');
        /*  « Pièce L × P mm » du moteur = son rectangle de dessin ; ici la pièce réelle du coin, avec ses cotes*/
        var ep = content && content.querySelector('.edge-piece'), pl = ep && edgeKey ? buildPlan(this) : null, us = pl && (pl.usinages || {})[edgeKey];
        if (ep && us && us.pieces && us.pieces.length) {
          var parts = us.pieces.map(function (id) {
            var pc = pl.pieces.filter(function (x) { return x.id === id; })[0]; if (!pc) return id;
            var lg = Math.round(num(pc.longueur_axe_mm)), pr = lg ? Math.round(area(pc.contour) / lg) : 0;
            return pc.role + (lg ? ' (' + lg + ' × ' + pr + ' mm)' : '');
          });
          ep.textContent = (parts.length > 1 ? 'Pièces : ' : 'Pièce : ') + parts.join(' et ');
        }
        var oldR = content && content.querySelector('.cp-reach'); if (oldR) oldR.remove();
        var rn = ep && edgeKey ? reachNote(this, edgeKey, pl) : '';
        if (rn) { var q = document.createElement('p'); q.className = 'cp-reach'; q.setAttribute('role', 'note'); q.textContent = rn;
          q.style.cssText = 'margin:.25rem 0 0;font-size:12px;line-height:1.35;color:#374151;text-align:center'; ep.parentNode.insertBefore(q, ep.nextSibling); }
        /* AUDIT Tour 611 : plus la phrase « Ce coin ajoute d'office le chant : … (+49,00 €) » dans la fenêtre ; ce que le choix
           ajoute est dit par l'écart réel du total (pastille, ligne « Remplace… » et bulle de cp-annonces, règle A-304) */
        var old = content && content.querySelector('.cp-imposed'); if (old) old.remove();
      } catch (e) { console.warn('[cp-plan]', e); }
      return r;
    };
    /*  après chaque rendu, tout coin dont l'usinage vient de changer de type donne la bulle de ce que le choix ajoute
       d'office, sur l'état réel (cp-annonces, à l'écart réel du total) ; sans choix en cours dans le menu du coin, pas de
       bulle (AUDIT Tour 611 : plus l'ancienne phrase « Ce coin ajoute d'office le chant… (+49,00 €) »).*/
    var edgesSeen = null, oRenderI = A.render;
    A.render = function () {
      var r = oRenderI.apply(this, arguments), B = this;
      try {
        var E = B.S.edges || {}, now = {};
        Object.keys(E).forEach(function (k) { now[k] = E[k]; });
        if (edgesSeen) Object.keys(now).forEach(function (k) {
          if (!now[k] || now[k] === 'straight' || now[k] === edgesSeen[k]) return;
          /* texte calculé après le passage de cp-a11y, qui nomme les cases (« bord arrière, contre le mur », et non « back ») */
          setTimeout(function () {
            try {
              var t = window.CP_bulleChoix ? window.CP_bulleChoix(B, k) : null;   /* A-304 : ce que le choix ajoute d'office, à l'écart réel (cp-annonces) */
              if (t && window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(t, 'info', 7000);
            } catch (err) {}
          }, 80);
        });
        edgesSeen = now;
      } catch (e) { console.warn('[cp-plan]', e); }
      return r;
    };
    /* traits de chant et cases tels qu'ils sont DESSINÉS (coordonnées finales, après le tracé
       réel), relevés à chaque rendu pour rattacher chaque chant à une arête de pièce*/
    var oInd = A.addEdgeBandingIndicator, oCb = A.addEdgeCheckbox;
    if (typeof oInd === 'function') A.addEdgeBandingIndicator = function () {
      var el = oInd.apply(this, arguments);
      if (el && this._cpMarks) this._cpMarks.lines.push(el);
      return el;
    };
    if (typeof oCb === 'function') A.addEdgeCheckbox = function (x, y, key) {
      var el = oCb.apply(this, arguments);
      if (el && this._cpMarks) this._cpMarks.boxes.push({ el: el, k: String(key), p: [num(x), num(y)] });
      return el;
    };
    /*  longueur facturée du G = somme des longueurs
       des pièces du modèle LE LONG DE LEUR AXE (montants : le long de leur mur ; haut et retour : en
       largeur), dans les deux sens — un retour de 400 × 600 compte 400, pas 600. Le moteur avait 16
       formules à la main (l. 1243-1316) : G gauche à 8,40 ml, G droit à 7,80 ml, pour 7,20 m dessinés.
       Le U, le L et le droit gardent le calcul du moteur (longueurs saisies, Q-A10).*/
    function geomGde(S) {
      return geomG({ Gtop: num(S.Gtop), Gleft: num(S.Gleft), Gright: num(S.Gright), Greturn: num(S.Greturn),
        Pgtop: num(S.Pgtop), Pgleft: num(S.Pgleft), Pgright: num(S.Pgright), Pgreturn: num(S.Pgreturn),
        top: jnU(S.junctionTopG), mid: jnU(S.junctionMidG), ret: jnU(S.junctionReturnG), dir: S.gDir === 'left' ? 'left' : 'right' });
    }
    var oLen = A.getTotalLengthMm;
    if (typeof oLen === 'function') A.getTotalLengthMm = function () {
      var S = this.S;
      if (S.layout !== 'g-shape') return oLen.apply(this, arguments);
      var g = geomGde(S);
      return Math.max(0, Math.round(g.pieces.reduce(function (s, p) { return s + axisLength(p.pts, p.axis); }, 0)));
    };
    /* A-420 (AUDIT Tour 1129) : en G, chaque ligne « Prof. » du moteur prend la longueur de sa pièce dessinée (geomG, le long
       de son axe), comme la longueur facturée. En G gauche, le moteur retirait le retour filant au montant qui ne le porte pas
       (configurator-main, calculateDepthSupplements, branche « G GAUCHE ») : montant droit dessiné 1 800, facturé 1,20 ml.
       Profondeur -> pièce : comme arrDepthKey (G à gauche : le montant de gauche porte Pgright). */
    function gProfLongueurs(B, r) {
      var S = B && B.S; if (!r || !r.items || !S || S.layout !== 'g-shape') return r;
      var R = S.gDir !== 'left', lg = {}, dkP = { Pgtop: 'haut', Pgreturn: 'retour', Pgleft: R ? 'gauche' : 'droite', Pgright: R ? 'droite' : 'gauche' };
      geomGde(S).pieces.forEach(function (p) { lg[p.id] = axisLength(p.pts, p.axis); });
      r.items.forEach(function (it) {
        var m = String(it.label).match(/^Prof\. (Pg(?:left|right|top|return)) \d+ mm \(\+([\d.]+)€\/m × \d+mm\)$/), L = m ? lg[dkP[m[1]]] : 0;
        if (!(L > 0)) return;
        var c = Math.round(parseFloat(m[2]) * (L / 1000) * 100);
        r.total += c - num(it.cents); it.cents = c; it.label = String(it.label).replace(/× \d+mm\)$/, '× ' + Math.round(L) + 'mm)');
      });
      return r;
    }
    /*  vente à la surface (voir sellsBySurface). getBilledQtyCm est la seule source de la quantité du
       moteur (prix affiché, prix de base, quantité mise au panier) : elle renvoie ici des dm², avec les règles
       de quantité de la variante comme le moteur. Récapitulatif « Surface totale … m² », en-tête « € / m² ».*/
    var oQty = A.getBilledQtyCm;
    if (typeof oQty === 'function') A.getBilledQtyCm = function (vo) {
      if (!sellsBySurface(this)) {
        var qc = oQty.apply(this, arguments), mm = minMl(this);                  /* étagère : 0,6 ml au moins */
        return (mm && qc < Math.ceil(mm / 10)) ? Math.ceil(mm / 10) : qc;
      }
      var q = Math.round(billedMm2(this) / 10000), v = vo || (this.getSelectedShopifyVariant && this.getSelectedShopifyVariant()), rule = (v && v.quantity_rule) || {};   /*  0,4 m² au moins par panneau*/
      var min = Number(rule.min || 1), inc = Number(rule.increment || 1), max = rule.max == null ? null : Number(rule.max);
      q = Math.max(min, q); if (inc > 1) q = Math.ceil(q / inc) * inc; if (max != null) q = Math.min(max, q);
      return Math.max(1, q);
    };
    var oDepth0 = A.calculateDepthSupplements, oDepth = typeof oDepth0 === 'function' ? function () { return gProfLongueurs(this, oDepth0.apply(this, arguments)); } : oDepth0;   /* A-420 */
    if (typeof oDepth === 'function') A.calculateDepthSupplements = function () {
      /* profondeur portée par les variantes (étagère, Dekton) : son prix est dans celui de la variante ; le moteur
         aurait appliqué la première plage de profondeur trouvée, toutes collections confondues (+49 €/m à 340 mm) */
      if (sellsBySurface(this) || depthRanges(this)) return { total: 0, items: [], segments: [] };
      /*  profondeurs de la règle du produit seulement, prix selon l'épaisseur (table DEPTH_THK)*/
      var tb = depthTable(this), C = window.CONFIGURATOR_CONFIG || {}, r;
      if (!tb) return oDepth.apply(this, arguments);
      var s0 = C.depthStandards, c0 = C.depthCustomRanges, p0 = this.S.P, b80 = backP80(this) || capP80(this), arr = arrPieces(this), self = this, args = arguments;
      C.depthStandards = tb.std; C.depthCustomRanges = tb.cst;
      if (b80) this.S.P = 800;                                                    /* chant arrière : palier 800 */
      try {
        r = oDepth.apply(this, arguments);
        /* L, U, G : chaque pièce à l'arrière chanté, recalculée seule à 800 (sa longueur réelle ne dépend que des
           profondeurs voisines) ; sa ligne est marquée « _arr_<pièce> » pour le récapitulatif */
        arr.forEach(function (a) {
          var q0 = self.S[a.dk], r8, re = new RegExp('^Prof\\. ' + a.dk + ' ');
          self.S[a.dk] = 800;
          try { r8 = oDepth.apply(self, args); } finally { self.S[a.dk] = q0; }
          var n8 = r8.items.filter(function (it) { return re.test(it.label); })[0]; if (!n8) return;
          var it8 = { label: n8.label.replace(re, 'Prof. ' + a.dk + '_arr_' + a.piece + ' '), cents: n8.cents }, i0 = -1;
          r.items.forEach(function (it, i) { if (re.test(it.label)) i0 = i; });
          if (i0 >= 0) { r.total -= r.items[i0].cents; r.items[i0] = it8; } else r.items.push(it8);
          r.total += it8.cents;
        });
      } finally { C.depthStandards = s0; C.depthCustomRanges = c0; if (b80) this.S.P = p0; }
      /*  facturation minimale (0,3 / 0,5 ml) : le supplément suit la longueur facturée, comme le prix de base*/
      var mm = minMl(this), len = num(this.getTotalLengthMm && this.getTotalLengthMm());
      if (r && r.total > 0 && mm && len > 0 && len < mm) {
        var f = mm / len; r.total = 0;
        r.items.forEach(function (it) {
          var m = String(it.label).match(/\(\+([\d.,]+)€\/m\)$/);                   /* droit : taux × longueur facturée, exact */
          it.cents = m ? Math.round(parseFloat(m[1].replace(',', '.')) * mm / 10) : Math.round(it.cents * f);
          it.label = String(it.label).replace(/×\s*(\d+)mm/, function (x, n) { return '× ' + Math.round(n * f) + 'mm'; });
          r.total += it.cents;
        });
      }
      /* lot de prix du stratifié (tableau 2.3 ; AUDIT Tours 557, 622) : réduction de profondeur de la règle, une fois par
         pièce dont la profondeur n'est pas vendue telle quelle ; plafond « jamais plus cher » (A-193) : la pièce ne coûte
         jamais plus que la même pièce en 800 (moins de 800 mm) ou en 1 200 (801 à 1 199 mm), même longueur facturée.
         Réduction = min(réduction, supplément au plafond − supplément facturé) : aucune ligne quand elle est nulle (paliers
         631-799 et 801-1 199, arrière chanté déjà au prix du 800) */
      var rd = r ? reducRegle(this) : null, sansRed = [];
      if (rd) {
        var S9 = this.S, lay9 = S9.layout || 'linear', cred9 = estCredence(this), eurC = Math.round(rd.eur * 100), lin = lay9 === 'linear';
        /* droit : le plafond est la même pièce en 800 (1 200) telle que le configurateur la facture, base au cm et suppléments
           sur la longueur réelle, minimum compris (A-193 ; AUDIT 04:43 : arrondie au cm, L 499 payait plus qu'un 800, L 742 moins) */
        var lenB = Math.max(len, mm || 0);
        var arr9 = arr.map(function (a) { return a.dk; });
        (DEPTH_KEYS[lay9] || []).forEach(function (k) {
          var P = num(S9[k]); if (!(P > 0) || rd.sans.indexOf(P) >= 0) return;
          var capD = capProf(self, P); if (!capD) return;
          var dejaArr = lin ? b80 : arr9.indexOf(k) >= 0, fact = 0, cap = 0, mmSeg = lenB;   /* arrière chanté : au prix du 800 (A-193), rien de plus (q3) */
          if (lin) {
            fact = Math.round(depthRateAt(self, dejaArr ? 800 : P) * lenB / 10); cap = Math.round(depthRateAt(self, capD) * lenB / 10);
          } else {
            var re9 = new RegExp('^Prof\\. ' + k + '(_arr_\\w+)? ');
            r.items.forEach(function (it) { if (re9.test(it.label)) fact += it.cents; });
            var q9 = S9[k], r9 = null; C.depthStandards = tb.std; C.depthCustomRanges = tb.cst; S9[k] = capD;
            try { r9 = oDepth.apply(self, args); } finally { S9[k] = q9; C.depthStandards = s0; C.depthCustomRanges = c0; }
            (r9 ? r9.items : []).forEach(function (it) { if (re9.test(it.label)) { cap += it.cents; var ms = String(it.label).match(/×\s*(\d+)\s*mm/); if (ms) mmSeg = num(ms[1]); } });
          }
          /* R1 de messages 2 (AUDIT Tour 719, COMMERCIAL Tour 113) : la pièce nommée comme en N22, « Profondeur du plan 650 mm » */
          var pc9 = lin ? '' : pieceDeCle(S9, k), red9 = Math.min(eurC, cap - fact);
          var quoi = cred9 ? 'Hauteur ' + fmtMm(P) + ' mm' : 'Profondeur ' + (pc9 ? (/^jambe/.test(pc9) ? 'de la ' : 'du ') + pc9 + ' ' : '') + fmtMm(P) + ' mm';
          var ref = 'au prix ' + (cred9 ? 'd\'une crédence' : 'd\'un plan') + ' de ' + fmtMm(capD) + ' mm';
          /* textes de COMMERCIAL (docs\commercial-stratifie-prix-lignes.md ; AUDIT 03:07 : « Mise à la profondeur », pas
             « réduction », qui se lirait comme une remise) */
          var lab, mise = cred9 ? 'mise à la hauteur' : 'mise à la profondeur';
          if (!(red9 > 0)) { if (!dejaArr) sansRed.push(quoi + ' : ' + ref + ', sans ' + mise); return; }   /* C6 : jamais « +0,00 € » */
          if (red9 === eurC) lab = 'Mise à la ' + (cred9 ? 'hauteur (' : 'profondeur (') + (lin ? '' : pieceDeCle(S9, k) + ', ') + fmtMm(P) + ' mm)';   /* R1 à R3 */
          else {                                                                  /* C1 à C3 ; C5 si l'écart ne se dit pas au mètre */
            var ec = depthRateAt(self, capD) - depthRateAt(self, dejaArr ? 800 : P), ml = mmSeg / 1000;
            lab = quoi + ', ' + ref + ', moins cher ici que la ' + mise + (ec > 0 && Math.round(ml * ec * 100) === red9 ? '§' + ml + '§' + ec : '');
          }
          r.items.push({ label: lab, cents: red9 }); r.total += red9;
        });
      }
      this.__cpSansReduc = sansRed;
      return r;
    };
    /* message de profondeur seulement après un geste du client : au chargement, la profondeur de départ est ramenée sans
       message (le client n'a rien saisi) ; ensuite, une profondeur saisie hors plage est ramenée avec son message */
    var geste = false;
    ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function () { geste = true; }, true); });
    var oRenderD = A.render;
    A.render = function () {
      var msgD = null; try { msgD = snapDepth(this); } catch (e) {}
      if (msgD && geste) setTimeout(function () { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msgD, 'info', 6000); }, 0);
      return oRenderD.apply(this, arguments);
    };
    var oTdLen = A.updateTdLongueurTotal;
    if (typeof oTdLen === 'function') A.updateTdLongueurTotal = function () {
      /* facturation minimale : la vraie taille d'abord, puis ce qui est facturé (« 0,40 ML (facturé 0,50 ML, minimum) ») ;
         la propriété « Longueur totale » du panier relit cette case */
      var f2 = function (x) { return x.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
      if (!sellsBySurface(this)) {
        var rl = oTdLen.apply(this, arguments), mm = minMl(this), tdl = document.getElementById('quantite_dimensions');
        var lm = num(this.getTotalLengthMm && this.getTotalLengthMm()), meta = window.__PRODUCT_META__ || {};
        if (mm && tdl && lm > 0 && lm < mm && tdl.textContent.indexOf('facturé') < 0) {
          var co = Number(meta.coeff) || 1, un = String(meta.unite_de_vente || 'cm').trim(), reel = f2(lm / 10 / co) + ' ' + un, fact = tdl.textContent.trim();
          if (reel !== fact) tdl.textContent = reel + ' (facturé ' + fact + ', minimum)';        /* 499 mm : « 0,50 ML » seul */
        }
        return rl;
      }
      var td = document.getElementById('quantite_dimensions'); if (!td) return;
      var q = this.getBilledQtyCm(this.getSelectedShopifyVariant && this.getSelectedShopifyVariant());
      this.S.qtyCm = q; td.dataset.qtyCm = String(q); td.dataset.surfaceM2 = String(q / 100);
      td.textContent = minApplied(this) && m2Reel(this) !== f2(q / 100) + ' m²'
        ? m2Reel(this) + ' (facturé ' + f2(q / 100) + ' m², minimum' + (piecesOf(this).length > 1 ? ' de ' + String(minM2(this)).replace('.', ',') + ' m² par panneau' : '') + ')'
        : f2(q / 100) + ' m²';                                                               /*  dit au client*/
    };
    var oHdr = A.updateRecapLengthHeader;
    if (typeof oHdr === 'function') A.updateRecapLengthHeader = function () {
      var r = oHdr.apply(this, arguments);
      if (sellsBySurface(this)) {
        var lb = document.getElementById('recap-length-label'), th = document.querySelector('th.recap-col-longueur');
        if (lb) lb.textContent = 'Surface totale'; if (th) th.textContent = 'Surface totale';
      }
      return r;
    };
    var origRender = A.render;
    A.render = function () {
      this._cpMarks = { lines: [], boxes: [] };
      var r = origRender.apply(this, arguments);
      try { notchTraits(this); } catch (e) { console.warn('[cp-plan]', e); }        /* bords d'encoche : finis seulement si finie */
      try { syncRealButton(this); } catch (e) { console.warn('[cp-plan]', e); }
      try {                                                /*  unité de l'en-tête (métachamp produit, commun au site en ligne)*/
        if (sellsBySurface(this)) Array.prototype.forEach.call(document.querySelectorAll('.config-header-unit'), function (u) { u.textContent = '€ / m²'; });
      } catch (e) {}
      return r;
    };
    var origProps = A.buildLineItemProperties;
    if (typeof origProps === 'function') {
      A.buildLineItemProperties = async function () {
        var p = await origProps.apply(this, arguments);
        try {
          var plan = buildPlan(this), txt = canon(plan), h = await sha256(txt);
          if (sellsBySurface(this)) {                     /*  l'atelier voit la même surface que le client*/
            var fq = plan.facturation, m2 = function (x) { return x.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
            delete p['Longueur totale'];
            p['Surface totale'] = fq.minimum_applique && m2Reel(this) !== m2(fq.qte_dm2 / 100) + ' m²' ? m2Reel(this) + ' (facturé ' + m2(fq.qte_dm2 / 100) + ' m², minimum)' : m2(fq.qte_dm2 / 100) + ' m²';
            p['Surface facturée'] = fq.qte_dm2 + ' dm² (surface des pièces ' + (fq.surface_mm2 / 1e6).toLocaleString('fr-FR', { maximumFractionDigits: 4 }) + ' m²' +
              (fq.minimum_applique ? ', ' + minText(this) : '') + ', arrondie au dm² le plus proche)';
            p['_qty_dm2'] = String(fq.qte_dm2);
          }
          p['_cfg_model'] = txt;
          p['_cfg_hash'] = h;
          p['Réf. plan'] = h.slice(0, 12);
          /* encoche finie proposée : chaque encoche, son coin (nom de la liste « Usinage des coins ») et sa finition */
          if (notchFini(this)) {
            var self = this, noms = this.__cpCoins || [], ks = notchKeys(this), ordre = function (k) { var i = noms.map(function (x) { return x.k; }).indexOf(k); return i < 0 ? 99 : i; };
            ks.sort(function (a, b) { return ordre(a) - ordre(b); });
            if (ks.length) p['Encoches'] = ks.map(function (k) { var x = noms.filter(function (y) { return y.k === k; })[0]; return (x ? x.nom : k) + ', ' + (estFinie(self, k) ? 'finie' : 'brute'); }).join(' ; ');
          }
          var ad = plan.forme.angles_deg;                /* angle par coin (U, G) : lisible sur la commande */
          if (ad && Object.keys(ad).some(function (k) { return ad[k] !== 90; }))
            p['Angles'] = Object.keys(ad).map(function (k) { return (NOMS_ANGLES[k] || 'coin ' + k) + ' ' + ad[k] + '°'; }).join(', ');
        } catch (e) { console.warn('[cp-plan]', e); }
        return p;
      };
    }
    try { syncRealButton(A); } catch (e) {}
    try { if (sellsBySurface(A)) A.render(); } catch (e) { console.warn('[cp-plan]', e); }   /*  premier prix déjà à la surface*/
  }

  var tries = 0;
  var timer = setInterval(function () {
    var A = getApp();
    if (A && A.S && A.__cpThkWrapped && A.__cpTexWrapped) { clearInterval(timer); wrap(A); hauteurDepart(A); }
    else if (++tries > 400) clearInterval(timer);
  }, 50);

  /* Garde panier : un contrôle bloquant en échec = pas d'ajout, avec le motif.
     Clic avant le branchement (page encore en chargement) : retenu jusqu'au branchement, 5 s au plus, puis relancé
     une seule fois (les clics pendant l'attente n'en ajoutent pas) ; sans branchement, pas d'ajout et un message :
     jamais de ligne sans plan ni contrôles. */
  var attente = false;
  window.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('#btn-add-cart'))) return;
    var A = getApp();
    if (attente || !A || !A.S || !A.__cpPlanWrapped) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (attente) return;
      attente = true;
      var t0 = Date.now(), iv = setInterval(function () {
        var B = getApp();
        if (B && B.S && B.__cpPlanWrapped) {
          clearInterval(iv); attente = false;
          var b = document.getElementById('btn-add-cart'); if (b) b.click();
        } else if (Date.now() - t0 >= 5000) {
          clearInterval(iv); attente = false;
          var msg = 'La page n\'a pas fini de se charger : rien n\'a été ajouté au panier. Rechargez la page, puis ajoutez à nouveau.';
          if (window.CFG_UI) window.CFG_UI.toast(msg, 'error', 9000); else window.alert(msg);
        }
      }, 100);
      return;
    }
    /* pas encore de rendu depuis le branchement (clic relancé) : les chants se relèvent sur le dessin */
    if (!A._cpMarks) { try { A.render(); } catch (err) { console.warn('[cp-plan]', err); } }
    /* A-403 (2) (AUDIT Tours 940 et 941, MAJEUR) : une profondeur hors des plages vendues (le moteur ouvre à default_depth, et
       snapDepth n'avait pas encore tourné) partait au panier, à la variante d'une autre plage. Avant le panier : snapDepth ; si
       elle change la profondeur, rendu (variante et prix suivent), ajout arrêté et la bulle du rappel : le client relit, puis
       ajoute à nouveau. Profondeur déjà dans une plage, ou produit sans plage : rien ne change */
    var msgP = null; try { msgP = snapDepth(A); } catch (err) { msgP = null; }
    if (msgP) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      try { A.render(); } catch (err) { console.warn('[cp-plan]', err); }
      var mP = msgP + ' Rien n\'a été ajouté au panier : vérifiez le prix, puis ajoutez à nouveau.';
      if (window.CFG_UI) window.CFG_UI.toast(mP, 'info', 9000); else window.alert(mP);
      return;
    }
    var plan; try { plan = buildPlan(A); } catch (err) { console.warn('[cp-plan]', err); return; }
    var ko = plan.controles.filter(function (c) { return c.bloquant && !c.ok; });
    /* cause première d'abord : un G fermé fait aussi échouer chevauchement, surface
       et chants ; le client ne lit que la vraie raison*/
    var cause = ko.filter(function (c) { return c.id === 'g_ouvert'; });
    if (cause.length) ko = cause;
    /* A-307 : une pièce trop longue que cp-pierre-angle signale déjà, au même maximum : son message seul (sa garde suit) */
    try {
      if (typeof window.CP_longueursMax === 'function' && window.CP_longueursMax(A).some(function (m) { return m.mm > m.max; }))
        ko = ko.filter(function (c) { return !/^plaque_/.test(c.id); });
    } catch (err) {}
    if (ko.length) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      /*  finition sans variante Shopify, sans jargon (« Variante commandée « ? » »)*/
      var vv = A.getSelectedShopifyVariant ? A.getSelectedShopifyVariant() : null;
      if (!(vv && vv.id) && ko.some(function (c) { return c.id === 'variante_finition'; })) {
        if (window.CFG_UI) window.CFG_UI.toast('Cette finition n\'est pas disponible pour le moment : choisissez-en une autre ou contactez-nous.', 'error', 9000);
        return;
      }
      /* lot « messages 1 » (AUDIT Tour 597) : un contrôle interne en échec, le message unique seul (A2) ; sinon un seul préfixe
         pour tous les produits (L68), et ce qu'il faut changer */
      if (ko.some(function (c) { return c.interne; })) { if (window.CFG_UI) window.CFG_UI.toast(MSG_INTERNE, 'error', 9000); return; }
      /* A-385 (AUDIT) : un seul point final ; les messages R36 (COMMERCIAL) finissent déjà par « . », les autres non */
      var tko = ko.map(function (c) { return String(c.message).replace(/\.\s*$/, ''); }).join(' ; ');
      if (window.CFG_UI) window.CFG_UI.toast('Commande impossible en l\'état : ' + tko + (/[.!?]$/.test(tko) ? '' : '.'), 'error', 9000);
    }
  }, true);

  /*  le moteur et les ajouts écrivent « 104,30€ », « +89€ », « +30€/m », sans
     espace. Espace insécable avant « € » dans tout texte de la page du configurateur (prix, récapitulatif,
     fenêtres, menus, messages), à l'écriture. _prix_total et Options, relus dans la page (innerText) au
     moment de l'ajout au panier, le reprennent ; cfg-enhancements lit _prix_total chiffres seuls.*/
  function euroText(n) {
    var t = n.nodeValue, p = n.parentNode;
    if (!t || t.indexOf('€') < 0 || !p || /^(SCRIPT|STYLE|TEXTAREA)$/.test(p.nodeName)) return;
    var u = t.replace(/(\d)[  ]?€/g, '$1 €');
    if (u !== t) n.nodeValue = u;
  }
  function euroTree(root) {
    if (root.nodeType === 3) { euroText(root); return; }
    if (root.nodeType !== 1 || (root.textContent || '').indexOf('€') < 0) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) euroText(n);
  }
  function euroWatch() {
    euroTree(document.body);
    Array.prototype.forEach.call(document.querySelectorAll('.config-header-unit'), function (u) {   /* prix ␣ « € / m² » de l'en-tête */
      var s = u.previousSibling; if (s && s.nodeType === 3 && !s.nodeValue.trim()) s.nodeValue = ' ';
    });
    new MutationObserver(function (list) {
      list.forEach(function (m) { if (m.type === 'characterData') euroText(m.target); else Array.prototype.forEach.call(m.addedNodes, euroTree); });
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.body) euroWatch(); else document.addEventListener('DOMContentLoaded', euroWatch);

  /*  sur téléphone, le prix total reste visible pendant la saisie. Mesuré à
     375 × 812 : « Ajouter au panier » 687 px sous le dessin. Jusqu'à 768 px, tant que le configurateur est à
     l'écran mais que le total du récapitulatif (#td-prix-total) et le bouton d'ajout n'y sont pas, une barre fixe
     en bas d'écran montre « Total … » (copie du récapitulatif, donc de chaque rendu) et « Voir le détail », qui
     amène au récapitulatif. Rien en plein écran. Feuille injectée.
      rien non plus tant qu'une fenêtre est ouverte (forme, finition, épaisseur, cote et profondeur,
     coins, jambages, évier, fenêtres cfg-modal ou aria-modal) : la barre passait devant leur bas.*/
  var WINDOWS = '#edge-dims-popup, #edge-menu, #legs-popup, #sink-popup, .config-popup.is-open, #config-popup-overlay.is-open, ' +
    '.cfg-modal, [aria-modal="true"], dialog[open]';
  function windowOpen(bar) {
    return Array.prototype.some.call(document.querySelectorAll(WINDOWS), function (e) {
      if (bar.contains(e) || e.classList.contains('hidden') || !e.getClientRects().length) return false;
      var cs = getComputedStyle(e);
      return cs.visibility !== 'hidden' && Number(cs.opacity) > 0.05;
    });
  }
  function priceBar() {
    var total = document.getElementById('td-prix-total'), main = document.querySelector('.config-main'), add = document.getElementById('btn-add-cart');
    if (!total || !main || typeof IntersectionObserver !== 'function' || document.getElementById('cp-pricebar')) return;
    var st = document.createElement('style'); st.id = 'cp-pricebar-css';
    st.textContent = '#cp-pricebar{position:fixed;left:0;right:0;bottom:0;z-index:900;display:flex;align-items:center;gap:12px;' +
      'padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:#0d3527;color:#fff;box-shadow:0 -4px 16px rgba(0,0,0,.18);' +
      'font-size:15px;line-height:1.2;transform:translateY(110%);transition:transform .2s ease;visibility:hidden}' +
      '#cp-pricebar.is-on{transform:none;visibility:visible}' +
      '#cp-pricebar .cp-pricebar__k{font-size:12px;letter-spacing:.06em;text-transform:uppercase;opacity:.85}' +
      '#cp-pricebar .cp-pricebar__v{font-size:18px;font-weight:700;white-space:nowrap}' +
      '#cp-pricebar button{min-height:44px;padding:0 16px;border:1px solid #fff;border-radius:4px;background:transparent;color:#fff;font:inherit;font-weight:600;cursor:pointer}' +
      '#cp-pricebar .cp-pricebar__det{margin-left:auto}' +
      '#cp-pricebar .cp-pricebar__add{background:#fff;color:#0d3527}#cp-pricebar .cp-pricebar__add:disabled{opacity:.55;cursor:not-allowed}' +
      '#cp-pricebar.is-side .cp-pricebar__det{display:none}#cp-pricebar.is-side .cp-pricebar__add{margin-left:auto}' +   /* récapitulatif juste au-dessus */
      '#cp-pricebar button:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
      /*  aussi sur les tablettes tactiles jusqu'à 1 366 px ; « Ajouter au panier » seulement là (place)*/
      '@media (min-width:769px) and (pointer:fine),(min-width:1367px){#cp-pricebar{display:none}}' +
      '@media (max-width:768px){#cp-pricebar .cp-pricebar__add{display:none}}' +
      '@media (prefers-reduced-motion:reduce){#cp-pricebar{transition:none}}';
    document.head.appendChild(st);
    var bar = document.createElement('div'); bar.id = 'cp-pricebar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Prix total');
    bar.innerHTML = '<div><div class="cp-pricebar__k">Total</div><div class="cp-pricebar__v"></div></div><button type="button" class="cp-pricebar__det">Voir le détail</button>' +
      '<button type="button" class="cp-pricebar__add">Ajouter au panier</button>';
    document.body.appendChild(bar);
    var val = bar.querySelector('.cp-pricebar__v'), addB = bar.querySelector('.cp-pricebar__add'), seen = { total: false, add: false, main: false };
    /* le bouton de la barre suit le vrai (désactivé tant que la configuration est incomplète) et le déclenche : même ajout */
    var sync = function () { val.textContent = (total.textContent || '').trim(); addB.disabled = !!(add && add.disabled); };
    addB.addEventListener('click', function () { if (add && !add.disabled) add.click(); });
    var show = function () {
      var stage = document.getElementById('stage'), fs = !!document.fullscreenElement || document.body.classList.contains('fullscreen-mobile-active') ||
        !!(stage && (stage.classList.contains('cfgfs-on') || stage.classList.contains('is-fullscreen-mobile')));
      /* jamais sur le cadre du dessin (étiquettes du bas à toucher), ni pendant une saisie (clavier ouvert) */
      var box = document.querySelector('.config-stage-wrap'), br = box && box.getBoundingClientRect(), hb = bar.offsetHeight || 64;
      var overStage = !!br && br.top < window.innerHeight && br.bottom > window.innerHeight - hb;
      var ae = document.activeElement, typing = !!ae && (/^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) || ae.isContentEditable) && !bar.contains(ae) &&
        ae.getClientRects().length > 0 && getComputedStyle(ae).visibility !== 'hidden';   /* champ encore affiché (fenêtre refermée : non) */
      /*  tablette tactile (769 à 1 366 px) : la barre vient dès que « Ajouter au panier » est
         hors de l'écran (en paysage, le total de la colonne de droite est visible, pas le bouton). Récapitulatif à côté
         du dessin (paysage) : barre calée sur sa colonne, elle ne couvre pas le dessin*/
      var tab = window.matchMedia('(pointer: coarse) and (min-width: 769px) and (max-width: 1366px)').matches, side = false;
      var rc = tab && br ? document.querySelector('.recap-panel') : null, rr = rc && rc.getBoundingClientRect();
      if (rr && rr.width > 0 && rr.left >= br.right - 1) side = true;
      bar.style.left = side ? Math.round(rr.left) + 'px' : ''; bar.style.right = side ? Math.max(0, Math.round(window.innerWidth - rr.right)) + 'px' : '';
      bar.classList.toggle('is-side', side);
      var on = seen.main && !seen.add && (tab || !seen.total) && !fs && (side || !overStage) && !typing &&
        (tab || window.matchMedia('(max-width: 768px)').matches) && !windowOpen(bar);
      bar.classList.toggle('is-on', on);
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');   /* caché : ni tabulation ni lecteur */
    };
    bar.querySelector('.cp-pricebar__det').addEventListener('click', function () {
      var row = total.closest('tr') || total;
      row.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (e) { seen[e.target === total ? 'total' : e.target === add ? 'add' : 'main'] = e.isIntersecting; });
      show();
    });
    io.observe(total); io.observe(main); if (add) io.observe(add);
    new MutationObserver(function () { sync(); show(); }).observe(total, { childList: true, characterData: true, subtree: true });   /* nouveau prix : fenêtre refermée */
    if (add) new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('resize', show);
    document.addEventListener('fullscreenchange', show);
    var queued = false;
    window.addEventListener('scroll', function () { if (queued) return; queued = true; setTimeout(function () { queued = false; show(); }, 60); }, { passive: true });
    document.addEventListener('focusin', show); document.addEventListener('focusout', function () { setTimeout(show, 0); });
    /*  ouverture et fermeture des fenêtres (classe, style, attribut ; fenêtres ajoutées au body)*/
    var wq = false, wshow = function () { if (wq) return; wq = true; requestAnimationFrame(function () { wq = false; show(); }); };
    var wmo = new MutationObserver(wshow);
    Array.prototype.forEach.call(document.querySelectorAll(WINDOWS + ', .config-popup, #config-popup-overlay'), function (e) {
      wmo.observe(e, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open'] });
    });
    wmo.observe(document.body, { childList: true });
    document.addEventListener('click', function () { setTimeout(wshow, 60); }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setTimeout(wshow, 60); }, true);
    sync(); show();
  }
  /* . Le moteur écrit « +99€ » dans la fenêtre « Choisir une profondeur », et au récapitulatif
     « Prof. Pc 800 mm (+99€/m × 1200mm) : +118,80 € » (même forme pour l'épaisseur ; « (+118,80€) : x1 = +118,80€ »
     avant le lot « messages 2 »).
     Fenêtre : « +99 €/ml ». Cartes sur mesure : « Sur mesure » en 1re ligne, la plage en 2e (le libellé du
       réglage, « Sur-mesure (300-630mm) », répétait la plage et chevauchait la 2e ligne).
     Récapitulatif : « Profondeur du fond 800 mm : 1,20 ml × 99 €/ml = +118,80 € », « Épaisseur 22 mm : 2,40 ml ×
       30 €/ml = +72,00 € ». Longueur lue dans le libellé (U, G, L) ou, en droit, montant ÷ tarif.
     La propriété « Options » du panier relit ces lignes (getOptionsTextForCart) : elle suit.*/
  var NB = ' ';
  function parseFr(s) { return parseFloat(String(s).replace(/[\s  ]/g, '').replace(',', '.')); }
  function eur(n) { return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function rate(n) { return n.toLocaleString('fr-FR', { maximumFractionDigits: 2 }); }
  /* lot « messages 2 » (COMMERCIAL, docs\commercial-messages-lot2.md, A ; AUDIT Tour 616) : une ligne de supplément s'écrit
     « {libellé} : {q} × {prix} € = +{total} € », ou « {libellé} : +{prix} € » pour une seule ; elle se lit sous cette forme
     et sous l'ancienne, « {libellé} (+{prix}€) : x{q} = +{total}€ ». Longueur en ml : 3 décimales si elle n'est pas au cm (T6) */
  /* R148-b2 (Romain : « ce ne sont pas des bouts mais des chants » ; COMMERCIAL Tours 210 et 211 ; ADMIN 17:58 ; AUDIT 20:41) :
     « Chants supp. : N × 59,00 € » devient une ligne par chant, « Chant du côté gauche : +59,00 € », même prix, même total.
     Les clés sont celles que le moteur a comptées (_cpChantsComptes), moins celles que d'autres modules ont retirées de la ligne
     (_cpChantsRetires : pièce finie sur 4 côtés, côté fini à part, chant imposé par un coin, arrière du plan de 800). Le nom
     d'un côté libre est celui de « Chants » (cp-pierre-angle) ; les autres, ceux de COMMERCIAL : « bord » pour un long bord,
     « côté » pour un petit, « côté libre » pour une extrémité ; « avant » vers la pièce, « arrière » vers le mur. Garde : si le
     nombre de clés n'est pas celui de la ligne, ou si une clé n'a pas de nom, la ligne reste telle quelle (avertissement en
     console) : jamais un chant nommé au hasard. Appelée après le rendu, à la lecture du panier et par cp-annonces */
  var NOMS_CHANT = {
    linear: { front: 'bord avant', back: 'bord arrière', sides: 'côté gauche', right: 'côté droit' },
    angle: { front: 'bord avant du plan principal', back: 'bord arrière du plan principal', sidesBarreH: 'côté libre du plan principal',
      angleReturnTop: 'bord arrière du retour', angleReturn: 'bord arrière du retour', sidesJambeVInner: 'bord avant du retour',
      sidesJambeVBottom: 'côté libre du retour', angleReturnH: 'côté du plan principal, à l\'angle' },
    'u-shape': { front: 'côté libre de la jambe gauche', sides: 'côté libre de la jambe droite', innerFront: 'bord avant du fond',
      backMidU: 'bord arrière du fond', backflol_right: 'bord arrière du fond', backolfl_left: 'bord arrière du fond',
      backLeftU: 'bord arrière de la jambe gauche', backflol_left: 'bord arrière de la jambe gauche', sideLeftU: 'bord arrière de la jambe gauche',
      sideLeftUTop: 'côté gauche du fond, contre le mur de gauche', sideLeftUBot: 'bord arrière de la jambe gauche',   /* …UTop : bouts du fond filant (AUDIT Tour 1224) */
      backRightU: 'bord arrière de la jambe droite', backolfl_right: 'bord arrière de la jambe droite', sideRightU: 'bord arrière de la jambe droite',
      sideRightUTop: 'côté droit du fond, contre le mur de droite', sideRightUBot: 'bord arrière de la jambe droite', angleReturn: '*bords avant des jambes' },
    'g-right': { backRightG_FF: 'bord arrière du plan du haut', backMidG_FO: 'bord arrière du plan du haut', backMidG_OF: 'bord arrière du plan du haut',
      backLeftG_OO: 'bord arrière du plan du haut', innerFrontTopG: 'bord avant du plan du haut',
      sidesLeftG_F: 'bord arrière du montant gauche', leftSideBottomG_O: 'bord arrière du montant gauche', angleReturnG: 'bord avant du montant gauche',
      frontLeftBottomG: 'côté libre du montant gauche',
      rightSideBottomG_FF: 'bord arrière du montant droit', rightSideMidG_FO: 'bord arrière du montant droit', sidesRightG_OF: 'bord arrière du montant droit',
      rightSideTopG_OO: 'bord arrière du montant droit', sidesInnerRightG: 'bord avant du montant droit',
      frontRightBottomG_FF: 'côté libre du montant droit', frontRightBottomG_OF: 'côté libre du montant droit',
      innerFrontReturnG: 'bord avant du retour', frontReturnBottomG_F: 'bord arrière du retour', frontReturnRightComboG_O: 'bord arrière du retour',
      backReturnG: 'côté libre du retour' },
    'g-left': { backRightGL_FF: 'bord arrière du plan du haut', backMidGL_FO: 'bord arrière du plan du haut', backMidGL_OF: 'bord arrière du plan du haut',
      backLeftGL_OO: 'bord arrière du plan du haut',
      sidesRightRightGL_FF: 'bord arrière du montant gauche', rightSideBottomGL_OF: 'bord arrière du montant gauche', rightSideMidGL_OO: 'bord arrière du montant gauche',
      leftSideBottomGL_F: 'bord arrière du montant droit', sidesLeftRightGL_O: 'bord arrière du montant droit',
      frontReturnBottomGL_F: 'bord arrière du retour', frontRightBottomGL_FO: 'bord arrière du retour', frontRightComboGL_OO: 'bord arrière du retour',
      frontLeftBottomGL: 'côté libre du montant droit', frontRightBottomGL_OF: 'côté libre du montant gauche', frontRightBottomGL_FF: 'côté libre du montant gauche',
      backReturnRightGL_O: 'côté libre du retour', frontReturnRightGL_F: 'côté libre du retour' }
  };
  function nomChant(A, k) {                                       /* « du côté gauche », « des bords avant des jambes » ; null : inconnu */
    var b = typeof window.CP_nomChantBout === 'function' ? window.CP_nomChantBout(A, k) : null;
    if (b) return 'du ' + b;
    var S = A.S, t = S.layout === 'g-shape' ? NOMS_CHANT[S.gDir === 'left' ? 'g-left' : 'g-right'] : NOMS_CHANT[S.layout || 'linear'], n = t && t[k];
    return !n ? null : n.charAt(0) === '*' ? 'des ' + n.slice(1) : 'du ' + n;
  }
  function chantsParLigne(A) {
    var td = A && document.getElementById('td-options'); if (!td) return;
    var li = Array.prototype.filter.call(td.querySelectorAll('.td-options-list li'), function (x) { var m = lireSupp(x.textContent); return m && m.lab === 'Chants supp.' && !x.hasAttribute('data-cp-bouts'); })[0];
    if (!li) return;
    var m = lireSupp(li.textContent), reste = (A._cpChantsComptes || []).slice();
    (A._cpChantsRetires || []).forEach(function (k) { var i = reste.indexOf(k); if (i >= 0) reste.splice(i, 1); });
    /* lot « pierres » (ADMIN Tour 1040) : une clé sans nom ici (faces contre le mur montrées par A-430 : sidesTopRightG_FF,
       backLeftTopG…) prend le nom lu de sa case (cp-a11y), mêmes mots que la case */
    var noms = reste.map(function (k) { var n = nomChant(A, k), c = !n && typeof window.CP_nomCase === 'function' ? window.CP_nomCase(A, k) : null; return n || (c ? 'du ' + c : null); });
    if (reste.length !== m.q || noms.some(function (n) { return !n; })) { console.warn('[cp-chants] « Chants supp. » de ' + m.q + ' chant(s) laissée telle quelle ; clés', reste, noms); return; }
    noms.forEach(function (n) { var x = document.createElement('li'); x.textContent = ligneSupp('Chant ' + n, 1, m.u); x.setAttribute('data-cp-chant', '1'); li.parentNode.insertBefore(x, li); });
    li.parentNode.removeChild(li);
  }
  window.CP_nomChantCle = function (A, k) { var n = nomChant(A || getApp(), k); return n ? n.replace(/^(du|des) /, '') : null; };   /* noms lus (cp-a11y), mêmes mots */
  window.CP_chantsParLigne = function (A) { try { chantsParLigne(A || getApp()); } catch (e) { console.warn('[cp-plan]', e); } };
  function ligneSupp(lab, q, uCents) { return lab + ' : ' + (q > 1 ? q + ' × ' + eur(uCents / 100) + NB + '€ = +' + eur(q * uCents / 100) : '+' + eur(uCents / 100)) + NB + '€'; }
  function lireSupp(txt) {
    var t = String(txt).replace(/\s+/g, ' ').trim(), m, c = function (s) { return Math.round(parseFr(s) * 100); };
    if ((m = t.match(/^(.+?) \(\+([\d .,]+?) ?€\) : x(\d+) = \+([\d .,]+?) ?€$/))) return { lab: m[1], q: Number(m[3]), u: c(m[2]), tot: c(m[4]) };
    if ((m = t.match(/^(.+) : (\d+) × ([\d .,]+?) ?€ = \+([\d .,]+?) ?€$/))) return { lab: m[1], q: Number(m[2]), u: c(m[3]), tot: c(m[4]) };
    if ((m = t.match(/^(.+) : \+([\d .,]+?) ?€$/))) return { lab: m[1], q: 1, u: c(m[2]), tot: c(m[2]) };
    return null;
  }
  function estLigne(txt, lab) { var t = String(txt).replace(/\s+/g, ' ').trim(); return t.indexOf(lab + ' (') === 0 || t.indexOf(lab + ' : ') === 0; }
  function mlTxt(ml) { return ml.toFixed(Math.round(ml * 1000) % 10 ? 3 : 2).replace('.', ','); }
  /* fin d'une ligne du moteur, « (+X€) : x1 = +Y€ » avant le lot, « : +Y € » après (N1) : le total est le dernier groupe */
  var FIN = '\\s*(?:\\(\\+[\\d .,]+?\\s*€\\)\\s*:\\s*x1\\s*=|:)\\s*\\+([\\d .,]+?)\\s*€$';
  var RE_PROF = new RegExp('^Prof\\.\\s+(?:(P\\w*)\\s+)?(\\d+)\\s*mm\\s*\\(\\+([\\d.,]+)\\s*€\\/m(?:\\s*×\\s*(\\d+)\\s*mm)?\\)' + FIN);
  var RE_MISE = new RegExp('^(Mise à la (?:profondeur|hauteur) \\(.+?\\))' + FIN);
  var RE_MOINS = new RegExp('^(.+?, moins cher ici que la mise à la (?:profondeur|hauteur))(?:§([\\d.]+)§([\\d.]+))?' + FIN);
  var RE_EP = new RegExp('^Épaisseur\\s+(\\d+)\\s*mm\\s*\\(\\+([\\d.,]+)\\s*€\\/m\\)' + FIN);
  /* R36-2 : jambage au m² (cp-jambages, marqueurs « §m2§surface§prix ») : « Jambage gauche (bout gauche du plan), 600 × 720 × 20 mm :
     0,432 m² × 1 199 €/m² = +517,97 € » (COMMERCIAL, docs\commercial-r36-textes.md § 2 ; surface à 3 décimales hors du dm², T6) */
  var RE_JAMB_M2 = new RegExp('^(Jambage .+?)§m2§([\\d.]+)§([\\d.]+)' + FIN);
  /* R36-4 : jambage au ml (marqueurs « §ml§longueur§prix§plaque§minimum ») : « … 600 × 720 × 40 mm, en retrait de 30 mm côté mur :
     0,72 ml × 789 €/ml + plaque de fixation 99 € = +667,08 € » ; « 0,30 ml (minimum) × … » (COMMERCIAL § 2) */
  var RE_JAMB_ML = new RegExp('^(Jambage .+?)§ml§([\\d.]+)§([\\d.]+)§([\\d.]+)§([01])' + FIN);
  function unitLine(txt) {
    var t = String(txt).replace(/[\s  ]+/g, ' ').trim(), m, supp, tot, ml;
    m = t.match(RE_PROF);
    if (m) {
      supp = parseFr(m[3]); tot = parseFr(m[5]); ml = m[4] ? Number(m[4]) / 1000 : (supp > 0 ? tot / supp : 0);
      var pa = (m[1] || '').match(/_arr_(\w+)$/), B = getApp(), pc = !pa && m[1] && B && B.S ? pieceDeCle(B.S, m[1]) : null;   /* pièce de L, U, G à l'arrière chanté */
      /* N22 : la pièce de la profondeur (« Profondeur du retour 650 mm ») ; plan droit, sans code : « Profondeur 650 mm ».
         A-353 (COMMERCIAL Tour 112) : « Hauteur » sur une crédence, comme la ligne voisine du lot stratifié ; la cote au
         format des milliers (« 1 000 mm ») */
      var nom = pa && B && B.S ? 'Chant arrière ' + pieceDe(B.S, pa[1]) + ' (découpé dans un plan de 800 mm)' : (B && estCredence(B) ? 'Hauteur ' : 'Profondeur ') + (pc ? (/^jambe/.test(pc) ? 'de la ' : 'du ') + pc + ' ' : '') + fmtMm(num(m[2])) + ' mm';
      return nom + ' : ' + mlTxt(ml) + NB + 'ml × ' + rate(supp) + NB + '€/ml = +' + eur(tot) + NB + '€';   /* N7 : quantité d'abord */
    }
    /* lot de prix du stratifié : « Mise à la profondeur (retour, 500 mm) : +89,00 € » ; plafond : « Profondeur 300 mm, au
       prix d'un plan de 800 mm, moins cher ici que la mise à la profondeur : 0,30 ml × 120 €/ml = +36,00 € » (montant seul
       si l'écart ne se dit pas au mètre ; jambage : montant seul) */
    /* t a perdu ses espaces insécables : « 1 200 mm » les reprend entre les milliers (COMMERCIAL, AUDIT 03:47) */
    var mil = function (s) { return s.replace(/(\d) (\d{3})(?!\d)/g, '$1' + NB + '$2'); };
    m = t.match(RE_MISE);
    if (m) return mil(m[1]) + ' : +' + eur(parseFr(m[2])) + NB + '€';
    m = t.match(RE_MOINS);
    /* longueur réelle du plafond (AUDIT 04:43) : « 0,499 ml » quand elle n'est pas au cm */
    if (m) return mil(m[1]) + ' : ' + (m[2] ? mlTxt(Number(m[2])) + NB + 'ml × ' + rate(Number(m[3])) + NB + '€/ml = ' : '') + '+' + eur(parseFr(m[4])) + NB + '€';
    m = t.match(RE_JAMB_M2);
    if (m) return mil(m[1]) + ' : ' + mlTxt(Number(m[2])) + NB + 'm² × ' + rate(Number(m[3])) + NB + '€/m² = +' + eur(parseFr(m[4])) + NB + '€';
    m = t.match(RE_JAMB_ML);
    if (m) return mil(m[1]) + ' : ' + mlTxt(Number(m[2])) + NB + 'ml' + (m[5] === '1' ? ' (minimum)' : '') + ' × ' + rate(Number(m[3])) + NB + '€/ml' +
      (Number(m[4]) > 0 ? ' + plaque de fixation ' + rate(Number(m[4])) + NB + '€' : '') + ' = +' + eur(parseFr(m[6])) + NB + '€';
    m = t.match(RE_EP);
    if (m) {
      supp = parseFr(m[2]); tot = parseFr(m[3]); ml = supp > 0 ? tot / supp : 0;
      return 'Épaisseur ' + m[1] + ' mm : ' + mlTxt(ml) + NB + 'ml × ' + rate(supp) + NB + '€/ml = +' + eur(tot) + NB + '€';   /* N8 */
    }
    return null;
  }
  /*  sur les produits vendus à la surface, le supplément d'épaisseur est au m² facturé
     (réglage extra_price du bloc d'épaisseur lu en €/m² : 22 mm du mélaminé à +20 €/m²), et non au ml de longueur comme
     le calcule le moteur (updateTdOptionsList, configurator-main l. 924-931). Écart remis dans S.optionsTotalCents (prix
     affiché, panier, contrôle d'intégrité), ligne réécrite ; la propriété « Options » du panier relit cette ligne.*/
  function thkExtra(mm) {
    if (thkByVariant(getApp())) return 0;                          /* épaisseur portée par les variantes : prix dans la variante */
    var o = ((window.CONFIGURATOR_CONFIG || {}).thicknessOptions || []).filter(function (x) { return num(x.mm) === num(mm); })[0];
    return num(o && o.extraPrice);
  }
  function surfaceThk(A) {
    if (!sellsBySurface(A)) return;
    var thk = num(A.S.thk), e = thkExtra(thk); if (!(e > 0)) return;
    var td = document.getElementById('td-options'); if (!td) return;
    var li = Array.prototype.filter.call(td.querySelectorAll('li'), function (x) { return new RegExp('^\\s*Épaisseur\\s+' + thk + '\\s*mm').test(x.textContent); })[0];
    if (!li) return;
    var lenMm = typeof A.getTotalLengthMm === 'function' ? num(A.getTotalLengthMm()) : 0;
    var engine = Math.round(e * (lenMm / 1000) * 100), m2 = A.getBilledQtyCm() / 100, ours = Math.round(e * m2 * 100);
    A.S.optionsTotalCents = num(A.S.optionsTotalCents) - engine + ours;
    li.textContent = 'Épaisseur ' + thk + ' mm : ' + m2.toFixed(2).replace('.', ',') + NB + 'm² × ' + rate(e) + NB + '€/m² = +' + eur(ours / 100) + NB + '€';   /* N9 */
    var sum = td.querySelector('.td-options-dropdown > summary');
    if (sum) sum.textContent = 'Suppléments : +' + eur(num(A.S.optionsTotalCents) / 100) + '€';
  }
  /*  hors standard, une pièce courte est facturée 0,5 ml (prix de base et supplément de
     profondeur), mais le moteur comptait l'épaisseur sur la longueur réelle (« +40 €/ml × 0,30 ml », sous « minimum
     facturé : 0,5 ml ») : 141,50 € au lieu de 149,50 en 60 mm. Même longueur facturée pour l'épaisseur.*/
  function minThk(A) {
    if (sellsBySurface(A)) return;
    var mm = minMl(A), len = typeof A.getTotalLengthMm === 'function' ? num(A.getTotalLengthMm()) : 0;
    if (!(mm > 0 && len > 0 && len < mm)) return;
    var thk = num(A.S.thk), e = thkExtra(thk); if (!(e > 0)) return;
    var td = document.getElementById('td-options'); if (!td) return;
    var li = Array.prototype.filter.call(td.querySelectorAll('li'), function (x) { return new RegExp('^\\s*Épaisseur\\s+' + thk + '\\s*mm').test(x.textContent); })[0];
    if (!li) return;
    var engine = Math.round(e * (len / 1000) * 100), ours = Math.round(e * (mm / 1000) * 100);
    A.S.optionsTotalCents = num(A.S.optionsTotalCents) - engine + ours;
    li.textContent = 'Épaisseur ' + thk + ' mm : ' + mlTxt(mm / 1000) + NB + 'ml × ' + rate(e) + NB + '€/ml = +' + eur(ours / 100) + NB + '€';   /* N10 */
    var sum = td.querySelector('.td-options-dropdown > summary');
    if (sum) sum.textContent = 'Suppléments : +' + eur(num(A.S.optionsTotalCents) / 100) + '€';
  }
  function rewriteOptions() {
    var td = document.getElementById('td-options'); if (!td) return;
    Array.prototype.forEach.call(td.querySelectorAll('li'), function (li) {
      var n = unitLine(li.textContent); if (n && li.textContent.trim() !== n) li.textContent = n;
    });
    /* lot de prix du stratifié (C6) : pièce sur mesure déjà au prix de sa profondeur de référence, « … : au prix d'un plan de
       800 mm, sans mise à la profondeur », sans montant (jamais « +0,00 € ») */
    var A = getApp(), ul = td.querySelector('.td-options-list:not(.cp-ilot-opt)');
    if (A && ul) ((A.__cpSansReduc) || []).forEach(function (t) {
      if (Array.prototype.some.call(ul.children, function (x) { return x.textContent === t; })) return;
      var li = document.createElement('li'); li.textContent = t; ul.appendChild(li);
    });
  }
  function rewriteDepth() {
    var pop = document.getElementById('edge-popup-content'); if (!pop) return;
    dimsClose();                                                   /*  ✕ « Fermer » (posé une fois)*/
    /*  prix de chaque profondeur à l'épaisseur choisie (table DEPTH_THK), mention « découpe en profondeur »
       sous le sur-mesure 300–599 (réduction d'un P60)*/
    var A = getApp(), thk = A && A.S ? num(A.S.thk) : 0, C = window.CONFIGURATOR_CONFIG || {};
    var all = (C.depthStandards || []).concat(C.depthCustomRanges || []);
    Array.prototype.forEach.call(pop.querySelectorAll('.depth-btn'), function (b) {
      var idEl = b.querySelector('.depth-id'), o = idEl ? all.filter(function (x) { return String(x.id) === idEl.textContent.trim(); })[0] : null;
      if (!o || !DEPTH_THK[o.id]) return;
      var v = depthRate(o, thk), p = b.querySelector('.depth-price');
      b.setAttribute('data-price', String(v));
      if (!p && v > 0) { p = document.createElement('small'); p.className = 'depth-price'; b.appendChild(p); }
      if (p) p.textContent = v > 0 ? '+' + v + '€' : '';
    });
    Array.prototype.forEach.call(pop.querySelectorAll('.depth-btn-custom'), function (b) {
      var idEl = b.querySelector('.depth-id'), r = b.querySelector('.depth-range'), t = idEl && DEPTH_MENTION[idEl.textContent.trim()];
      if (t === 'découpe comprise' && A && reducRegle(A)) t = null;            /* mise à la hauteur de la règle : la découpe se paie */
      if (t && r && r.textContent.indexOf(t) < 0) r.textContent = r.textContent.trim() + ' · ' + t;
    });
    /* ligne sous les choix : facturation minimale hors standard*/
    var mr = A ? depthMinRule(A) : null, grid = pop.querySelector('.depth-selector-grid');
    if (mr && grid && !pop.querySelector('.cp-depth-min') && (mr.std > 0 || reducRegle(A))) {
      var n = document.createElement('p');
      n.className = 'cp-depth-min'; n.setAttribute('role', 'note');
      n.style.cssText = 'margin:.6rem 0 0;font-size:13px;line-height:1.35;color:#374151';
      grid.parentNode.insertBefore(n, grid.nextSibling);
    }
    /* texte posé ici, avant le retour de la crédence stratifiée plus bas (sa note restait vide) */
    var dm = pop.querySelector('.cp-depth-min');
    if (dm && mr) {
      /* lot de prix du stratifié (Tour 622) : facturation minimale (plan 0,3 m ; crédence aucune), puis la réduction de la
         règle et son plafond (texte à relire par COMMERCIAL) */
      var rg0 = reducRegle(A), cr0 = estCredence(A), p1 = rg0 ? capProf(A, 0) : null, p2 = p1 ? capProf(A, p1 + 1) : null;
      var plaf = p1 ? (cr0 ? 'jamais plus chère que la même crédence de ' + fmtMm(p1) + ' mm de haut' : 'Sur mesure, une pièce n\'est jamais plus chère que la même pièce de ' + fmtMm(p1) + ' mm de profondeur') +
        (p2 ? ' (' + fmtMm(p2) + ' mm de ' + fmtMm(p1 + 1) + ' à ' + fmtMm(p2 - 1) + ' mm)' : '') + '.' : '';
      var tm = cr0 ? (plaf ? 'Hauteur sur mesure : ' + plaf : '')                       /* crédence : aucun minimum écrit (q2) */
        : (mr.std > 0 ? 'Longueur facturée : au moins ' + mTxt(mr.std) + '.' : '') + (plaf ? (mr.std > 0 ? ' ' : '') + plaf : '');
      if (dm.textContent !== tm) dm.textContent = tm;
    }
    Array.prototype.forEach.call(pop.querySelectorAll('.depth-btn .depth-price'), function (p) {
      var m = p.textContent.trim().match(/^\+\s*([\d.,]+)\s*€$/); if (m) p.textContent = '+' + m[1] + NB + '€/ml';
    });
    Array.prototype.forEach.call(pop.querySelectorAll('.depth-btn-custom .depth-label'), function (l) {
      if (/^sur[-\s]?mesure/i.test(l.textContent.trim())) l.textContent = 'Sur mesure';
    });
    /*  libellés et mentions sur plusieurs lignes (configurator-custom.css : nowrap + « … » ; à 390 px, « Sur mesure :
       entre 300 et 599 … » et « découpée dans une crédence de 1 20… » sous l'étiquette de prix) ; « Min: 801mm - Max:
       1199mm » du moteur sous le champ masqué : il redit le libellé du choix, en anglais*/
    if (!document.getElementById('cp-depth-wrap')) {
      var st = document.createElement('style'); st.id = 'cp-depth-wrap';
      st.textContent = '#edge-popup-content .depth-btn .depth-label,#edge-popup-content .depth-btn .depth-range{white-space:normal;overflow:visible;text-overflow:clip}' +
        '#edge-popup-content .depth-btn-custom .depth-range{grid-column:1}#edge-popup-content #depth-range-info{display:none!important}';
      document.head.appendChild(st);
    }
    var T = A ? depthPopTable(A) : null; if (!T || !grid) return;
    var cred = !!mr && mr.id === 'depth_800_credence_imb', tt = document.getElementById('edge-popup-title');
    if (cred) {                                                                        /*  c'est une hauteur*/
      if (tt) tt.textContent = 'Choisir la hauteur';
      var cl = pop.querySelector('#depth-custom-input-zone label');                    /* « Profondeur (mm): » du moteur */
      if (cl) { cl.textContent = 'Hauteur (mm) :'; cl.htmlFor = 'depth-custom-value'; }
      return;
    }
    /* A-325 : autres crédences (HPL, quartz, Silestone, Dekton), une hauteur aussi */
    var haut = A && estCredence(A), mot = haut ? 'Hauteur' : 'Profondeur';
    if (haut) {
      if (tt && tt.textContent !== 'Choisir la hauteur') tt.textContent = 'Choisir la hauteur';
      var cl2 = pop.querySelector('#depth-custom-input-zone label');
      if (cl2 && cl2.textContent !== 'Hauteur (mm) :') { cl2.textContent = 'Hauteur (mm) :'; cl2.htmlFor = 'depth-custom-value'; }
    }
    /*  textes pour la fenêtre du plan — ligne d'aide, libellés « 1 200 mm » et « Sur mesure : entre 300 et 599 mm (découpe comprise) »,
       ligne de facturation minimale toujours visible*/
    var lim = depthBounds(T);
    if (!pop.querySelector('.cp-depth-help')) {
      var h = document.createElement('p'); h.className = 'cp-depth-help';
      /* sans choix sur mesure, seules les valeurs standard existent : on les nomme (« 600, 630 ou 900 mm ») plutôt qu'une plage */
      var sv0 = T.std.map(function (o) { return num(o.depth_mm); }).filter(function (v, i, a) { return v > 0 && a.indexOf(v) === i; }).sort(function (a, b) { return a - b; }).map(fmtMm);
      h.textContent = (T.cst.length || !sv0.length)
        ? mot + ' : de ' + fmtMm(lim.lo) + ' à ' + fmtMm(lim.hi) + ' mm.'
        : mot + ' : ' + (sv0.length > 1 ? sv0.slice(0, -1).join(', ') + ' ou ' + sv0[sv0.length - 1] : sv0[0]) + ' mm.';
      h.style.cssText = 'margin:0 0 .6rem;font-size:14px;line-height:1.35;color:#374151';
      grid.parentNode.insertBefore(h, grid);
    }
    /* A-324 : une ligne par palier de hauteur avec son prix au mètre, comme les choix de la crédence stratifiée (texte à
       relire par COMMERCIAL) */
    var pal = haut ? paliers(A) : null, pp = pop.querySelector('.cp-paliers');
    if (pal) {
      if (!pp) {
        pp = document.createElement('ul'); pp.className = 'cp-paliers'; pp.setAttribute('aria-label', 'Prix au mètre selon la hauteur');
        pp.style.cssText = 'margin:0 0 .6rem;padding:0 0 0 1.1rem;font-size:14px;line-height:1.45;color:#374151';
        grid.parentNode.insertBefore(pp, grid);
      }
      var eurMl = function (p) { return (Math.round(p * 100) % 100 ? p.toFixed(2).replace('.', ',') : String(Math.round(p))) + NB + '€/ml'; };
      var lignes = pal.map(function (x) { return 'de ' + fmtMm(x.lo) + ' à ' + fmtMm(x.hi) + ' mm : ' + eurMl(x.prix); });
      if (pp.__cpTxt !== lignes.join('|')) {
        pp.__cpTxt = lignes.join('|'); pp.innerHTML = '';
        lignes.forEach(function (t) { var li = document.createElement('li'); li.textContent = t.charAt(0).toUpperCase() + t.slice(1); pp.appendChild(li); });
      }
    } else if (pp) pp.remove();
    var T0 = depthTable(A);                                         /* table du produit, sans borne de forme */
    /* lot « messages 2 », N42 : « Fini sur 4 côtés, au m² » pour toute plage entièrement hors de la plage au mètre de la règle
       (quartz 300-599 et 601-1 200, laqué, Dekton), comme le dit la note sous les boutons ; sans plage au mètre (stratifié,
       HPL, G), la seule plage de l'îlot, comme avant */
    var pmlN = typeof window.CP_plageMl === 'function' ? window.CP_plageMl(A) : null;
    var auM2 = function (o, id) { return pmlN ? (num(o.max_mm) < pmlN.lo || num(o.min_mm) > pmlN.hi) : id === ILOT_ID; };
    Array.prototype.forEach.call(pop.querySelectorAll('.depth-btn'), function (b) {
      var idEl = b.querySelector('.depth-id'), id = idEl && idEl.textContent.trim(), l = b.querySelector('.depth-label'), r = b.querySelector('.depth-range');
      if (id) b.setAttribute('data-cp-depth', id);                  /* repère pour les feuilles de style (îlot masqué en L et en U) */
      var o = T.std.concat(T.cst).filter(function (x) { return String(x.id) === id; })[0];
      if (!o && T0 && T0 !== T && T0.std.concat(T0.cst).some(function (x) { return String(x.id) === id; })) b.style.display = 'none';   /* plage hors de la forme */
      if (!o || !l) return;
      if (b.classList.contains('depth-btn-custom')) {
        /* A-429 : en L et en U aussi, seule la pièce profonde est finie sur 4 côtés (plus « Tous les côtés finis ») */
        l.textContent = (auM2(o, id) ? 'Fini sur 4 côtés, au m² : entre ' : 'Sur mesure : entre ') + fmtMm(num(o.min_mm)) + ' et ' + fmtMm(num(o.max_mm)) + ' mm' + (id === 'depth_custom_300_599' && !reducRegle(A) ? ' (découpe comprise)' : '');   /* A-316 ; mise à la profondeur de la règle : la découpe se paie */
        if (r) r.hidden = true;
      } else l.textContent = fmtMm(num(o.depth_mm)) + ' mm';
    });
    /* A-316 (AUDIT Tour 576) : partout où une profondeur passe au m², finie sur ses côtés, le saut de prix est dit ici, avec
       la plage au mètre linéaire de la règle (quartz « À 60 cm », laqué « À 63 cm », Dekton « De 60 à 70 cm ») ; aucun nombre
       en dur, pas le mot « îlot » */
    var pml = typeof window.CP_plageMl === 'function' ? window.CP_plageMl(A) : null, ni = pop.querySelector('.cp-ilot-note');
    if (pml) {
      if (!ni) {
        ni = document.createElement('p'); ni.className = 'cp-ilot-note'; ni.setAttribute('role', 'note');
        ni.style.cssText = 'margin:.6rem 0 0;font-size:13px;line-height:1.35;color:#374151';
        grid.parentNode.insertBefore(ni, grid.nextSibling);
      }
      var cm = function (mm) { return String(Math.round(mm) / 10).replace('.', ','); };
      /* A-429 (COMMERCIAL, docs\commercial-pierres-textes.md § 2, arbitrage d'AUDIT Tour 1216-c) : en L, U et G, une seule note,
         la pièce de cette cote seule ; le plan droit garde la sienne */
      var nt = A.S.layout === 'linear'
        ? (pml.lo >= pml.hi ? 'À ' + cm(pml.lo) : 'De ' + cm(pml.lo) + ' à ' + cm(pml.hi)) + NB + 'cm de profondeur, le prix est au mètre linéaire. À toute autre profondeur, votre plan est fini sur ses 4 côtés, tous les chants compris, et son prix est calculé à la surface (au m²).'
        : 'Au-delà de ' + fmtMm(pml.hi) + NB + 'mm, cette pièce est finie sur ses 4 côtés et facturée au m², tous ses chants compris.';
      if (ni.textContent !== nt) ni.textContent = nt;
    } else if (ni) ni.remove();
    /* pierre, plan droit : sous la plus petite tranche, fini sur 4 côtés au m² ; dans les tranches, chant arrière en option
       (texte de cp-pierre-angle, CP_noteProf) */
    var tp = typeof window.CP_noteProf === 'function' ? window.CP_noteProf(A) : '', np = pop.querySelector('.cp-arr-note');
    if (tp) {
      if (!np) {
        np = document.createElement('p'); np.className = 'cp-arr-note'; np.setAttribute('role', 'note');
        np.style.cssText = 'margin:.6rem 0 0;font-size:13px;line-height:1.35;color:#374151';
        grid.parentNode.insertBefore(np, grid.nextSibling);
      }
      if (np.textContent !== tp) np.textContent = tp;
    } else if (np && np.parentNode) np.parentNode.removeChild(np);
  }
  var ILOT_ID = 'depth_custom_pierre_701_1400';                    /* plage de l'îlot en pierre (product.json) */
  /* table de la fenêtre de profondeur : plages bornées par la forme (pierre en L et en U sans prix d'îlot : 700 mm au plus,
     CP_depthPlafond de cp-pierre-angle ; en L, en U et en G : pas sous la plus petite tranche, CP_depthPlancher) ; les prix
     et l'état gardent la table du produit */
  function depthPopTable(A) {
    var T = depthTable(A); if (!T) return T;
    var pl = typeof window.CP_depthPlafond === 'function' ? num(window.CP_depthPlafond(A)) : 0;
    var pc = typeof window.CP_depthPlancher === 'function' ? num(window.CP_depthPlancher(A)) : 0;
    if (!(pl > 0) && !(pc > 0)) return T;
    var hi = pl > 0 ? pl : Infinity;
    return {
      std: T.std.filter(function (o) { return num(o.depth_mm) <= hi && num(o.depth_mm) >= pc; }),
      cst: T.cst.filter(function (o) { return num(o.min_mm) <= hi && num(o.max_mm) >= pc; }).map(function (o) {
        var c = {}; for (var k in o) c[k] = o[k]; c.max_mm = Math.min(num(o.max_mm), hi); c.min_mm = Math.max(num(o.min_mm), pc); return c;
      })
    };
  }
  function fmtMm(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NB); }
  function mTxt(mm) { return String(mm / 1000).replace('.', ',') + NB + 'm'; }
  function depthBounds(T) {
    var lo = [], hi = [];
    T.std.forEach(function (o) { lo.push(num(o.depth_mm)); hi.push(num(o.depth_mm)); });
    T.cst.forEach(function (o) { lo.push(num(o.min_mm)); hi.push(num(o.max_mm)); });
    return { lo: Math.min.apply(null, lo), hi: Math.max.apply(null, hi) };
  }

  /*  fenêtre « Choisir une profondeur » du moteur (showDepthSelector,
     configurator-main l. 3508-3715). Le moteur écrit S.P à chaque frappe du champ sur mesure et au clic d'une option,
     AVANT « Valider » : une valeur hors plage (1 300, 250, 30) restait dans l'état, le dessin gardait 600, le total ne
     bougeait pas, et l'ajout au panier était refusé par un bandeau technique ; une fenêtre refermée sans valider
     gardait aussi l'option cliquée (P = 1 200, dessin 600). Ici :
     frappe hors de la plage choisie : l'état n'est pas touché ;
     « Valider » ou Entrée sur une valeur refusée : message en clair dans la fenêtre, focus
       rendu au champ, fenêtre ouverte ;
     fenêtre fermée sans validation (✕, Échap, clic dehors, autre cote) : état remis comme à l'ouverture.*/
  var depthSess = null;
  /* A-325 (AUDIT Tour 598, lot D13) : une crédence se règle en hauteur. Elle est repérée par sa règle : toutes ses
     profondeurs permises sont des profondeurs de crédence (« depth_600_credence_imb », « depth_custom_credence_hpl_100_650 »…) */
  function estCredence(A) { var al = depthAllowed(A); return hauteurVar(A) || (!!al && al.every(function (id) { return /credence/.test(id); })); }   /* lot R : une rehausse se règle en hauteur, comme une crédence */
  window.CP_estCredence = function (A) { A = A || getApp(); return !!(A && A.S) && estCredence(A); };
  function depthWord(A) { return estCredence(A) ? 'hauteur' : 'profondeur'; }
  /* A-324 (AUDIT Tours 598, 599) : hauteur portée par les variantes (crédence HPL : 10/35, 35,1/56, 56,1/65 cm) ; chaque
     palier avec le prix au mètre de sa variante, au décor et à l'épaisseur choisis → [{ lo, hi, prix }], sinon null.
     Les bornes lues dans les variantes ne valent que pour un produit vendu au cm (prix au mètre) : une option en cm qui
     n'est pas une hauteur (rehausse du quartz « 5 cm », « 8 cm ») ne doit pas être lue ainsi (AUDIT Tour 621) */
  function paliers(A) {
    var all = A.shopifyVariants || [], k = all.length > 1 ? depthKey(all) : null, cur = A.getSelectedShopifyVariant ? A.getSelectedShopifyVariant() : null;
    if (!k || !cur) return null;
    var out = [];
    all.forEach(function (v) {
      if (!['option1', 'option2', 'option3'].every(function (o) { return o === k || v[o] === cur[o]; })) return;
      var r = depthRange(v[k]); if (r) out.push({ lo: r[0], hi: r[1], prix: num(v.price) });
    });
    return out.length > 1 ? out.sort(function (a, b) { return a.lo - b.lo; }) : null;
  }
  function depthRangeSel(A) {
    var el = document.querySelector('#edge-popup-content .depth-btn-custom.selected .depth-id'), T = el && depthPopTable(A);
    return T ? T.cst.filter(function (o) { return String(o.id) === el.textContent.trim(); })[0] || null : null;
  }
  function depthCheck(A, v, range) {
    var T = depthPopTable(A); if (!T) return '';
    var w = depthWord(A), a = num(range.min_mm), b = num(range.max_mm), lim = depthBounds(T);
    var here = 'Pour ce choix, la ' + w + ' va de ' + fmtMm(a) + ' à ' + fmtMm(b) + ' mm.';
    if (!isFinite(v) || v <= 0) return here;
    if (v < lim.lo || v > lim.hi) return 'La ' + w + ' doit être comprise entre ' + fmtMm(lim.lo) + ' et ' + fmtMm(lim.hi) + ' mm.';
    if (v >= a && v <= b) return '';
    var std = T.std.map(function (o) { return num(o.depth_mm); });
    if (std.indexOf(v) >= 0) return fmtMm(v) + ' mm existe en ' + w + ' standard : choisissez-la dans la liste.';
    var inCst = T.cst.some(function (o) { return v >= num(o.min_mm) && v <= num(o.max_mm); });
    if (!inCst) {                                          /* aucun choix ne couvre cette valeur (plan : 601 à 629) */
      var under = std.concat(T.cst.map(function (o) { return num(o.max_mm); })).filter(function (x) { return x < v; });
      var over = std.concat(T.cst.map(function (o) { return num(o.min_mm); })).filter(function (x) { return x > v; });
      if (under.length && over.length) {
        var s1 = Math.max.apply(null, under), s2 = Math.min.apply(null, over);
        return { html: 'Entre ' + fmtMm(s1 + 1) + ' et ' + fmtMm(s2 - 1) + ' mm : choisissez ' + fmtMm(s1) + ' mm ou ' + fmtMm(s2) +
          ' mm, ou <a href="/pages/contact">écrivez-nous</a>.' };            /* lot « messages 2 », N41 : même lien */
      }
    }
    return here;
  }
  function depthErr(msg) {
    var zone = document.getElementById('depth-custom-input-zone'), inp = document.getElementById('depth-custom-value'); if (!zone || !inp) return;
    var e = document.getElementById('cp-depth-err');
    if (!e) {
      e = document.createElement('p'); e.id = 'cp-depth-err'; e.className = 'cp-depth-err'; e.setAttribute('role', 'alert');
      e.style.cssText = 'margin:.5rem 0 0;font-size:14px;line-height:1.4;color:#b42318';
      zone.appendChild(e);
    }
    if (!msg) { e.textContent = ''; e.hidden = true; inp.removeAttribute('aria-invalid'); return; }
    if (msg.html) e.innerHTML = msg.html; else e.textContent = msg;
    e.hidden = false; inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', 'cp-depth-err');
  }
  document.addEventListener('input', function (e) {
    if (!depthSess || !e.target || e.target.id !== 'depth-custom-value') return;
    var A = getApp(), range = A && depthRangeSel(A); if (!range) return;
    depthErr('');
    var v = parseInt(e.target.value, 10);
    if (!(v >= num(range.min_mm) && v <= num(range.max_mm))) e.stopPropagation();   /* le moteur n'écrit pas S.P */
  }, true);
  document.addEventListener('click', function (e) {
    if (!depthSess || !e.target || !e.target.closest || !e.target.closest('#depth-apply')) return;
    var A = getApp(), range = A && depthRangeSel(A); if (!range) return;           /* option standard : rien à vérifier */
    var inp = document.getElementById('depth-custom-value'), msg = depthCheck(A, parseInt(inp && inp.value, 10), range);
    if (!msg) return;
    e.stopPropagation(); e.preventDefault();
    depthErr(msg);
    if (inp) { try { inp.focus({ preventScroll: true }); } catch (err) { inp.focus(); } try { inp.select(); } catch (err) {} }
  }, true);
  /*  rien n'entre dans l'état avant « Valider ». Le moteur écrit S.P, depthMode et
     depthSelectedId au toucher d'une option et à chaque frappe ; « Valider » les réécrit ensuite d'après ses propres
     variables (selectedValue, champ relu). L'état est donc remis aussitôt après chacune de ses écritures (écouteurs en
     phase de remontée, après les siens) : dessin, prix et état restent d'accord tant que la fenêtre est ouverte.*/
  function depthHold() {
    var A = getApp(), s = depthSess; if (!A || !A.S || !s || s.done) return;
    A.S.P = s.P; A.S.depthMode = s.mode; A.S.depthSelectedId = s.id;
  }
  document.addEventListener('click', function (e) {                                  /* option touchée */
    if (!depthSess || !e.target || !e.target.closest || !e.target.closest('#edge-popup-content .depth-btn')) return;
    depthErr(''); depthPendingMsg(false); depthHold();
    var A = getApp(), r = A && depthRangeSel(A), inp = document.getElementById('depth-custom-value');   /* champ borné comme la plage (L et U en pierre : 650) */
    if (r && inp && num(inp.max) !== num(r.max_mm)) inp.max = r.max_mm;
  });
  document.addEventListener('input', function (e) {                                  /* frappe dans la plage */
    if (depthSess && e.target && e.target.id === 'depth-custom-value') { depthPendingMsg(false); depthHold(); }
  });
  /*  au téléphone, la fenêtre ne se fermait qu'en validant (ni ✕, ni toucher dehors). Toucher
     dehors = annuler (état d'avant l'ouverture, closeEdgePopup ci-dessous) ; sauf « Ajouter au panier » : refusé tant
     que la fenêtre est ouverte, avec une phrase en clair dans la fenêtre.*/
  function depthPendingMsg(on) {
    var c = document.getElementById('edge-popup-content'), m = document.getElementById('cp-depth-pending'); if (!c) return;
    if (!on) { if (m) m.hidden = true; return; }
    if (!m) {
      m = document.createElement('p'); m.id = 'cp-depth-pending'; m.setAttribute('role', 'alert');
      m.style.cssText = 'margin:.6rem 0 0;font-size:14px;line-height:1.4;color:#b42318';
      var ap = c.querySelector('#depth-apply'); if (ap) c.insertBefore(m, ap); else c.appendChild(m);
    }
    m.textContent = 'Une dimension est en cours de modification : validez-la ou fermez la fenêtre.'; m.hidden = false;
  }
  /* sur window, en capture : le moteur écoute l'ajout au panier en capture sur document (bindAddToCartButton,
     configurator-main l. 1628), inscrit avant nous — l'arrêter sur document ne l'empêchait pas de partir (/cart/add) */
  window.addEventListener('click', function (e) {
    var pop = document.getElementById('edge-dims-popup');
    if (!depthSess || !pop || pop.classList.contains('hidden') || !e.target || !e.target.closest || pop.contains(e.target)) return;
    if (e.target.closest('#btn-add-cart')) { e.preventDefault(); e.stopPropagation(); depthPendingMsg(true); return; }
    var B = getApp(); if (B && typeof B.closeEdgePopup === 'function') B.closeEdgePopup();
  }, true);
  /*  en G, une longueur valide pour le champ peut refermer le G (le retour touche le montant d'en
     face) ; le client ne l'apprenait qu'à l'ajout au panier (garde plus haut). Dans la fenêtre de la cote, « Appliquer »
     essaie la valeur à blanc (fonction de la cote relevée à addDim, rendu neutralisé, état remis ensuite) ; si le G
     se ferme, la valeur est refusée dans la fenêtre, avec la limite de cette cote (recherche entre l'ancienne valeur,
     G ouvert, et la nouvelle).*/
  var dimCommits = {}, lastDimKey = null;
  document.addEventListener('click', function (e) {
    var sp = e.target && e.target.closest && e.target.closest('span[data-cp-a11y="dim"]'); if (sp) lastDimKey = sp.dataset.cpKey || null;
  }, true);
  function gOpenWith(A, commit, v) {                        /* true : G ouvert avec cette valeur ; null : pas de réponse */
    var snap = {}, k, rr = A.render, res = null;
    for (k in A.S) if (Object.prototype.hasOwnProperty.call(A.S, k) && (A.S[k] === null || typeof A.S[k] !== 'object')) snap[k] = A.S[k];
    A.render = function () {};
    try {
      commit.call(A, v);
      var c = buildPlan(A).controles.filter(function (x) { return x.id === 'g_ouvert'; })[0];
      res = c ? !!c.ok : null;
    } catch (err) { res = null; }
    finally { A.render = rr; for (k in snap) A.S[k] = snap[k]; }
    return res;
  }
  function dimErr(msg) {
    var c = document.getElementById('edge-popup-content'), inp = document.getElementById('dim-normal-input'); if (!c || !inp) return;
    var e = document.getElementById('cp-dim-err');
    if (!e) {
      e = document.createElement('p'); e.id = 'cp-dim-err'; e.setAttribute('role', 'alert');
      e.style.cssText = 'margin:.5rem 0 0;font-size:14px;line-height:1.4;color:#b42318;text-align:left';
      var ap = document.getElementById('dim-normal-apply'); if (ap) c.insertBefore(e, ap); else c.appendChild(e);
    }
    if (!msg) { e.textContent = ''; e.hidden = true; inp.removeAttribute('aria-invalid'); return; }
    e.textContent = msg; e.hidden = false; inp.setAttribute('aria-invalid', 'true'); inp.setAttribute('aria-describedby', 'cp-dim-err');
  }
  document.addEventListener('input', function (e) { if (e.target && e.target.id === 'dim-normal-input') dimErr(''); }, true);
  window.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('#dim-normal-apply')) return;
    var A = getApp(); if (!A || !A.S || A.S.layout !== 'g-shape' || !A.__cpPlanWrapped) return;
    var commit = lastDimKey && dimCommits[lastDimKey], inp = document.getElementById('dim-normal-input'); if (!commit || !inp) return;
    var v = parseInt(inp.value, 10), lo = num(inp.min), hi = num(inp.max); if (!isFinite(v) || (lo && v < lo) || (hi && v > hi)) return;   /* le moteur répond */
    if (gOpenWith(A, commit, v) !== false) { dimErr(''); return; }
    e.preventDefault(); e.stopPropagation();
    /* limite : dernière valeur qui garde le G ouvert, entre l'ancienne (ouverte) et la nouvelle */
    var cur = parseInt(inp.defaultValue, 10), lim = null;
    if (isFinite(cur) && cur !== v && gOpenWith(A, commit, cur) === true) {
      var a = cur, b = v;                                   /* a ouvert, b fermé */
      while (Math.abs(b - a) > 1) { var m = Math.round((a + b) / 2); if (gOpenWith(A, commit, m) === true) a = m; else b = m; }
      lim = a;
    }
    dimErr('Avec ' + fmtMm(v) + ' mm, le retour touche le montant d\'en face : le G est fermé. ' + (lim != null
      ? 'Pour cette cote : ' + (v > cur ? 'au plus ' : 'au moins ') + fmtMm(lim) + ' mm.'
      : 'Raccourcissez le retour ou allongez le plan du haut.'));
    try { inp.focus({ preventScroll: true }); inp.select(); } catch (err) {}
  }, true);
  /*  en U et en G, valider la profondeur d'un retour change EN SILENCE
     la longueur hors tout L1 (le moteur garde la longueur intérieure : 2 400 → 2 500). Aucune cote ne change sans que
     le client le sache : sous le dessin, « La longueur hors tout L1 passe de 2 400 à 2 500 mm. », [Garder 2 400 mm]
     (L1 remis par la fonction de la cote L1 relevée à addDim : la longueur intérieure diminue) et [OK].*/
  function dimVal(key) {
    var sp = document.querySelector('span[data-cp-a11y="dim"][data-cp-key="' + key + '"]'), m = sp && sp.textContent.match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }
  function l1NoteOff() { var n = document.getElementById('cp-l1-note'); if (n && n.parentNode) n.parentNode.removeChild(n); }
  document.addEventListener('click', function (e) {             /* une longueur retouchée : le message n'est plus juste */
    if (e.target && e.target.closest && e.target.closest('#dim-normal-apply')) l1NoteOff();
  });
  function l1Check(sess) {
    var A = getApp(); if (!A || !A.S || sess.L1 == null || sess.key === 'L1') return;
    var now = dimVal('L1'); if (now == null || now === sess.L1) return;
    var host = document.getElementById('cp-stage-extras'), was = sess.L1;
    var txt = 'La longueur hors tout L1 passe de ' + fmtMm(was) + ' à ' + fmtMm(now) + ' mm.';
    if (!host) { try { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(txt, 'info', 9000); } catch (e) {} return; }
    l1NoteOff();
    var n = document.createElement('div'); n.id = 'cp-l1-note'; n.setAttribute('role', 'status');
    n.style.cssText = 'display:flex;flex-wrap:wrap;align-items:center;gap:8px 12px;padding:10px 12px;border-radius:8px;background:#f1ece2;color:#0d3527;font-size:14px;line-height:1.4';
    var b = 'min-height:40px;padding:6px 14px;border-radius:6px;font:inherit;font-weight:600;cursor:pointer;border:1.5px solid #0d3527;';
    n.innerHTML = '<p style="margin:0;flex:1 1 220px"></p><span style="display:flex;gap:8px;flex-wrap:wrap">' +
      '<button type="button" data-a="keep" style="' + b + 'background:#fff;color:#0d3527"></button>' +
      '<button type="button" data-a="ok" style="' + b + 'background:#0d3527;color:#fff"></button></span>';
    n.firstChild.textContent = txt;
    n.querySelector('[data-a="keep"]').textContent = 'Garder ' + fmtMm(was) + ' mm';
    n.querySelector('[data-a="ok"]').textContent = 'Passer à ' + fmtMm(now) + ' mm';   /*  [OK] ne disait pas ce qu'il faisait*/
    n.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('button[data-a]'); if (!a) return;
      if (a.getAttribute('data-a') === 'keep') {
        var B = getApp(), c = dimCommits.L1; if (!B || !c) { l1NoteOff(); return; }
        if (B.S.layout === 'g-shape' && gOpenWith(B, c, was) === false) {   /*  garder L1 refermerait le G*/
          n.firstChild.textContent = 'Impossible de garder ' + fmtMm(was) + ' mm : le retour toucherait le montant d\'en face. La longueur hors tout reste à ' + fmtMm(now) + ' mm.';
          a.remove(); return;
        }
        l1NoteOff(); c.call(B, was);
      } else l1NoteOff();
    });
    host.insertBefore(n, host.firstChild);
    if (host.hidden) host.hidden = false;
  }
  /*  depthMode et depthSelectedId sont uniques pour tout le plan ; une profondeur sur mesure
     choisie pour un retour (P2 en L) les laissait à « custom » après le retour en « Droit », avec P = 600 (standard).
     En plan droit, fenêtre fermée, ils suivent P d'après la règle du produit.*/
  function syncDepthMode(A) {
    if (!A || !A.S || A.S.layout !== 'linear' || depthSess) return;
    var T = depthTable(A); if (!T) return;
    var p = num(A.S.P), s = T.std.filter(function (o) { return num(o.depth_mm) === p; })[0];
    var c = s ? null : T.cst.filter(function (o) { return p >= num(o.min_mm) && p <= num(o.max_mm); })[0];
    var mode = s ? 'standard' : (c ? 'custom' : null), id = s ? s.id : (c ? c.id : null);
    if (mode && (A.S.depthMode !== mode || A.S.depthSelectedId !== id)) { A.S.depthMode = mode; A.S.depthSelectedId = id; }
  }
  /*  panneau vendu jusqu'à
     2 770 ou 3 000 × 1 200 mm selon le décor. Règle : le fil suit L ; bois (veine horizontale renseignée) L ≤ l
     et P ≤ h ; iso, grand côté ≤ l et petit côté ≤ h. La règle du mélaminé bornant P à 1 200, cela revient à L ≤ l.*/
  function dmaxCheck(A, L, P) {
    if (!A || !A.S || A.S.layout !== 'linear' || hauteurVar(A)) return null;   /* lot R : la longueur est ramenée, pas refusée */
    /* CP_DMAX : clé = titre de la variante (cp-decor-data) ; le message nomme le décor (option1 : « Albâtre », pas
       « Albâtre / 20 mm / 60/63 cm ») */
    var v = A.getSelectedShopifyVariant ? A.getSelectedShopifyVariant() : null, key = v && v.title, name = v && (v.option1 || v.title);
    var dm = key && window.CP_DMAX && window.CP_DMAX[key]; if (!dm || !(num(dm.l) > 0)) return null;
    var l = num(dm.l), h = num(dm.h) || 1200, bois = dm.h_max_veine_horizontale != null;
    var ih = typeof window.CP_ilotDim === 'function' ? num(window.CP_ilotDim(A, P)) : 0; if (ih) h = Math.max(h, ih);   /* îlot en pierre : dalle plus profonde */
    var ok = bois ? (L <= l && P <= h) : (Math.max(L, P) <= l && Math.min(L, P) <= h);
    var lim = 'jusqu\'à ' + fmtMm(l) + ' × ' + fmtMm(h) + ' mm';
    /* L2 (lot « messages 1 ») : la longueur demandée et ce qu'il faut changer ; sans point : la garde panier en ajoute un */
    return { ok: ok, name: name, lim: lim, msg: 'Le décor « ' + name + ' » se fabrique ' + lim + ' : ' + fmtMm(l) + ' mm de long au plus (ici ' + fmtMm(L) + ' mm). Réduisez la longueur' };
  }
  window.addEventListener('click', function (e) {                /* fenêtre de la longueur (plan droit / panneau) */
    if (!e.target || !e.target.closest || !e.target.closest('#dim-normal-apply')) return;
    var A = getApp(), inp = document.getElementById('dim-normal-input'); if (!A || !A.S || !inp) return;
    var v = parseInt(inp.value, 10); if (!isFinite(v)) return;
    var r = dmaxCheck(A, v, num(A.S.P)); if (!r || r.ok) return;
    e.preventDefault(); e.stopPropagation();
    dimErr(r.msg + '.');
    try { inp.focus({ preventScroll: true }); inp.select(); } catch (err) {}
  }, true);
  /* lot R : fenêtre de la longueur d'une rehausse (COMMERCIAL § 3, Tour 117 R3) : « Longueur (mm) : », aide « Longueur :
     jusqu'à {max} mm pour ce décor. » ; une saisie au-delà du maximum du décor est ramenée à ce maximum, avec le message */
  function fenetreLongueurR(A) {
    var inp = document.getElementById('dim-normal-input'); if (!inp || !A || !hauteurVar(A)) return;
    var mx = maxDecor(A), grp = inp.closest('.input-group'), lab = grp && grp.querySelector('label');
    if (lab && lab.textContent !== 'Longueur (mm) :') lab.textContent = 'Longueur (mm) :';
    if (!(mx > 0)) return;
    if (inp.max !== String(mx)) inp.max = String(mx);
    var ai = document.getElementById('cp-long-aide');
    if (!ai && grp && grp.parentNode) { ai = document.createElement('p'); ai.id = 'cp-long-aide'; ai.style.cssText = 'margin:6px 0 0;font-size:13px;line-height:1.4;color:#374151'; grp.parentNode.insertBefore(ai, grp.nextSibling); }
    var ta = 'Longueur : jusqu\'à ' + fmtMm(mx) + ' mm pour ce décor.';
    if (ai && ai.textContent !== ta) ai.textContent = ta;
    var tt = document.getElementById('edge-popup-title');
    if (tt) { var t2 = tt.textContent.replace(/à [\d\s  .]+ mm/, 'à ' + fmtMm(mx) + ' mm'); if (t2 !== tt.textContent) tt.textContent = t2; }   /* titre du moteur : la borne du décor */
  }
  document.addEventListener('click', function (e) {             /* à l'ouverture, après le moteur et cp-a11y */
    if (!e.target || !e.target.closest || !e.target.closest('.dim .label span')) return;
    setTimeout(function () { try { fenetreLongueurR(getApp()); } catch (err) {} }, 0);
  });
  window.addEventListener('click', function (e) {                /* « Appliquer » : au-delà du maximum du décor, ramenée */
    if (!e.target || !e.target.closest || !e.target.closest('#dim-normal-apply')) return;
    var A = getApp(), inp = document.getElementById('dim-normal-input'); if (!A || !A.S || !inp || !hauteurVar(A)) return;
    var v = parseInt(inp.value, 10), mx = maxDecor(A); if (!isFinite(v) || !(mx > 0) || v <= mx) return;
    inp.value = String(mx);
    setTimeout(function () { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msgRamenee(mx), 'info', 7000); }, 0);
  }, true);
  /* décor changé alors que la longueur est déjà trop grande pour lui : message DANS la page, au-dessus d'« Ajouter au
     panier », tant que
     l'écart dure ; revu à chaque changement de décor et à chaque calcul du prix*/
  function dmaxNote(A) {
    var r = dmaxCheck(A, num(A.S.L), num(A.S.P)), n = document.getElementById('cp-dmax-note'), add = document.getElementById('btn-add-cart');
    if (!r || r.ok) { if (n && n.parentNode) n.parentNode.removeChild(n); return; }
    if (!add || !add.parentNode) return;
    if (!n) {
      n = document.createElement('p'); n.id = 'cp-dmax-note'; n.setAttribute('role', 'alert');
      n.style.cssText = 'margin:0 0 8px;padding:8px 12px;border-radius:8px;background:#fdecea;color:#b42318;font-size:14px;line-height:1.4';
      add.parentNode.insertBefore(n, add);
    }
    var t = r.msg + (dmaxOther(A, r.name) ? ' ou choisissez un autre décor.' : '.');   /* la consigne est déjà dans le message (L2) */
    if (n.textContent !== t) n.textContent = t;
  }
  /* « choisissez un autre décor » seulement si un autre décor proposé va assez loin (Dekton : 3 160 mm pour tous ; gris
     clair du mélaminé, 3 000 mm = le maximum du produit) ; décors fermés (CP_AVAIL) exclus */
  function dmaxOther(A, name) {
    var t = window.CP_DMAX || {}, av = window.CP_AVAIL || {}, L = num(A.S.L), P = num(A.S.P);
    return Object.keys(t).some(function (k) {
      var d = k.split(' / ')[0], dm = t[k]; if (d === name || av[d] === false || !dm) return false;
      var l = num(dm.l), h = num(dm.h) || 1200;
      return dm.h_max_veine_horizontale != null ? (L <= l && P <= h) : (Math.max(L, P) <= l && Math.min(L, P) <= h);
    });
  }
  function dmaxWatch(A) {
    var bv = document.getElementById('bar-value-variant'); if (!bv || typeof MutationObserver !== 'function') return;
    new MutationObserver(function () { try { dmaxNote(A); } catch (err) {} }).observe(bv, { childList: true, characterData: true, subtree: true });
  }
  /*  la page défilait derrière la fenêtre des cotes (position fixe) : molette et glissé bloqués
     HORS de la fenêtre tant qu'elle est ouverte ; dans la fenêtre, une zone qui défile garde son défilement, sans le
     passer à la page (overscroll-behavior). Pas d'overflow:hidden sur la page : sa barre de défilement disparaîtrait
     et la mise en page bougerait sous la fenêtre.*/
  function dimsOpen() { var p = document.getElementById('edge-dims-popup'); return !!(p && !p.classList.contains('hidden') && p.getClientRects().length); }
  function noPageScroll(e) {
    if (!dimsOpen()) return;
    var p = document.getElementById('edge-dims-popup');
    for (var el = e.target; el && el.nodeType === 1; el = el.parentElement) {
      if (el.scrollHeight > el.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(el).overflowY) && p.contains(el)) return;
      if (el === p) break;
    }
    if (e.cancelable) e.preventDefault();
  }
  window.addEventListener('wheel', noPageScroll, { passive: false });
  window.addEventListener('touchmove', noPageScroll, { passive: false });
  /* ✕ « Fermer » de la fenêtre des cotes (#edge-dims-popup : profondeur, hauteur, longueurs, usinages), 44 px au
     toucher : même effet qu'Échap (fermeture du moteur ; pour la profondeur, état d'avant l'ouverture) */
  function dimsClose() {
    var pop = document.getElementById('edge-dims-popup'); if (!pop || pop.querySelector('.cp-dp-x')) return;
    if (!document.getElementById('cp-dp-x-css')) {
      var st = document.createElement('style'); st.id = 'cp-dp-x-css';
      /* !important : configurator-custom.css donne à TOUT bouton de la fenêtre la forme du bouton « Valider » (largeur
         var(--act-w) !important, min-width, marges, dégradé doré !important, capitales) ; id doublé : la règle de cp-style
         « html:root .edge-dims-popup button:not(.depth-btn):not(.ni-step):not(#edge-delete) » (fond vert !important) pèse (1,4,2) */
      st.textContent = 'html:root #edge-dims-popup#edge-dims-popup button.cp-dp-x{position:absolute!important;top:4px!important;right:4px!important;left:auto!important;width:36px!important;min-width:0!important;max-width:none!important;' +
        'height:36px!important;display:flex;align-items:center;justify-content:center;border:0!important;border-radius:6px!important;background:transparent!important;' +
        'color:#0d3527!important;font-size:18px!important;letter-spacing:0!important;text-transform:none!important;line-height:1;cursor:pointer;z-index:2;padding:0!important;margin:0!important;' +
        'box-shadow:none!important;transform:none!important}' +
        'html:root #edge-dims-popup#edge-dims-popup button.cp-dp-x:hover{background:rgba(0,0,0,.06)!important}html:root #edge-dims-popup#edge-dims-popup button.cp-dp-x:focus-visible{outline:2px solid #80602f;outline-offset:-2px}' +
        '#edge-dims-popup #edge-popup-title{padding-right:40px}#edge-dims-popup,#edge-dims-popup *{overscroll-behavior:contain}' +    
        '@media (max-width:768px),(pointer:coarse){html:root #edge-dims-popup#edge-dims-popup button.cp-dp-x{width:44px!important;height:44px!important;top:4px!important;right:4px!important}#edge-dims-popup #edge-popup-title{padding-right:48px}}';
      document.head.appendChild(st);
    }
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'cp-dp-x'; x.setAttribute('aria-label', 'Fermer'); x.innerHTML = '<span aria-hidden="true">✕</span>';
    x.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var B = getApp(); if (B && typeof B.closeEdgePopup === 'function') B.closeEdgePopup(); else pop.classList.add('hidden');
    });
    pop.insertBefore(x, pop.firstChild);
  }
  var unitTries = 0, unitTimer = setInterval(function () {
    var A = getApp();
    if (A && typeof A.updateTdOptionsList === 'function' && typeof A.showDepthSelector === 'function') {
      clearInterval(unitTimer);
      if (A.__cpUnitWrapped) return;
      A.__cpUnitWrapped = true;
      /* « Chants décochés au départ » (règle retenue : pierre, HPL) : au premier rendu où la règle est connue, l'état
         initial des chants du moteur (avant + bout gauche cochés) est vidé ; resolveBanding recoche les chants verrouillés
         par la règle. Le client coche lui-même un chant payant. Règles sans la case : inchangées. */
      /* « Profondeur de départ » de la règle retenue : à l'ouverture (premier rendu où la règle est connue) et après chaque
         changement de forme, toutes les profondeurs du plan la prennent ; 0 : celle du configurateur */
      var profDepart = function (B) {
        var rg = regleRetenue(B), pd = rg ? num(rg.profDepartMm) : 0; if (!(pd > 0)) return;
        ['P', 'P1', 'P2', 'Pl', 'Pc', 'Pr', 'Pgtop', 'Pgleft', 'Pgright', 'Pgreturn'].forEach(function (k) { B.S[k] = pd; });
      };
      var oReset = A.resetDimensionsForLayout;
      if (typeof oReset === 'function') A.resetDimensionsForLayout = function () { var r = oReset.apply(this, arguments); profDepart(this); return r; };
      var oRe = A.render;
      if (typeof oRe === 'function') A.render = function () {
        if (!this.__cpProfDepart && this._eff) { this.__cpProfDepart = true; profDepart(this); }
        if (!this.__cpEdgeOptin && this._eff) {
          this.__cpEdgeOptin = true;
          var rgo = regleRetenue(this);
          if (rgo && rgo.chantsOptin === true) { this.S.edgeBanding = {}; this.S.edgeBandingByEdge = {}; }
        }
        return oRe.apply(this, arguments);
      };
      var oOpts = A.updateTdOptionsList;
      A.updateTdOptionsList = function () {
        /* épaisseur portée par les variantes (HPL, pierre) : le moteur ne compte pas son supplément d'épaisseur global */
        var C = window.CONFIGURATOR_CONFIG || {}, t0 = C.thicknessOptions, r;
        if (Array.isArray(t0) && thkByVariant(this)) C.thicknessOptions = t0.map(function (o) { var c = {}; for (var k in o) c[k] = o[k]; c.extraPrice = 0; return c; });
        try { r = oOpts.apply(this, arguments); } finally { C.thicknessOptions = t0; }
        try { syncDepthMode(this); surfaceThk(this); minThk(this); rewriteOptions(); capOptions(this); backP80Options(this); dmaxNote(this); } catch (e) { console.warn('[cp-plan]', e); } return r;
      };
      var oDepth = A.showDepthSelector;
      A.showDepthSelector = function (cur, onCommit) {
        /*  état à l'ouverture, remis si la fenêtre se ferme sans validation*/
        var S = this.S || {}, sess = { P: S.P, mode: S.depthMode, id: S.depthSelectedId, done: false, L1: dimVal('L1'), key: lastDimKey },
          args = Array.prototype.slice.call(arguments);
        l1NoteOff();                                        /*  message d'une validation précédente*/
        if (typeof onCommit === 'function') args[1] = function () {
          sess.done = true;
          var r = onCommit.apply(this, arguments), B = getApp();
          /*  « Valider » écrit aussi S.P (profondeur du plan droit) quand la cote est un retour
             (P1, P2, Pl, Pgleft…) : hors plan droit, S.P reprend sa valeur d'avant*/
          if (B && B.S && B.S.layout !== 'linear') B.S.P = sess.P;
          setTimeout(function () { try { l1Check(sess); } catch (e) { console.warn('[cp-plan]', e); } }, 80);   /* après le rendu*/
          return r;
        };
        var r = oDepth.apply(this, args);
        depthSess = sess;
        try { rewriteDepth(); refusProf(this); } catch (e) { console.warn('[cp-plan]', e); }   /* R180 : profondeurs grisées */
        return r;
      };
      dimsClose();
      dmaxWatch(A);                                            
      if (typeof A.addDim === 'function') {                 /*  fonction de chaque cote nommée (L1…), relevée au dessin*/
        var oAdd = A.addDim;
        A.addDim = function () {
          /* nom de la cote : option label (G) ou début du texte « L1 : 3000 » (U, qui n'a pas d'option label) */
          var o = arguments[4], m = o && !o.label && typeof o.txt === 'string' && o.txt.match(/^\s*([LP]\d)\s*:/), key = o && (o.label || (m && m[1]));
          if (key && typeof o.onCommit === 'function') dimCommits[key] = o.onCommit;
          /* lot R (A-361) : la hauteur d'une rehausse est dite, pas saisie : cote calculée du moteur (texte gris, comme
             « 2400 »), « Hauteur : 50 mm », sans ligne fléchée (.track-std est en display:block!important : retirée), sans le
             cadre orange de .label et sans survol (rien ne s'ouvre). Avant, une pastille orange « P1 : 50 » inerte au toucher */
          if (o && typeof o.txt === 'string' && /^\s*P\d?\s*:/.test(o.txt) && hauteurVar(A) && A.S && A.S.layout === 'linear') {
            var args = Array.prototype.slice.call(arguments);
            args[4] = Object.assign({}, o, { editable: false, calculated: true, txt: 'Hauteur : ' + fmtMm(num(A.S.P)) + ' mm' });
            var b = oAdd.apply(this, args), tr = b && b.querySelector ? b.querySelector('.track-std') : null, lb = b && b.querySelector ? b.querySelector('.label') : null;
            if (tr && tr.parentNode) tr.parentNode.removeChild(tr);
            if (lb) { lb.style.border = '0'; lb.style.pointerEvents = 'none'; }
            return b;
          }
          /* A-364 (AUDIT, R97) : sur une crédence, la cote P se lit « H1 : 600 » (la hauteur), comme sa fenêtre « Choisir la
             hauteur » et son nom accessible ; la clé reste P1 (cp-a11y et cp-forme lisent « H » comme « P » ; cp-pierre-angle
             ne se charge pas sur une crédence). Les plans gardent « P1 » */
          if (o && typeof o.txt === 'string' && /^\s*P\d?\s*:/.test(o.txt) && estCredence(A)) {
            var argsH = Array.prototype.slice.call(arguments);
            argsH[4] = Object.assign({}, o, { txt: o.txt.replace(/^(\s*)P(\d?\s*:)/, '$1H$2') });
            return oAdd.apply(this, argsH);
          }
          return oAdd.apply(this, arguments);
        };
      }
      if (typeof A.closeEdgePopup === 'function') {
        var oClose = A.closeEdgePopup;
        A.closeEdgePopup = function () {
          var s = depthSess; depthSess = null;
          if (s && !s.done && this.S) { this.S.P = s.P; this.S.depthMode = s.mode; this.S.depthSelectedId = s.id; }
          return oClose.apply(this, arguments);
        };
      }
      rewriteOptions();
      /*  fenêtre de profondeur « simple » du moteur (configurator-main l. 2487-2535 : produit sans
         règle de profondeur, c'est-à-dire mélaminé et placage, vendus au m²). Elle affichait « +49 €/m » d'après les
         profondeurs de TOUTES les collections (celles du plan), alors qu'aucun supplément n'est facturé (2 400 × 300 :
         0,72 m² × 139 = 100,08 €). L'étiquette ment : elle est retirée dès que la fenêtre est construite.*/
      var epc = document.getElementById('edge-popup-content');
      if (epc && typeof MutationObserver === 'function') new MutationObserver(function () {
        if (!epc.querySelector('#depth-normal-input')) return;
        Array.prototype.forEach.call(epc.querySelectorAll('.em-price'), function (p) { p.remove(); });
      }).observe(epc, { childList: true });
    } else if (++unitTries > 400) clearInterval(unitTimer);
  }, 50);

  /*  récapitulatif, « TOTAL HORS CONFIG » (custom-configV2 l. 952, moteur) → « Prix de base ».
     ma part : la ligne « Finition » ne montrait qu'une vignette (updateTdFinition, moteur, refait
     la case à chaque changement). Le nom de la finition est ajouté à côté (variantsMeta, le même que la propriété
     « Finition » de la commande), et sert de texte de remplacement à la vignette.*/
  function recapNames() {
    var base = document.querySelector('.recap-item-base .recap-label');
    if (base && base.textContent.trim() !== 'Prix de base') base.textContent = 'Prix de base';
    var td = document.getElementById('td-finition'), A = getApp();
    if (!td || !A || !A.S) return;
    var meta = A.variantsMeta && A.variantsMeta[A.S.variant], name = meta && meta.name;
    var wrap = td.querySelector('.finition-wrap'); if (!wrap || !name) return;
    var span = wrap.querySelector('.finition-name');
    if (!span) { span = document.createElement('span'); span.className = 'finition-name'; wrap.appendChild(span); }
    if (span.textContent !== name) span.textContent = name;
    var img = wrap.querySelector('img'); if (img && img.alt !== '') img.alt = '';   /* le nom est écrit : vignette décorative */
  }
  function recapWatch() {
    var td = document.getElementById('td-finition'); if (!td) return false;
    var st = document.createElement('style'); st.id = 'cp-finition-css';
    st.textContent = '#td-finition .finition-wrap{display:inline-flex;align-items:center;gap:8px;justify-content:flex-end}' +
      '#td-finition .finition-name{font-weight:600;text-align:right;overflow-wrap:anywhere}';
    document.head.appendChild(st);
    new MutationObserver(function () { recapNames(); }).observe(td, { childList: true, subtree: true });
    recapNames();
    return true;
  }
  var rnTries = 0, rnTimer = setInterval(function () {
    if (recapWatch() || ++rnTries > 200) clearInterval(rnTimer);
  }, 100);

  var pbTries = 0, pbTimer = setInterval(function () {
    if (document.getElementById('td-prix-total') && document.querySelector('.config-main')) { clearInterval(pbTimer); priceBar(); }
    else if (++pbTries > 200) clearInterval(pbTimer);
  }, 100);

  /*  au téléphone, la fenêtre « Finition » (#popup-variant ; configurator-custom.css : grille
     .variants limitée à 320 px, dans une fenêtre à 80vh qui défile aussi) ne montrait que 6 décors sur 26, en
     3 rangées entières, sans signe qu'on peut défiler (barre en surimpression, invisible au repos).
     Fenêtre jusqu'à 85 % de la hauteur d'écran ; une seule zone qui défile, la grille.
     Quand tout ne tient pas, la hauteur de la grille coupe toujours la rangée du bas (30 à 60 % visible).
     Nombre de décors dans le titre (« Finition 26 décors »).
     Barre de défilement toujours visible : si le navigateur n'en dessine pas (largeur 0 : téléphones), une piste
       fine suit le défilement. Pas de fondu.*/
  function finitionPopup() {
    var P = document.getElementById('popup-variant'), V = document.getElementById('variants-container');
    if (!P || !V) return false;
    if (P.__cpVpop) return true;
    P.__cpVpop = true;
    var st = document.createElement('style'); st.id = 'cp-vpop-css';
    st.textContent = '#popup-variant.is-open{display:flex;flex-direction:column;max-height:85vh;max-height:85dvh;overflow:hidden}' +
      '#popup-variant > .config-popup-header{flex:0 0 auto}' +
      '#popup-variant > .variants{position:relative;flex:0 1 auto;min-height:0;max-height:none;overflow-y:auto;overscroll-behavior:contain}' +
      '#popup-variant .cp-vcount{margin-left:.75em;font-size:13px;font-weight:600;letter-spacing:0;text-transform:none;color:#4b5563}' +
      '#popup-variant .cp-vscroll{position:absolute;right:5px;width:4px;border-radius:2px;background:#e5e7eb;pointer-events:none}' +
      '#popup-variant .cp-vscroll[hidden]{display:none}' +
      '#popup-variant .cp-vscroll > i{position:absolute;left:0;right:0;border-radius:2px;background:#0d3527;opacity:.6}';
    document.head.appendChild(st);
    var title = P.querySelector('.config-popup-title'), count = document.createElement('span');
    count.className = 'cp-vcount';
    if (title) title.appendChild(count);
    var track = document.createElement('div'); track.className = 'cp-vscroll'; track.setAttribute('aria-hidden', 'true'); track.hidden = true;
    var thumb = document.createElement('i'); track.appendChild(thumb); P.appendChild(track);
    var bar = function () {
      var ch = V.clientHeight, sh = V.scrollHeight;
      track.hidden = !(P.classList.contains('is-open') && sh > ch + 1 && V.offsetWidth - V.clientWidth === 0);
      if (track.hidden) return;
      var th = Math.max(24, Math.round(ch * ch / sh));
      track.style.top = V.offsetTop + 'px'; track.style.height = ch + 'px';
      thumb.style.height = th + 'px'; thumb.style.top = Math.round(V.scrollTop / Math.max(1, sh - ch) * (ch - th)) + 'px';
    };
    var fit = function () {
      /*  le nombre suit les cartes AFFICHÉES*/
      var cards = Array.prototype.filter.call(V.querySelectorAll('.variant-opt'), function (c) { return c.style.display !== 'none'; }), n = cards.length;
      var txt = n > 1 ? n + ' décors' : '';
      if (count.textContent !== txt) count.textContent = txt;
      if (!P.classList.contains('is-open')) { track.hidden = true; return; }
      V.style.maxHeight = '';
      var avail = V.clientHeight;
      if (n > 1 && V.scrollHeight > avail + 1) {
        var top0 = cards[0].offsetTop, cardH = cards[0].offsetHeight, step = 0;
        for (var i = 1; i < n; i++) if (cards[i].offsetTop > top0 + 1) { step = cards[i].offsetTop - top0; break; }
        if (step > 0 && cardH > 0) {
          var k = Math.max(1, Math.floor((avail - top0 - 0.3 * cardH) / step));
          var f = Math.min(0.6, Math.max(0.3, (avail - top0 - k * step) / cardH));
          V.style.maxHeight = Math.round(top0 + k * step + f * cardH) + 'px';
        }
      }
      bar();
    };
    var queued = false, later = function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fit(); }); };
    new MutationObserver(later).observe(P, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(later).observe(V, { childList: true });
    V.addEventListener('load', later, true);                                   /* vignettes chargées : hauteur des cartes */
    V.addEventListener('scroll', bar, { passive: true });
    window.addEventListener('resize', later);
    fit();
    return true;
  }
  var vpTries = 0, vpTimer = setInterval(function () {
    if (finitionPopup() || ++vpTries > 200) clearInterval(vpTimer);
  }, 100);

  /*  la fenêtre « Épaisseur » proposait 20 / 40 / 60 mm sans prix ; l'effet sur le total se
     découvrait après coup. Sous chaque épaisseur, l'écart avec le choix actuel, par la règle du moteur
     (updateTdOptionsList, configurator-main l. 924-931 : supplément de l'option en €/m × longueur totale ;
     le prix au cm et les jambages ne dépendent pas de l'épaisseur). Recalculé à chaque ouverture.*/
  function thkCents(A, mm) {
    if (thkByVariant(A)) {
      /* épaisseur portée par les variantes : l'écart est celui du prix de base (prix au cm de la variante × cm facturés) */
      var t1 = A.S.thk, v = null; A.S.thk = Number(mm);
      try { v = exactVariant(A); } finally { A.S.thk = t1; }
      var q = typeof A.getBilledQtyCm === 'function' ? num(A.getBilledQtyCm(v)) : 0;
      return v ? Math.round(num(v.price) * q) : 0;
    }
    var o = ((window.CONFIGURATOR_CONFIG || {}).thicknessOptions || []).filter(function (x) { return Number(x.mm) === Number(mm); })[0];
    var e = Number(o && o.extraPrice || 0), len = typeof A.getTotalLengthMm === 'function' ? Number(A.getTotalLengthMm()) || 0 : 0;
    if (e > 0 && sellsBySurface(A)) return Math.round(e * (A.getBilledQtyCm() / 100) * 100);   /*  €/m² × m² facturés*/
    len = Math.max(len, minMl(A));                                     /*  longueur facturée (minimum)*/
    /*  le supplément de profondeur dépend de l'épaisseur (800 : +120 en 20 mm, +150 en 60 mm) ; l'écart affiché
       sous chaque épaisseur le compte aussi, sinon il ne serait plus « le vrai changement du total »*/
    var dep = 0;
    if (DEPTH_KEYS[A.S.layout] && depthAllowed(A) && typeof A.calculateDepthSupplements === 'function') {
      var t0 = A.S.thk; A.S.thk = mm;
      try { dep = num((A.calculateDepthSupplements() || {}).total); } catch (err) { dep = 0; } finally { A.S.thk = t0; }
    }
    return (e > 0 ? Math.round(e * (len / 1000) * 100) : 0) + dep;
  }
  /* R180 (AUDIT Tour 1143, UX) : l'écart sous chaque épaisseur est l'écart réel du total, calculé comme A-304 (cp-annonces,
     CP_simule : l'épaisseur posée, tout le rendu refait, le total lu, l'état remis). Il compte donc ce que l'épaisseur ajoute
     d'office (en 18 cm, les chants des 2 côtés). Calculé après le rendu, fenêtre « Épaisseur » ouverte, et gardé tant que
     l'état ne change pas ; sinon thkCents (le prix de base seul). Les épaisseurs indisponibles ou refusées ne sont pas posées. */
  var thkMemo = null, thkCalc = false, thkMinut = null;
  function sigEtat(A) { try { return JSON.stringify(A.S); } catch (e) { return String(Date.now()); } }
  function thkOuvert() { var P = document.getElementById('popup-thickness'); return !!P && P.classList.contains('is-open'); }
  function thkLibre(host, i) { var lb = host.querySelector('label[for="' + i.id + '"]'); return !!lb && !lb.classList.contains('cp-thk-na') && !i.hasAttribute('data-cp-r180'); }
  /* bulle du passage à une épaisseur : la forme générée d'A-304 (cp-annonces, texteAjout ; AUDIT et COMMERCIAL Tour 224), sans
     la phrase du prix de base, qui est le choix lui-même : « Ce choix ajoute aussi : chant du côté gauche : +69,00 € ; … Écart
     sur le total : +978,00 €. » ; rien d'ajouté d'office : pas de bulle */
  function texteEp(d) {
    var plus = ((d && d.plus) || []).filter(function (p) { return !/^Épaisseur\b/i.test(p.nom); });   /* la ligne de l'épaisseur choisie (stratifié : « Épaisseur 40 mm ») est le choix lui-même, comme la ligne du coin en A-304 */
    if (!plus.length || typeof window.CP_texteAjout !== 'function') return '';
    return window.CP_texteAjout(Object.assign({}, d, { base: 0, plus: plus }), null, null);
  }
  /* l'épaisseur posée comme le clic la pose (S.thk, puis le rendu de CP_simule), avec un rendu de plus : un côté que le client
     avait fini (cpBouts, cp-pierre-angle) ne revient qu'au 2e rendu, comme après le vrai clic (12 → 18 cm → 12, côté gauche coché :
     −939 €, et non −978 €) */
  function thkPose(mm) { return function (B) { B.S.thk = mm; B.render(); }; }
  function thkReel() {
    var A = getApp(), host = document.getElementById('thk-container');
    if (!A || !A.S || !host || thkCalc || typeof window.CP_simule !== 'function' || typeof window.CP_ecart !== 'function') return;
    var mms = Array.prototype.filter.call(host.querySelectorAll('input[name="thk"]'), function (i) { return !i.checked && thkLibre(host, i); }).map(function (i) { return num(i.value); });
    var r = null; thkCalc = true;
    try { r = window.CP_simule(A, mms.map(function (mm) { return thkPose(mm); })); } catch (e) { console.warn('[cp-plan]', e); } finally { thkCalc = false; }
    if (!r || !r.avant) return;
    var ec = {}; mms.forEach(function (mm, j) { if (r.apres[j]) { var d = window.CP_ecart(r.avant, r.apres[j]); ec[mm] = { c: d.total, texte: texteEp(d) }; } });
    thkMemo = { sig: sigEtat(A), ec: ec };
    thkDeltas();
  }
  function thkDeltas() {
    var A = getApp(), host = document.getElementById('thk-container');
    if (!A || !A.S || !host || thkCalc || (window.CP_enSimulation && window.CP_enSimulation())) return;
    var memo = thkMemo && thkMemo.sig === sigEtat(A) ? thkMemo.ec : null;
    if (!memo && thkOuvert() && typeof window.CP_simule === 'function') { clearTimeout(thkMinut); thkMinut = setTimeout(thkReel, 0); }
    var cur = thkCents(A, A.S.thk);
    Array.prototype.forEach.call(host.querySelectorAll('input[name="thk"]'), function (i) {
      var lb = host.querySelector('label[for="' + i.id + '"]'); if (!lb) return;
      var m = memo && memo[num(i.value)], d = m ? m.c : thkCents(A, i.value) - cur, sp = lb.querySelector('.cp-thk-delta');
      /*  épaisseur absente du décor (cp-gamme), ou refusée (R180, refus180). A-422 : le refus se lit aussi sur l'input ; au rendu
         qui suit la simulation (1re ouverture), cp-gamme retire le grisé du libellé et rappelle ce calcul avant que refus180 le
         repose : l'écart s'écrivait sur le choix refusé (« 18 CM +1 260,00 € » en L) */
      var na = lb.classList.contains('cp-thk-na') || i.hasAttribute('data-cp-r180');
      var txt = na ? 'indisponible' : i.checked ? 'choix actuel' : d === 0 ? 'même prix' : (d > 0 ? '+' : '−') + eur(Math.abs(d) / 100) + NB + '€';
      if (!sp) { sp = document.createElement('span'); sp.className = 'cp-thk-delta'; lb.appendChild(sp); }
      if (sp.textContent !== txt) sp.textContent = txt;
      /* R180 (AUDIT, WCAG 2.5.3) : le nom commence par le libellé visible du bloc d'épaisseur (« 18 cm, +840,00 € »), pas par sa
         valeur en mm */
      var rf = i.hasAttribute('data-cp-r180') ? refusEp(A, num(i.value)) : null;   /* A-422 : la raison, même si l'input a perdu son nom */
      var nm = na ? ((rf && rf.nom) || i.getAttribute('aria-label') || epLabel(i.value) + ', indisponible') : epLabel(i.value) + ', ' + txt;
      if (lb.getAttribute('aria-label') !== nm) lb.setAttribute('aria-label', nm);
    });
  }
  window.CP_thkDeltas = thkDeltas;                                /*  rappelé par cp-gamme après son passage*/
  function thkWatch() {
    var P = document.getElementById('popup-thickness'), host = document.getElementById('thk-container');
    if (!P || !host) return false;
    var st = document.createElement('style'); st.id = 'cp-thk-css';
    st.textContent = '#thk-container .cp-thk-delta{display:block;margin-top:3px;font-size:12px;font-weight:500;letter-spacing:0;text-transform:none;opacity:.85}';
    document.head.appendChild(st);
    new MutationObserver(function () { if (P.classList.contains('is-open')) thkDeltas(); }).observe(P, { attributes: true, attributeFilter: ['class'] });
    host.addEventListener('change', function () { setTimeout(thkDeltas, 0); });
    /* R180 (AUDIT Tour 1143) : au passage à une épaisseur, la bulle d'A-304 dit ce qu'elle ajoute d'office (avant le moteur :
       l'état est encore celui d'avant ; une épaisseur refusée est arrêtée plus tôt, sur window) */
    host.addEventListener('change', function (e) {
      var A = getApp(), i = e.target; if (!A || !A.S || !i || i.name !== 'thk' || thkCalc) return;
      var mm = num(i.value), m = thkMemo && thkMemo.sig === sigEtat(A) ? thkMemo.ec[mm] : null, t = m ? m.texte : '';
      if (!m && typeof window.CP_simule === 'function' && typeof window.CP_ecart === 'function') {
        thkCalc = true;
        try { var r = window.CP_simule(A, [thkPose(mm)]); if (r && r.avant && r.apres[0]) t = texteEp(window.CP_ecart(r.avant, r.apres[0])); } catch (err) { console.warn('[cp-plan]', err); } finally { thkCalc = false; }
      }
      if (t && window.CFG_UI && window.CFG_UI.toast) setTimeout(function () { window.CFG_UI.toast(t, 'info', 9000); }, 0);
    }, true);
    thkDeltas();
    return true;
  }
  var tkTries = 0, tkTimer = setInterval(function () {
    if (thkWatch() || ++tkTries > 200) clearInterval(tkTimer);
  }, 100);

  /*  « Angle droit » se lisait « angle à 90° », là
     même où l'on règle un angle hors d'équerre, et l'atelier pouvait le lire ainsi dans la commande. Une forme n'a
     qu'un nom, partout : tuiles de la fenêtre « Type de plan », bouton « Forme » de la barre, ligne « Forme » du
     récapitulatif (textes du moteur, custom-configV2 l. 759-803, 1428 et updateTdForme), propriété « Forme » de la
     commande (cp-jonction, par CP_formeName). Valeurs internes du moteur inchangées.*/
  var FORMES = { 'linear': 'Droit', 'angle-right': 'En L, retour à droite', 'angle-left': 'En L, retour à gauche',
    'u-shape': 'En U', 'g-shape-right': 'En G, à droite', 'g-shape-left': 'En G, à gauche' };
  function formeKey(layout, dir) { return (layout === 'angle' || layout === 'g-shape') ? layout + '-' + (dir === 'left' ? 'left' : 'right') : layout; }
  window.CP_formeName = function (S) {
    return S ? (FORMES[formeKey(S.layout || 'linear', S.layout === 'angle' ? S.angleDir : S.gDir)] || '') : '';
  };
  function formeTexts() {
    Array.prototype.forEach.call(document.querySelectorAll('.layout-btn[data-layout]'), function (b) {
      var sp = b.querySelector(':scope > span'), n = FORMES[formeKey(b.dataset.layout, b.dataset.dir)];
      if (sp && n && sp.textContent !== n) sp.textContent = n;
    });
    var A = getApp(), n = A && A.S ? window.CP_formeName(A.S) : '';
    if (!n) return;
    ['#bar-value-layout', '#td-forme .td-forme-text'].forEach(function (sel) {
      var e = document.querySelector(sel); if (e && e.textContent !== n) e.textContent = n;
    });
  }
  function formeWatch() {
    var bar = document.getElementById('bar-value-layout'), td = document.getElementById('td-forme');
    if (!bar || !td || !getApp() || !getApp().S) return false;
    var q = false, later = function () { if (q) return; q = true; setTimeout(function () { q = false; formeTexts(); }, 0); };
    [bar, td].forEach(function (e) { new MutationObserver(later).observe(e, { childList: true, characterData: true, subtree: true }); });
    formeTexts();
    return true;
  }
  var fmTries = 0, fmTimer = setInterval(function () {
    if (formeWatch() || ++fmTries > 200) clearInterval(fmTimer);
  }, 100);
})();
